/**
 * Indonesian is the source dictionary. en.ts must provide every key (enforced by
 * its type), so a missing translation is a build error, not a blank label.
 *
 * Voice (copy/messaging.md): formal, complete sentences, never overstate status.
 * Placeholders use {name} syntax.
 */
export const id = {
  "app.name": "Zerpid",
  "app.tagline": "Satu sistem. Satu alur. Tanpa jeda.",

  "common.save": "Simpan",
  "common.cancel": "Batal",
  "common.continue": "Lanjut",
  "common.skip": "Lewati",
  "common.back": "Kembali",
  "common.close": "Tutup",
  "common.edit": "Ubah",
  "common.add": "Tambah",
  "common.delete": "Hapus",
  "common.retry": "Coba lagi",
  "common.loading": "Memuat…",
  "common.loadMore": "Muat lebih banyak",
  "common.actions": "Aksi",
  "common.status": "Status",
  "common.name": "Nama",
  "common.email": "Email",
  "common.password": "Kata sandi",
  "common.language": "Bahasa",
  "common.never": "Belum pernah",
  "common.comingSoon": "Segera hadir",
  "common.reference": "Kode referensi: {id}",
  "common.optional": "(opsional)",

  "lang.id": "Bahasa Indonesia",
  "lang.en": "English",

  "role.owner": "Owner / admin",
  "role.warehouse_manager": "Manajer gudang",
  "role.warehouse_staff": "Staf gudang",
  "role.finance_cs": "Finance / admin order / CS",

  "plan.trial": "Masa percobaan",
  "plan.free": "Free",
  "plan.growth": "Growth",
  "plan.scale": "Scale",
  "plan.enterprise": "Enterprise",

  "field.required": "Kolom ini wajib diisi.",
  "field.invalid_email": "Masukkan alamat email yang valid.",
  "field.too_short": "Terlalu pendek.",
  "field.too_long": "Terlalu panjang.",
  "field.length": "Panjang tidak sesuai.",
  "field.invalid": "Nilai tidak valid.",
  "field.password_hint": "Minimal 10 karakter.",
  "field.password_mismatch": "Kata sandi tidak sama.",

  "error.generic": "Ada gangguan di sisi kami. Silakan coba lagi.",
  "error.network": "Tidak dapat terhubung ke server. Periksa koneksi Anda.",
  "error.unauthorized": "Sesi Anda berakhir. Silakan masuk kembali.",
  "error.session_expired": "Sesi Anda berakhir. Silakan masuk kembali.",
  "error.forbidden": "Anda tidak memiliki akses ke halaman ini.",
  "error.not_found": "Data tidak ditemukan.",
  "error.rate_limited": "Terlalu banyak percobaan. Tunggu sebentar, lalu coba lagi.",
  "error.validation_failed": "Periksa kembali isian yang ditandai.",
  "error.email_taken": "Email ini sudah terdaftar.",
  "error.invalid_credentials": "Email atau kata sandi salah.",
  "error.email_unverified": "Email Anda belum dikonfirmasi.",
  "error.invalid_token": "Tautan ini tidak valid atau sudah kedaluwarsa.",
  "error.no_workspace": "Buat atau gabung ke perusahaan terlebih dahulu.",
  "error.membership_inactive": "Akses Anda ke perusahaan ini telah dinonaktifkan.",
  "error.already_member": "Orang ini sudah menjadi anggota.",
  "error.last_owner": "Perusahaan harus memiliki minimal satu Owner aktif.",
  "error.cannot_disable_self": "Anda tidak dapat menonaktifkan akses Anda sendiri.",
  "error.warehouse_code_taken": "Kode gudang ini sudah dipakai gudang lain.",
  "error.warehouse_required": "Tambahkan gudang atau lewati langkah ini.",
  "error.default_warehouse_archive": "Gudang utama tidak dapat diarsipkan.",
  "error.onboarding_step_mismatch": "Langkah ini sudah dilewati. Muat ulang halaman.",

  "auth.login.title": "Masuk ke Zerpid",
  "auth.login.submit": "Masuk",
  "auth.login.forgot": "Lupa kata sandi?",
  "auth.login.noAccount": "Belum punya akun?",
  "auth.login.register": "Daftar",
  "auth.login.unverifiedHelp": "Konfirmasi email Anda terlebih dahulu. Kami dapat mengirim ulang tautannya.",
  "auth.login.resend": "Kirim ulang email konfirmasi",
  "auth.login.newEyebrow": "Oktober 2026",
  "auth.login.newTitle": "Yang baru di Zerpid",
  "auth.login.new1": "Lazada kini tersinkron: order, stok, harga, retur, dan label pengiriman dari toko Lazada Anda.",
  "auth.login.new2": "Bantu tulis dengan AI: deskripsi produk ditulis dari editor produk, atau diperbaiki sesuai catatan revisi marketplace.",
  "auth.login.new3": "Blibli siap dipakai: hubungkan toko, terbitkan produk, dan revisi produk yang dikembalikan Blibli.",
  "auth.login.promoTitle": "Belum punya akun?",
  "auth.login.promoBody": "Gabung open beta: gratis, tanpa kartu kredit, dan founding member hemat 30% selama 12 bulan pertama.",
  "auth.login.promoCta": "Daftar Gratis",
  "auth.login.help": "Butuh bantuan? Tulis ke",

  "auth.register.title": "Buat akun Zerpid",
  "auth.register.subtitle": "Gabung open beta Zerpid. Akun siap dalam beberapa menit.",
  "auth.register.perksTitle": "Yang Anda dapat sebagai peserta open beta",
  "auth.register.perk1": "Gratis selama open beta, tanpa kartu kredit.",
  "auth.register.perk2": "Semua modul terbuka di bulan pertama, tanpa batas order.",
  "auth.register.perk3": "Akses pertama ke Zerpid Chat saat rilis: chat pembeli dari semua toko di satu inbox, sedang kami bangun.",
  "auth.register.perk4": "Founding member hemat 30% selama 12 bulan pertama.",
  "auth.register.perk5": "Harga diumumkan sebelum beta berakhir, dan data Anda tetap tersimpan.",
  "auth.register.submit": "Buat akun",
  "auth.register.haveAccount": "Sudah punya akun?",
  "auth.register.login": "Masuk",
  "auth.register.emailTakenAction": "Masuk dengan email ini",

  "auth.verify.pendingTitle": "Cek email Anda",
  "auth.verify.pendingBody": "Kami mengirim tautan konfirmasi ke {email}. Buka tautan itu untuk melanjutkan.",
  "auth.verify.resend": "Kirim ulang",
  "auth.verify.resendIn": "Kirim ulang dalam {seconds} detik",
  "auth.verify.resent": "Jika email tersebut terdaftar dan belum dikonfirmasi, tautan baru sudah dikirim.",
  "auth.verify.checking": "Mengonfirmasi email Anda…",
  "auth.verify.failedTitle": "Tautan tidak dapat dipakai",
  "auth.verify.failedBody": "Tautan konfirmasi tidak valid atau sudah kedaluwarsa. Masuk untuk meminta tautan baru.",

  "auth.forgot.title": "Lupa kata sandi",
  "auth.forgot.body": "Masukkan email akun Anda. Kami akan mengirim tautan untuk mengatur kata sandi baru.",
  "auth.forgot.submit": "Kirim tautan",
  "auth.forgot.sent": "Jika email tersebut terdaftar, tautan untuk mengatur ulang kata sandi sudah dikirim. Tautan berlaku 1 jam.",

  "auth.reset.title": "Atur kata sandi baru",
  "auth.reset.newPassword": "Kata sandi baru",
  "auth.reset.confirm": "Ulangi kata sandi baru",
  "auth.reset.submit": "Simpan kata sandi",
  "auth.reset.done": "Kata sandi berhasil diubah. Semua sesi sebelumnya telah diakhiri. Silakan masuk.",

  "auth.invite.title": "Bergabung ke {workspace}",
  "auth.invite.body": "Anda diundang sebagai {role} dengan email {email}.",
  "auth.invite.existingAccount": "Email ini sudah memiliki akun Zerpid. Masukkan kata sandi akun tersebut untuk bergabung.",
  "auth.invite.newAccount": "Buat kata sandi untuk akun baru Anda.",
  "auth.invite.submit": "Terima undangan",
  "auth.invite.invalidTitle": "Undangan tidak dapat dipakai",
  "auth.invite.invalidBody": "Undangan ini tidak valid, sudah dipakai, dibatalkan, atau kedaluwarsa. Minta Owner perusahaan mengirim undangan baru.",

  "onboarding.title": "Siapkan Zerpid",
  "onboarding.step.company": "Perusahaan",
  "onboarding.step.marketplace": "Marketplace",
  "onboarding.step.warehouse": "Gudang",
  "onboarding.company.title": "Nama perusahaan atau brand",
  "onboarding.company.body": "Nama ini tampil untuk tim Anda dan dapat diubah kapan saja di Pengaturan.",
  "onboarding.company.label": "Nama perusahaan / brand",
  "onboarding.marketplace.title": "Hubungkan marketplace",
  "onboarding.marketplace.body": "Order dan stok dari toko yang terhubung akan masuk ke satu daftar. Anda dapat menghubungkan toko kapan saja dari menu Channel.",
  "onboarding.marketplace.connect": "Hubungkan",
  "onboarding.marketplace.notYet": "Koneksi marketplace sedang kami siapkan. Lewati langkah ini; Anda akan mendapat kabar saat sudah tersedia.",
  "onboarding.warehouse.title": "Tambah gudang",
  "onboarding.warehouse.body": "Gudang tempat stok Anda disimpan. Jika dilewati, kami membuat satu gudang utama yang dapat Anda ubah nanti.",

  "nav.dashboard": "Beranda",
  "nav.orders": "Order",
  "nav.aftersales": "Purna jual",
  "nav.promotions": "Promosi",
  "nav.catalog": "SKU",
  "nav.inventory": "Ringkasan stok",
  "nav.warehouse": "Gudang",
  "nav.warehouse.inbound": "Penerimaan",
  "nav.warehouse.locations": "Lokasi & zona",
  "nav.warehouse.putaway": "Putaway",
  "nav.warehouse.pools": "Pool order",
  "nav.warehouse.waves": "Wave",
  "nav.warehouse.picking": "Picking",
  "nav.warehouse.packing": "Packing",
  "nav.warehouse.outbound": "Serah terima",
  "nav.warehouse.returns": "Terima retur",
  "nav.warehouse.transfers": "Transfer",
  "nav.warehouse.counts": "Hitung stok",
  "nav.warehouse.variance": "Selisih",
  "nav.channels": "Channel",
  "nav.logs": "Log Aktivitas",
  "nav.settings": "Pengaturan",
  "nav.settings.company": "Perusahaan",
  "nav.settings.warehouses": "Gudang",
  "nav.settings.labels": "Label & Resi",
  "nav.settings.users": "User & Role",
  "nav.billing": "Langganan",
  "nav.finance": "Keuangan",
  "nav.analytics": "Analitik",

  "shell.trialBadge": "Percobaan: {days} hari lagi",
  "shell.trialEnded": "Masa percobaan berakhir",
  "shell.switchWorkspace": "Pindah perusahaan",
  "shell.logout": "Keluar",
  "shell.profile": "Profil saya",

  "dashboard.greeting": "Selamat datang, {name}",
  "dashboard.setup.title": "Langkah berikutnya",
  "dashboard.setup.warehouse": "Tambahkan gudang",
  "dashboard.setup.marketplace": "Hubungkan toko marketplace",
  "dashboard.setup.team": "Undang tim Anda",
  "dashboard.card.newOrders": "Order baru",
  "dashboard.card.lowStock": "Stok kritis",
  "dashboard.card.sync": "Status sinkronisasi",
  "dashboard.card.emptyOrders": "Order akan tampil di sini setelah toko marketplace terhubung.",
  "dashboard.card.emptyStock": "Stok akan tampil di sini setelah produk dan gudang terisi.",
  "dashboard.card.emptySync": "Belum ada toko yang terhubung.",

  "coming.title": "{feature} segera hadir",
  "coming.body": "Fitur ini belum tersedia. Menu ini sudah disiapkan agar Anda tahu letaknya.",

  "settings.company.title": "Perusahaan",
  "settings.company.name": "Nama perusahaan / brand",
  "settings.company.locale": "Bahasa bawaan",
  "settings.company.localeHelp": "Dipakai untuk email undangan dan pengguna baru.",
  "settings.company.plan": "Paket",
  "settings.company.trialUntil": "Masa percobaan berakhir {date}. Setelah itu paket otomatis turun ke Free kecuali Anda berlangganan.",
  "settings.company.saved": "Perubahan disimpan.",

  "settings.warehouses.title": "Gudang",
  "settings.labels.title": "Label & Resi",
  "settings.labels.intro": "Atur bentuk label yang dicetak dari menu Order. Label tetap memakai format kurir dari marketplace; Zerpid menambahkan informasi di sekitarnya agar mudah dibaca saat packing.",
  "settings.labels.paper": "Kertas",
  "settings.labels.paper.thermal": "Label thermal 100 × 150 mm",
  "settings.labels.paper.thermalHelp": "Satu label per lembar, untuk printer thermal.",
  "settings.labels.paper.a4": "A4, 4 label per lembar",
  "settings.labels.paper.a4Help": "Untuk printer biasa; potong lembar menjadi empat.",
  "settings.labels.additions": "Tambahan di label",
  "settings.labels.showTracking": "Nomor resi besar + barcode di bagian atas",
  "settings.labels.showTrackingHelp": "Terbaca dari jauh saat packing dan bisa di-scan.",
  "settings.labels.showOrderInfo": "Nomor order, toko, dan kurir",
  "settings.labels.showItems": "Daftar barang di bagian bawah",
  "settings.labels.showItemsHelp": "SKU dan jumlah, maksimal 4 baris. Membantu packer mencocokkan isi paket.",
  "settings.labels.shrinkNote": "Label marketplace diperkecil secara proporsional agar tambahan muat di kertas yang sama. Bila hasilnya tidak sesuai, gunakan Cetak label asli marketplace di detail order.",
  "settings.labels.preview": "Pratinjau tata letak",
  "settings.labels.previewLabel": "Label kurir dari marketplace",
  "settings.labels.saved": "Pengaturan label disimpan.",
  "settings.warehouses.add": "Tambah gudang",
  "settings.warehouses.edit": "Ubah gudang",
  "settings.warehouses.code": "Kode",
  "settings.warehouses.codeHelp": "Huruf kapital, angka, dan tanda hubung. Kosongkan untuk dibuat otomatis.",
  "settings.warehouses.address": "Alamat",
  "settings.warehouses.city": "Kota",
  "settings.warehouses.postalCode": "Kode pos",
  "settings.warehouses.default": "Utama",
  "settings.warehouses.active": "Aktif",
  "settings.warehouses.archived": "Diarsipkan",
  "settings.warehouses.archive": "Arsipkan",
  "settings.warehouses.restore": "Aktifkan kembali",
  "settings.warehouses.archiveConfirm": "Arsipkan gudang {name}? Gudang tidak dapat dipilih untuk penerimaan atau order baru sampai diaktifkan kembali.",
  "settings.warehouses.empty": "Belum ada gudang.",
  "settings.warehouses.wms": "WMS",
  "settings.warehouses.wmsOn": "Aktif",
  "settings.warehouses.wmsOff": "Tidak aktif",
  "settings.warehouses.wmsSet": "Atur WMS",
  "settings.warehouses.wmsTitle": "WMS · {name}",
  "settings.warehouses.wmsBody": "Dengan WMS, stok dicatat per lokasi rak (zona › rak › level › bin), barang diterima dan disimpan lewat tugas, dan order dipicking lewat pool dan wave (single-pcs, batch, cluster) dengan FEFO.",
  "settings.warehouses.wmsEnable": "Aktifkan WMS untuk gudang ini",
  "settings.warehouses.wmsEnableNote": "Saat diaktifkan, stok yang ada dipindah ke lokasi TERIMA. Buat lokasi rak, lalu jalankan tugas putaway untuk menyimpannya.",
  "settings.warehouses.wmsDisableNote": "Menonaktifkan WMS mengembalikan semua stok bin ke level gudang. Tugas yang masih terbuka harus selesai atau dibatalkan dulu.",
  "settings.warehouses.shipMethod": "Pengiriman saat label dicetak di meja packing",
  "settings.warehouses.shipMethodHelp": "Untuk order yang belum diatur pengirimannya, kurir dipesan dengan cara ini saat label dicetak.",
  "settings.warehouses.requireBoxScan": "Wajib scan barcode kemasan saat packing",
  "settings.warehouses.requireBoxScanHelp": "Kemasan tidak bisa dipilih dengan klik atau diambil dari saran; packer harus memindai barcode kemasan yang dipakai, sehingga pemakaian kardus tercatat akurat.",
  "settings.warehouses.recordPacking": "Rekam video packing",
  "settings.warehouses.recordPackingHelp": "Meja packing merekam setiap paket dengan kamera (webcam) dari saat order dibuka sampai paket ditutup; nomor order dan waktu tertulis di video. Video disimpan di cloud Zerpid dan bisa diputar dari detail order untuk bukti komplain.",
  "settings.warehouses.videoRetention": "Simpan video selama",
  "settings.warehouses.videoRetentionHelp": "Setelah itu video dihapus otomatis. Sesuaikan dengan batas waktu komplain marketplace (umumnya 7–30 hari setelah diterima).",
  "settings.warehouses.days": "hari",
  "settings.warehouses.wmsSaved": "Pengaturan WMS disimpan.",
  "settings.warehouses.manageLocations": "Kelola lokasi",

  "settings.users.warehouses": "Akses gudang",
  "settings.users.allWarehouses": "Semua gudang",
  "settings.users.warehousesChanged": "Akses gudang {name} diubah. Berlaku di permintaan berikutnya.",
  "activity.member.warehouses_changed": "Mengubah akses gudang anggota",
  "error.warehouse_access": "Anda tidak punya akses ke gudang ini.",
  "list.total": "{n} data",
  "list.totalCapped": "Lebih dari {n} data. Persempit filter untuk melihat sisanya.",
  "list.export": "Export",
  "list.exportXlsx": "Excel (.xlsx)",
  "list.exportCsv": "CSV (UTF-8)",
  "list.exporting": "Menyiapkan file export…",
  "list.from": "Dari tanggal",
  "list.to": "Sampai tanggal",
  "list.allStatuses": "Semua status",
  "list.openOnly": "Masih berjalan",
  "list.searchNumber": "Cari nomor…",
  "error.export_too_large": "Lebih dari 100.000 baris. Persempit filter dulu, lalu export lagi.",
  "list.createdBy": "Dibuat oleh",
  "list.createdAt": "Dibuat",
  "list.completedAt": "Selesai",
  "wms.in.search": "Cari nomor, pemasok, referensi…",
  "wms.task.doneUnits": "Selesai (unit)",
  "wms.task.units": "Total unit",
  "common.yes": "Ya",
  "common.no": "Tidak",
  "wms.count.countedLocations": "Lokasi dihitung",
  "wms.count.shortUnits": "Kurang (unit)",
  "wms.count.overUnits": "Lebih (unit)",
  "wms.wave.orderCount": "Order",
  "wms.wave.removed": "Dikeluarkan",
  "wms.wave.packed": "Dikemas",
  "wms.wave.search": "Cari nomor, pool…",
  "wms.mf.search": "Cari nomor, kurir, nama kurir…",
  "wms.mf.handedBy": "Diserahkan oleh",
  "wms.tr.search": "Cari nomor, catatan…",
  "wms.tr.shippedAt": "Dikirim",
  "as.sourceLabel": "Asal kasus",
  "as.expectedUnits": "Unit diharapkan",
  "as.receivedUnits": "Unit diterima",
  "as.resolutionLabel": "Penyelesaian",
  "as.receivedAt": "Diterima gudang",
  "as.resolvedAt": "Diselesaikan",
  "as.filter.allResolutions": "Semua penyelesaian",
  "orders.carrierFilter": "Kurir",
  "orders.holdLabel": "Tertahan",
  "orders.holdNoteLabel": "Catatan tertahan",
  "orders.lineCount": "Jumlah baris",
  "orders.unitCount": "Jumlah unit",
  "orders.currency": "Mata uang",
  "orders.labelPrints": "Label dicetak",
  "inventory.stock.all": "Semua kondisi stok",
  "inventory.stock.out": "Habis (available 0)",
  "inventory.stock.damaged": "Ada stok rusak",
  "inventory.stock.quarantine": "Ada stok karantina",
  "inventory.stock.variance": "Ada selisih",
  "logs.allEntities": "Semua jenis",
  "logs.actionFilter": "Kode aktivitas (mis. order)",
  "logs.entityLabel": "Jenis",
  "logs.entityId": "ID",
  "logs.entity.tenant": "Workspace",
  "logs.entity.member": "Pengguna",
  "logs.entity.invitation": "Undangan",
  "logs.entity.warehouse": "Gudang",
  "logs.entity.order": "Order",
  "logs.entity.product": "Produk",
  "logs.entity.stock": "Stok",
  "logs.entity.channel": "Channel",
  "catalog.allKinds": "Semua jenis",
  "catalog.allTracking": "Semua pelacakan",
  "catalog.updatedAt": "Diubah",
  "catalog.platform.variant": "Varian",
  "catalog.platform.listingId": "ID produk marketplace",
  "catalog.platform.skuId": "ID SKU marketplace",
  "catalog.platform.mappedCode": "Dipetakan ke (kode)",
  "catalog.platform.mappedName": "Dipetakan ke (nama)",
  "support.title": "Sesi support Zerpid",
  "support.subtitle": "Membuka workspace client dalam mode hanya lihat…",
  "support.toLogin": "Ke halaman masuk",
  "support.banner": "Mode support Zerpid (hanya lihat) oleh {name}. Semua akses tercatat di Log Aktivitas.",
  "support.end": "Akhiri sesi",
  "shell.suspended.title": "Workspace ini sedang ditangguhkan",
  "shell.suspended.body": "Data Anda tetap aman. Hubungi tim Zerpid untuk mengaktifkannya kembali.",
  "settings.support.title": "Akses support Zerpid",
  "settings.support.help": "Izinkan tim support Zerpid melihat isi workspace ini (hanya lihat, tidak bisa mengubah apa pun) untuk membantu menyelesaikan masalah. Setiap sesi support tercatat di Log Aktivitas, dan izin bisa dicabut kapan saja.",
  "settings.support.openUntil": "Akses support terbuka sampai {at}.",
  "settings.support.grant24": "Izinkan 24 jam",
  "settings.support.grant72": "Izinkan 72 jam",
  "settings.support.withdraw": "Cabut akses",
  "settings.support.granted": "Akses support diizinkan.",
  "settings.support.withdrawn": "Akses support dicabut.",
  "error.support_read_only": "Sesi support hanya bisa melihat, tidak bisa mengubah.",
  "error.support_access_ended": "Owner sudah mencabut akses support.",
  "error.support_access_not_granted": "Owner belum mengizinkan akses support.",
  "error.workspace_suspended": "Workspace ini sedang ditangguhkan. Hubungi tim Zerpid.",
  "activity.support.session_started": "Sesi support Zerpid dimulai",
  "activity.support.access_granted": "Mengizinkan akses support",
  "activity.support.access_withdrawn": "Mencabut akses support",
  "orders.hold.quota": "Kuota order bulan ini habis",
  "sub.title": "Langganan",
  "sub.plan": "Paket",
  "sub.trialEnds": "Masa percobaan berakhir",
  "sub.planUntil": "Berlaku sampai",
  "sub.noEnd": "Tanpa batas waktu",
  "sub.trialHelp": "Selama masa percobaan semua modul terbuka tanpa batas. Setelah berakhir, workspace turun ke paket Free; data tetap tersimpan.",
  "sub.manualHelp": "Untuk upgrade, perpanjang, atau menambah kuota, hubungi tim Zerpid. Paket diaktifkan setelah pembayaran dikonfirmasi.",
  "sub.contact": "Hubungi tim Zerpid",
  "sub.contactText": "Hubungi tim Zerpid untuk upgrade.",
  "sub.usage": "Pemakaian",
  "sub.unlimited": "{n} · tanpa batas",
  "sub.kind.orders_month": "Order diproses bulan ini",
  "sub.kind.skus": "SKU aktif",
  "sub.kind.warehouses": "Gudang",
  "sub.kind.users": "User (termasuk undangan)",
  "sub.kind.stores": "Toko terhubung",
  "sub.ordersWaiting": "{n} order menunggu kuota. Order ini diproses otomatis begitu kuota tersedia lagi (upgrade atau bulan baru).",
  "sub.warn.full": "Batas paket tercapai: {kinds}. Hubungi tim Zerpid untuk upgrade.",
  "sub.warn.near": "Pemakaian mendekati batas paket (80%): {kinds}.",
  "sub.warn.trial": "Masa percobaan berakhir {date}. Setelah itu workspace turun ke paket Free.",
  "sub.warn.planEnding": "Paket Anda berlaku sampai {date}. Hubungi tim Zerpid untuk perpanjang.",
  "sub.warn.planExpired": "Masa berlaku paket sudah lewat. Hubungi tim Zerpid untuk perpanjang.",
  "error.quota_exceeded": "Batas paket Anda sudah tercapai. Lihat menu Langganan untuk upgrade.",
  "activity.tenant.trial_ended": "Masa percobaan berakhir, paket menjadi Free",
  "settings.users.title": "User & Role",
  "settings.users.invite": "Undang user",
  "settings.users.inviteSubmit": "Kirim undangan",
  "settings.users.invited": "Undangan dikirim ke {email}.",
  "settings.users.role": "Role",
  "settings.users.lastLogin": "Terakhir masuk",
  "settings.users.active": "Aktif",
  "settings.users.disabled": "Nonaktif",
  "settings.users.deactivate": "Nonaktifkan",
  "settings.users.activate": "Aktifkan",
  "settings.users.deactivateConfirm": "Nonaktifkan {name}? Akses ke perusahaan ini berhenti segera dan semua sesinya di perusahaan ini diakhiri.",
  "settings.users.roleChanged": "Role {name} diubah. Berlaku pada aksi berikutnya.",
  "settings.users.pending": "Undangan tertunda",
  "settings.users.expires": "Berlaku sampai",
  "settings.users.revoke": "Batalkan",
  "settings.users.revokeConfirm": "Batalkan undangan untuk {email}? Tautan di email tidak dapat dipakai lagi.",
  "settings.users.you": "Anda",

  "logs.title": "Log Aktivitas",
  "logs.time": "Waktu",
  "logs.actor": "Oleh",
  "logs.action": "Aktivitas",
  "logs.detail": "Detail",
  "logs.empty": "Belum ada aktivitas yang dapat Anda lihat.",
  "logs.scopeWarehouse": "Menampilkan aktivitas gudang dan stok sesuai role Anda.",
  "logs.scopeOrders": "Menampilkan aktivitas order sesuai role Anda.",

  "activity.tenant.created": "Membuat perusahaan",
  "activity.tenant.updated": "Mengubah data perusahaan",
  "activity.warehouse.created": "Menambah gudang",
  "activity.warehouse.updated": "Mengubah gudang",
  "activity.invitation.sent": "Mengirim undangan",
  "activity.invitation.revoked": "Membatalkan undangan",
  "activity.member.joined": "Bergabung",
  "activity.member.role_changed": "Mengubah role",
  "activity.member.activated": "Mengaktifkan user",
  "activity.member.deactivated": "Menonaktifkan user",
  "activity.member.updated": "Mengubah user",

  "platform.shopee": "Shopee",
  "platform.tokopedia": "Tokopedia",
  "platform.tiktok": "TikTok Shop",
  "platform.lazada": "Lazada",
  "platform.blibli": "Blibli",
  "channels.key.title": "Hubungkan toko Blibli",
  "channels.key.modeBind": "Permintaan bind (disarankan)",
  "channels.key.modeKey": "API Seller Key",
  "channels.key.bindHelp": "Zerpid mengirim permintaan bind ke Blibli. Pemilik toko menyetujuinya di Blibli Seller Center (Profil > Seller API Manager) atau lewat email dari Blibli. Permintaan berlaku sampai akhir hari berikutnya; setelah disetujui, toko terhubung dengan sendirinya.",
  "channels.key.keyHelp": "Di Blibli Seller Center, buka Profil > Seller API Manager > Manual Bind. Hubungkan API Client ID di bawah, klik Generate, lalu salin API Seller Key ke sini.",
  "channels.key.clientId": "API Client ID Zerpid",
  "channels.key.storeCode": "Kode toko",
  "channels.key.storeCodeHint": "Ada di Profil > Info Toko, misalnya TOQ-15126.",
  "channels.key.username": "Email login Seller Center",
  "channels.key.sellerKey": "API Seller Key (Kata Sandi API)",
  "channels.key.signatureKey": "Signature Key (Kata Sandi Khusus)",
  "channels.key.signatureHint": "Isi hanya jika toko mengaktifkan Signature di Seller API Manager.",
  "channels.key.send": "Kirim permintaan",
  "channels.key.bindSent": "Permintaan terkirim. Toko terhubung setelah pemilik toko menyetujuinya di Blibli Seller Center.",
  "channels.bindPending": "Menunggu persetujuan di Blibli Seller Center.",
  "error.key_rejected": "Blibli menolak data toko ini. Periksa kode toko, email login, dan API Seller Key.",
  "error.already_connected": "Toko ini sudah terhubung.",
  "error.shop_taken": "Toko ini sudah terhubung ke perusahaan lain di Zerpid.",
  "error.unknown_platform": "Marketplace tidak dikenal.",
  "error.channel_unavailable": "Marketplace ini belum dapat dihubungkan.",
  "error.sync_in_progress": "Sinkronisasi toko ini sedang berjalan.",
  "error.reauth_required": "Hubungkan ulang toko ini sebelum menyinkronkan.",
  "error.store_disconnected": "Toko ini sudah diputus. Hubungkan ulang di Channels untuk memproses ordernya.",
  "error.sku_barcode_taken": "Barcode ini sudah dipakai SKU lain.",
  "error.sku_code_taken": "Kode SKU ini sudah dipakai SKU lain.",
  "error.sku_archived": "SKU ini diarsipkan. Aktifkan kembali terlebih dahulu.",
  "error.duplicate_group_changed": "Kelompok ini berubah sejak ditampilkan. Muat ulang lalu tinjau lagi.",
  "error.no_seller_sku": "SKU platform ini tidak punya seller SKU untuk dijadikan kode. Petakan secara manual.",
  "error.platform_sku_not_found": "SKU platform tidak ditemukan.",
  "channels.title": "Channel",
  "channels.connect": "Hubungkan toko",
  "channels.pickPlatform": "Pilih marketplace",
  "channels.pickBody": "Anda akan diarahkan ke halaman marketplace untuk memberi izin akses. Setelah selesai, Anda kembali ke halaman ini.",
  "channels.unavailable": "Segera hadir",
  "channels.empty": "Belum ada toko terhubung",
  "channels.emptyBody": "Hubungkan toko Shopee, Tokopedia, TikTok Shop, atau Lazada agar order dan stok masuk ke satu tempat.",
  "channels.status.connecting": "Menghubungkan",
  "channels.status.syncing": "Menyinkronkan",
  "channels.status.active": "Terhubung",
  "channels.status.reauth_required": "Hubungkan ulang",
  "channels.status.error": "Bermasalah",
  "channels.status.disconnected": "Terputus",
  "channels.colKind": "Jenis",
  "channels.colSource": "Sumber",
  "channels.colMarketplace": "Marketplace",
  "channels.shopId": "ID toko",
  "channels.lastSync": "Sinkron terakhir",
  "channels.lastWebhook": "Notifikasi terakhir",
  "channels.lastError": "Kesalahan terakhir",
  "channels.syncNow": "Sinkronkan sekarang",
  "channels.syncQueued": "Sinkronisasi dijadwalkan. Status diperbarui dalam beberapa saat.",
  "channels.disconnect": "Putuskan koneksi",
  "channels.disconnectConfirm": "Putuskan {name}? Token akses dihapus dan sinkronisasi berhenti. Riwayat order dan log tetap tersimpan.",
  "channels.disconnected": "{name} diputus.",
  "channels.reconnect": "Hubungkan ulang",
  "channels.reauthHelp": "Akses Zerpid ke toko ini berakhir atau dicabut di marketplace. Hubungkan ulang untuk melanjutkan sinkronisasi.",
  "channels.detail": "Detail",
  "channels.syncJobs": "Riwayat sinkronisasi",
  "channels.events": "Data masuk terbaru",
  "channels.eventCounts": "Data diterima 30 hari terakhir",
  "channels.jobResult": "{orders} order, {listings} produk, {new} baru",
  "channels.job.initial": "Awal",
  "channels.job.manual": "Manual",
  "channels.job.poll": "Otomatis",
  "channels.job.token_refresh": "Perpanjang token",
  "channels.job.running": "Berjalan",
  "channels.job.succeeded": "Berhasil",
  "channels.job.failed": "Gagal",
  "channels.source.webhook": "Notifikasi",
  "channels.source.poll": "Pengecekan otomatis",
  "channels.source.initial_sync": "Sinkron awal",
  "channels.source.manual_sync": "Sinkron manual",
  "channels.kind.order": "Order",
  "channels.kind.product": "Produk",
  "channels.kind.return": "Retur",
  "channels.kind.cancellation": "Pembatalan",
  "channels.kind.auth": "Otorisasi",
  "channels.kind.chat": "Chat",
  "channels.kind.other": "Lainnya",
  "channels.result.connected": "{count} toko {platform} terhubung. Sinkronisasi awal sedang berjalan.",
  "channels.result.cancelled": "Otorisasi dibatalkan. Tidak ada toko yang disimpan.",
  "channels.result.expired": "Waktu otorisasi habis. Silakan ulangi dari tombol Hubungkan toko.",
  "channels.result.failed": "Toko gagal dihubungkan. Silakan coba lagi; bila berulang, hubungi kami.",
  "channels.result.shop_taken": "Toko ini sudah terhubung ke perusahaan lain di Zerpid.",
  "channels.warning.shop_taken": "Sebagian toko tidak dihubungkan karena sudah terhubung ke perusahaan lain.",
  "channels.banner": "{n} toko marketplace perlu perhatian.",
  "channels.bannerAction": "Buka Channel",
  "catalog.title": "SKU",
  "catalog.add": "Tambah SKU",
  "catalog.edit": "Ubah SKU",
  "catalog.code": "Kode SKU",
  "catalog.codeHelp": "Kode unik Anda, tanpa spasi. Tidak dapat diubah setelah disimpan.",
  "catalog.barcode": "Barcode",
  "catalog.weight": "Berat (gram)",
  "catalog.brand": "Brand",
  "catalog.dimensions": "Dimensi (mm)",
  "catalog.dimensionsHelp": "Ukuran luar satu unit: panjang × lebar × tinggi. Dipakai untuk menyarankan kardus saat packing.",
  "catalog.lengthMm": "Panjang",
  "catalog.widthMm": "Lebar",
  "catalog.heightMm": "Tinggi",
  "catalog.tracking": "Pelacakan",
  "catalog.kind": "Jenis",
  "catalog.kind.single": "Satuan",
  "catalog.bundle": "Bundle",
  "catalog.bundleHelp": "Bundle tidak punya stok sendiri. Stok yang dijual ke marketplace adalah jumlah set yang bisa dibentuk dari komponennya; order bundle dipecah menjadi komponen saat diproses, lalu dikunci, di-pick, dan dikemas.",
  "catalog.bundleMadeOf": "Isi bundle: {items}",
  "catalog.components": "Isi bundle",
  "catalog.addComponent": "Tambah komponen",
  "catalog.tracking.none": "Tanpa pelacakan",
  "catalog.tracking.lot": "Lot + tanggal kedaluwarsa (FEFO)",
  "catalog.tracking.serial": "Nomor seri",
  "catalog.trackingHelp": "Lot dan nomor seri dicatat per rak saat penerimaan dan di-scan saat picking (modul Gudang). Hanya dapat diubah saat stok SKU kosong.",
  "catalog.trackingPlan": "Paket Scale ke atas",
  "catalog.search": "Cari kode, nama, atau barcode",
  "catalog.empty": "Belum ada SKU.",
  "catalog.active": "Aktif",
  "catalog.archived": "Diarsipkan",
  "catalog.archive": "Arsipkan",
  "catalog.restore": "Aktifkan kembali",
  "catalog.total": "{n} SKU aktif",
  "catalog.view.platform": "Listing toko",
  "catalog.import": "Sinkron listing",
  "catalog.importOne": "Sinkron satu toko saja",
  "catalog.importStarted": "Sinkron berjalan untuk {n} toko. Listing diperbarui dalam beberapa menit.",
  "catalog.importSkipped": "{n} toko dilewati karena sedang sinkron atau perlu dihubungkan ulang.",
  "catalog.importNone": "Tidak ada toko yang bisa disinkronkan sekarang.",
  "catalog.duplicateBanner": "{n} kelompok SKU duplikat ditemukan",
  "catalog.duplicateBannerBody": "SKU platform yang kemungkinan produk yang sama tetapi belum dipetakan ke satu SKU internal. Stoknya bisa tidak sinkron.",
  "catalog.review": "Tinjau",
  "catalog.unmappedBanner": "{n} SKU platform belum dipetakan",
  "catalog.unmappedBannerBody": "Order untuk SKU ini tidak mereservasi stok, dan stoknya di marketplace tidak disinkronkan.",
  "catalog.platform.filter.all": "Semua",
  "catalog.platform.filter.unmapped": "Belum dipetakan ({n})",
  "catalog.platform.filter.mapped": "Sudah dipetakan",
  "catalog.platform.search": "Cari seller SKU atau nama produk",
  "catalog.platform.product": "Produk di marketplace",
  "catalog.platform.sellerSku": "Seller SKU",
  "catalog.platform.price": "Harga",
  "catalog.platform.stock": "Stok di marketplace",
  "catalog.platform.mappedTo": "Dipetakan ke",
  "catalog.platform.empty": "Belum ada listing. Hubungkan toko; listing-nya diunduh otomatis.",
  "catalog.mapping.auto_code": "Otomatis",
  "catalog.mapping.manual": "Manual",
  "catalog.mapping.untracked": "Tidak dilacak",
  "catalog.mapping.untrackedHelp": "Ditandai tidak dilacak: stok tidak disinkronkan dan tidak dipetakan otomatis.",
  "catalog.map": "Petakan",
  "catalog.mapTo": "Petakan ke SKU internal",
  "catalog.mapSelected": "Petakan ({n})",
  "catalog.mapTitle": "Petakan {n} SKU platform",
  "catalog.mapBody": "SKU platform akan menjual SKU internal ini: stok dikirim dari SKU ini dan order mereservasinya, termasuk order yang masih terbuka.",
  "catalog.skuPick": "SKU internal",
  "catalog.skuPickPlaceholder": "Cari kode atau nama SKU",
  "catalog.mapped": "Pemetaan disimpan. Stok dikirim ke marketplace dalam beberapa detik.",
  "catalog.createFromPlatform": "Buat SKU internal ({n})",
  "catalog.createFromPlatformHelp": "Kode memakai seller SKU. Bila kode sudah ada, SKU yang ada dipakai.",
  "catalog.createdFromPlatform": "{created} SKU internal dibuat, {reused} memakai SKU yang sudah ada.",
  "catalog.createdPartial": "{ok} berhasil, {failed} gagal (mis. tanpa seller SKU).",
  "catalog.unmap": "Lepas",
  "catalog.untrackSelected": "Tandai tidak dilacak ({n})",
  "catalog.untrackTitle": "Tandai {n} SKU platform tidak dilacak?",
  "catalog.untrackBody": "Stok SKU ini di marketplace tidak lagi disinkronkan dan tetap di angka terakhir. Order baru untuknya tidak mereservasi stok. Pemetaan otomatis tidak akan memetakannya lagi.",
  "catalog.unmapTitle": "Lepas pemetaan {name}?",
  "catalog.untracked": "SKU platform ditandai tidak dilacak.",
  "catalog.detail.mapping": "Pemetaan",
  "catalog.detail.log": "Log",
  "catalog.detail.mappingEmpty": "SKU ini belum dijual di marketplace mana pun.",
  "catalog.detail.mapToPlatform": "Petakan ke platform",
  "catalog.detail.mapToPlatformTitle": "Petakan {code} ke SKU platform",
  "catalog.detail.suggested": "Diurutkan dari yang paling mirip dengan nama SKU ini.",
  "catalog.detail.stock": "Lihat stok",
  "catalog.dup.title": "Tinjau SKU duplikat",
  "catalog.dup.intro": "Setiap kelompok berisi SKU platform yang kemungkinan produk yang sama. Gabungkan agar semuanya memakai satu SKU internal (stok jadi satu), atau abaikan bila memang berbeda.",
  "catalog.dup.empty": "Tidak ada SKU duplikat yang perlu ditinjau.",
  "catalog.dup.reason.same_code": "Seller SKU sama",
  "catalog.dup.reason.similar_title": "Nama dan varian mirip",
  "catalog.dup.merge": "Gabungkan",
  "catalog.dup.dismiss": "Abaikan",
  "catalog.dup.dismissed": "Kelompok diabaikan. Akan muncul lagi hanya bila ada SKU baru yang masuk.",
  "catalog.dup.mergeTitle": "Gabungkan {n} SKU platform",
  "catalog.dup.target": "Gunakan SKU internal",
  "catalog.dup.targetOther": "SKU internal lain",
  "catalog.dup.targetNew": "Buat SKU internal baru",
  "catalog.dup.mergedPlain": "Digabungkan. Semua SKU platform di kelompok ini kini memakai satu SKU internal.",
  "catalog.dup.more": "Menampilkan {shown} dari {total} kelompok. Kelompok lain muncul setelah yang ini selesai ditinjau.",
  "catalog.dup.notMapped": "Belum dipetakan",
  "price.tab": "Harga",
  "price.current": "Harga di marketplace",
  "price.new": "Harga baru",
  "price.edit": "Ubah",
  "price.save": "Kirim",
  "price.sync.pending": "Menyinkronkan",
  "price.sync.done": "Tersinkron",
  "price.sync.failed": "Gagal",
  "price.sync.pendingTo": "Mengirim {price}",
  "price.queued": "Harga dikirim ke marketplace.",
  "price.empty": "Belum ada SKU platform yang menjual SKU ini, jadi belum ada harga untuk diatur.",
  "price.bulk": "Ubah harga massal ({n})",
  "price.bulkTitle": "Ubah harga {n} SKU",
  "price.rule": "Aturan",
  "price.mode.set": "Tetapkan harga",
  "price.mode.percent": "Ubah dengan persen",
  "price.mode.amount": "Ubah dengan nominal",
  "price.value.set": "Harga baru (Rp)",
  "price.value.percent": "Persen (negatif untuk diskon)",
  "price.value.amount": "Nominal (Rp, negatif untuk menurunkan)",
  "price.round": "Pembulatan",
  "price.round.none": "Tanpa pembulatan",
  "price.round.to": "Kelipatan Rp{n}",
  "price.roundMode.nearest": "Terdekat",
  "price.roundMode.up": "Ke atas",
  "price.roundMode.down": "Ke bawah",
  "price.stores": "Toko",
  "price.storesAll": "Semua toko",
  "price.preview": "Pratinjau",
  "price.previewEmpty": "SKU terpilih belum dipetakan ke SKU platform mana pun.",
  "price.apply": "Terapkan ({n})",
  "price.problem.no_current_price": "Belum ada harga untuk dihitung",
  "price.problem.below_min": "Di bawah Rp100, dilewati",
  "price.problem.above_max": "Terlalu besar, dilewati",
  "price.problem.big_change": "Berubah lebih dari 50%",
  "price.mode.suggested": "Harga saran",
  "price.problem.no_cost": "Belum ada HPP, dilewati",
  "price.suggestedHelp": "Harga dihitung per SKU dari HPP dan profil biaya tokonya (Keuangan > Margin harga), lalu dibulatkan ke atas supaya margin tidak di bawah target.",
  "price.summaryTitle": "Hasil perubahan harga",
  "price.summarySending": "Mengirim ke marketplace… {done} dari {total} selesai",
  "price.summaryDone": "{done} harga tersinkron, {failed} gagal.",
  "price.summarySuperseded": "{n} diganti oleh perubahan yang lebih baru.",
  "activity.channel.connected": "Menghubungkan toko",
  "activity.channel.reconnected": "Menghubungkan ulang toko",
  "activity.channel.disconnected": "Memutus toko",
  "activity.channel.reauth_required": "Akses toko berakhir",
  "activity.product.created": "Menambah SKU",
  "activity.product.updated": "Mengubah SKU",
  "activity.product.mapped": "Memetakan SKU platform",
  "activity.product.unmapped": "Melepas SKU platform",
  "activity.product.duplicates_dismissed": "Mengabaikan kelompok duplikat",
  "activity.product.price_changed": "Mengubah harga",
  "onboarding.marketplace.connected": "Terhubung",

  "tabs.reload": "Muat ulang tab",
  "tabs.close": "Tutup",
  "tabs.keep": "Pertahankan tab",
  "tabs.previewHelp": "Tab pratinjau: detail berikutnya dari menu yang sama dibuka di sini. Klik dua kali untuk mempertahankan.",
  "tabs.closeOthers": "Tutup tab lain",
  "tabs.closeRight": "Tutup tab di kanan",
  "tabs.closeAll": "Tutup semua",
  "tabs.autoClosed": "Maksimal {max} tab terbuka. Tab yang paling lama tidak dipakai ditutup.",

  "status.awaiting_payment": "Menunggu bayar",
  "status.new": "Baru",
  "status.processing": "Diproses",
  "status.packed": "Dikemas",
  "status.shipped": "Dikirim",
  "status.delivered": "Terkirim",
  "status.completed": "Selesai",
  "status.cancelled": "Dibatalkan",
  "status.returned": "Retur",
  "error.order_not_processable": "Hanya order Baru tanpa permintaan batal yang dapat diproses.",
  "error.order_not_cancellable": "Order ini sudah tidak dapat dibatalkan.",
  "error.no_cancel_request": "Tidak ada permintaan pembatalan untuk ditanggapi.",
  "error.marketplace_rejected": "Marketplace menolak aksi ini.",
  "error.not_supported": "Marketplace ini tidak mendukung aksi tersebut.",
  "error.sku_not_found": "SKU tidak ditemukan.",
  "error.warehouse_not_found": "Gudang tidak ditemukan atau diarsipkan.",
  "error.wms_bin_required": "Gudang ini memakai WMS. Ubah stok per lokasi (bin) dari detail stok.",
  "error.wms_not_enabled": "Aktifkan WMS untuk gudang ini terlebih dahulu.",
  "error.wms_tasks_open": "Masih ada tugas gudang yang terbuka. Selesaikan atau batalkan dulu.",
  "error.insufficient_bin_stock": "Jumlah di lokasi ini tidak mencukupi (sebagian mungkin sedang dipesan tugas lain).",
  "error.location_not_found": "Lokasi tidak ditemukan di gudang ini.",
  "error.location_not_empty": "Lokasi ini masih berisi stok.",
  "error.location_system": "Lokasi sistem tidak dapat diarsipkan.",
  "error.location_code_taken": "Kode lokasi ini sudah dipakai.",
  "error.location_not_allowed": "Barang ini tidak bisa disimpan di jenis lokasi tersebut.",
  "error.lot_required": "SKU ini dilacak per lot: isi nomor lot dan tanggal kedaluwarsa.",
  "error.serials_required": "SKU ini dilacak per nomor seri: scan satu nomor seri per unit.",
  "error.serial_in_stock": "Nomor seri ini sudah tercatat di stok.",
  "error.serial_not_here": "Nomor seri ini tidak ada di lokasi tersebut.",
  "error.serial_requires_scan": "Stok bernomor seri diubah dengan memindai unitnya, bukan dengan angka.",
  "error.receipt_closed": "Penerimaan ini sudah selesai atau dibatalkan.",
  "error.receipt_has_receipts": "Barang sudah diterima pada dokumen ini. Selesaikan saja.",
  "error.code_not_found": "Kode tidak dikenali: bukan SKU, barcode, lokasi, atau nomor seri.",
  "error.task_closed": "Tugas ini sudah selesai atau dibatalkan.",
  "error.task_taken": "Tugas ini sedang dikerjakan orang lain.",
  "error.quantity_over_line": "Jumlah melebihi sisa baris ini.",
  "error.nothing_to_putaway": "Tidak ada barang yang menunggu di lokasi TERIMA.",
  "error.order_not_arrangeable": "Pengiriman hanya bisa diatur untuk order Baru atau Diproses yang belum diatur dan tanpa permintaan batal.",
  "error.shipping_not_arranged": "Atur pengiriman dulu. Label tersedia setelah kurir dipesan.",
  "error.order_closed": "Order ini sudah dibatalkan atau diretur.",
  "error.label_not_ready": "Marketplace masih menyiapkan label. Coba lagi sebentar lagi.",
  "error.label_not_prepared": "Label belum disiapkan. Coba cetak ulang.",
  "error.label_no_original": "Label asli hanya tersedia untuk satu order dengan label dari marketplace.",
  "error.label_unreadable": "Label dari marketplace tidak bisa diberi resi besar. Cetak label asli marketplace.",
  "error.insufficient_stock": "Jumlah unit pada kondisi asal tidak mencukupi.",
  "error.insufficient_available": "Stok Tersedia tidak mencukupi. Stok yang sudah dialokasikan untuk order tidak dapat ditahan.",
  "error.hold_released": "Stok ini sudah dilepas sebelumnya.",
  "error.plan_feature_unavailable": "Fitur ini tersedia mulai paket Scale. Upgrade paket untuk mengaktifkannya.",
  "error.tracking_has_stock": "Mode pelacakan hanya dapat diubah saat SKU tidak memiliki stok di gudang mana pun.",
  "error.location_counting": "Lokasi ini sedang dihitung (dibekukan) sampai hasil hitungnya dikirim.",
  "error.variance_location": "Lokasi SELISIH hanya berubah lewat hitung stok dan konfirmasi selisih.",
  "error.location_busy": "Sebagian unit di lokasi ini sedang dipesan tugas. Selesaikan tugasnya dulu, lalu hitung.",
  "error.sku_not_in_count": "SKU ini tidak termasuk dalam hitung stok ini.",
  "error.serial_other_warehouse": "Nomor seri ini tercatat di stok gudang lain.",
  "error.variance_changed": "Selisih berubah sejak ditampilkan. Muat ulang, lalu konfirmasi lagi.",
  "error.nothing_to_count": "Tidak ada lokasi yang cocok, atau semuanya sedang dihitung di dokumen lain.",
  "error.count_closed": "Hitung stok ini sudah ditutup.",
  "error.location_not_pending": "Lokasi ini tidak sedang menunggu dihitung.",
  "error.count_started": "Sudah ada lokasi yang dihitung. Tutup hitung stok ini, jangan dibatalkan.",
  "error.counts_open": "Tutup dulu hitung stok yang masih terbuka di gudang ini.",
  "error.shelf_short": "Stok di rak tidak cukup untuk order ini (mungkin masih di TERIMA atau sedang dihitung).",
  "error.order_changed": "Order berubah saat wave disiapkan.",
  "error.nothing_to_wave": "Tidak ada order di pool ini yang bisa dipicking sekarang (kosong, atau stok rak kurang).",
  "error.wave_closed": "Wave ini sudah selesai atau dibatalkan.",
  "error.wrong_bin": "Bukan bin untuk baris ini.",
  "error.not_in_wave": "Order ini tidak sedang menunggu packing di wave mana pun.",
  "error.not_picked": "Order ini belum selesai dipick.",
  "error.already_packed": "Order ini sudah dikemas.",
  "error.not_packed": "Order ini belum dikemas.",
  "error.pack_mismatch": "Barang yang di-scan tidak sama dengan isi order.",
  "error.cancel_requested": "Pembeli mengajukan pembatalan order ini. Jawab dulu permintaannya.",
  "error.order_combined": "TikTok mengirim order ini dalam satu paket bersama order lain. Kemas bersama dan atur kirim lewat Seller Center TikTok.",
  "error.serial_required": "Scan nomor seri barang ini.",
  "error.nothing_to_pack": "Tidak ada order single-pcs terpick yang membutuhkan barang ini.",
  "error.packaging_code_taken": "Kode kemasan ini sudah dipakai di gudang ini.",
  "error.packaging_required": "Gudang ini mewajibkan scan kemasan: scan barcode kemasan dulu.",
  "error.no_packaging": "Tidak ada kemasan aktif untuk dicetak.",
  "error.manifest_closed": "Serah terima ini sudah selesai atau dibatalkan.",
  "error.manifest_empty": "Scan minimal satu paket dulu.",
  "error.order_cancelled": "Order ini dibatalkan. Paketnya tidak boleh dikirim.",
  "error.already_handed_over": "Paket ini sudah diserahkan ke kurir.",
  "error.already_scanned": "Paket ini sudah ada di serah terima ini.",
  "error.in_other_manifest": "Paket ini ada di serah terima lain yang masih terbuka.",
  "error.wrong_carrier": "Paket ini untuk kurir lain.",
  "error.transfer_state": "Transfer ini tidak bisa diproses pada statusnya sekarang.",
  "error.nothing_to_ship": "Tidak ada barang transfer ini yang tersisa untuk dikirim.",
  "error.transfer_too_many": "Melebihi jumlah yang dikirim untuk SKU ini. Konfirmasi dulu untuk menerima lebih.",
  "error.not_on_transfer": "SKU atau nomor seri ini tidak dikirim di transfer ini.",
  "error.transfer_not_picked": "Pick semua barang transfer ini sebelum dikirim.",
  "error.task_of_transfer": "Tugas ini untuk transfer: batalkan transfernya, bukan tugasnya.",
  "error.parcel_on_manifest": "Paket ini ada di serah terima. Keluarkan dari serah terima dulu.",
  "error.order_held_oos": "Stok belum cukup; order menunggu stok masuk.",
  "error.order_held_unmapped": "Ada SKU yang belum dipetakan.",
  "error.order_held_no_warehouse": "Order ini belum punya gudang.",
  "error.order_held_cancel_request": "Pembeli meminta pembatalan; jawab permintaannya dulu.",
  "error.order_held_rule": "Order ditahan aturan tahan.",
  "error.order_held_manual": "Order ditahan manual.",
  "error.order_held_arrange_failed": "Atur pengiriman gagal.",
  "error.order_in_wave": "Gudang sudah memproses order ini (picking atau packing).",
  "error.order_not_holdable": "Hanya order yang belum dikirim yang bisa ditahan atau dipindah.",
  "error.order_not_held": "Order ini tidak ditahan oleh aturan atau manual.",
  "error.bundle_no_stock": "Bundle tidak punya stok sendiri; ubah stok komponennya.",
  "error.recording_off": "Gudang ini tidak merekam video packing dan unboxing.",
  "error.video_not_found": "Tidak ada video packing untuk order ini (tidak direkam, atau sudah lewat masa simpan).",
  "error.unboxing_video_not_found": "Tidak ada video unboxing untuk kasus ini (tidak direkam, atau sudah lewat masa simpan).",
  "error.case_closed": "Kasus ini sudah selesai atau dibatalkan.",
  "error.case_state": "Kasus ini tidak bisa diproses seperti itu pada statusnya sekarang.",
  "error.case_receiving": "Gudang sedang membuka paket retur ini. Tunggu sampai pemeriksaan selesai.",
  "error.case_unlinked": "Cocokkan paket ini dengan order-nya terlebih dahulu.",
  "error.case_no_units": "Catat minimal satu barang sebelum menyelesaikan pemeriksaan.",
  "error.serial_not_shipped": "Nomor seri ini tidak tercatat keluar bersama order. Catat sebagai barang lain.",
  "error.serial_duplicate": "Nomor seri ini sudah dicatat di kasus ini.",
  "error.warehouse_inactive": "Gudang itu tidak aktif.",
  "error.video_too_large": "Rekaman terlalu besar.",
  "orders.title": "Order",
  "orders.all": "Semua",
  "orders.heldTab": "Ditahan",
  "orders.filters": "Filter",
  "orders.filtersReset": "Reset filter",
  "orders.copyNumber": "Salin nomor order",
  "orders.copied": "Tersalin",
  "orders.stage.all": "Semua tahap",
  "orders.stage.queue": "Belum dipicking",
  "orders.stage.picking": "Picking",
  "orders.stage.packing": "Packing",
  "orders.wave": "No. Picklist",
  "orders.cod": "COD",
  "orders.search": "Cari nomor order, nama pembeli, atau resi",
  "orders.allStores": "Semua toko",
  "orders.number": "No. order",
  "orders.store": "Toko",
  "orders.buyer": "Pembeli",
  "orders.items": "Barang",
  "orders.itemsValue": "{units} unit, {lines} SKU",
  "orders.total": "Total",
  "orders.orderedAt": "Waktu order",
  "orders.empty": "Belum ada order.",
  "orders.emptyBody": "Order dari toko marketplace yang terhubung akan muncul di sini.",
  "orders.cancelRequested": "Minta batal",
  "orders.cancelRequestsOnly": "Permintaan batal ({n})",
  "orders.unmapped": "SKU belum dipetakan",
  "orders.unmappedHelp": "Sebagian barang belum terhubung ke SKU internal, sehingga stoknya belum direservasi. Klik Petakan pada barangnya untuk menghubungkannya ke SKU internal (berlaku juga untuk order lain dengan barang yang sama), atau buat SKU dengan kode yang sama di Produk & Harga.",
  "orders.process": "Proses order",
  "orders.processSelected": "Proses terpilih ({n})",
  "orders.processed": "{ok} order diproses.",
  "orders.processedPartial": "{ok} order diproses, {failed} tidak dapat diproses.",
  "orders.cancel": "Batalkan",
  "orders.cancelTitle": "Batalkan order {number}",
  "orders.cancelAtTitle": "Order juga dibatalkan di {platform}",
  "orders.cancelAtBody": "Pembeli diberi tahu dan pembatalan di {platform} tidak bisa diurungkan. Stok yang direservasi dilepas setelah {platform} mengonfirmasi.",
  "orders.cancelAtOk": "Batalkan di {platform}",
  "orders.cancelZerpidTitle": "Hanya ditutup di Zerpid",
  "orders.cancelZerpidBody": "Toko {shop} sudah tidak terhubung, jadi marketplace TIDAK diberi tahu. Order ditutup di Zerpid dan stoknya dilepas. Pastikan order sudah dibatalkan atau diselesaikan di Seller Center.",
  "orders.cancelZerpidOk": "Tutup di Zerpid saja",
  "orders.cancelZerpidDone": "Order ditutup di Zerpid; marketplace tidak diubah.",
  "orders.storeGoneTitle": "Toko {shop} sudah tidak terhubung ke Zerpid",
  "orders.storeGoneBody": "Aksi ke marketplace (atur pengiriman, label, batal di marketplace) tidak bisa dijalankan lagi. Selesaikan order ini di Seller Center, lalu tutup di Zerpid lewat Batalkan.",
  "orders.cancelReason": "Alasan",
  "orders.reason.out_of_stock": "Stok habis",
  "orders.reason.customer_request": "Permintaan pembeli",
  "orders.reason.other": "Lainnya",
  "orders.reason.pickup": "dijemput kurir",
  "orders.reason.dropoff": "antar ke drop-off",
  "orders.cancelDone": "Order dibatalkan di marketplace.",
  "orders.cancelRequestTitle": "Pembeli meminta pembatalan",
  "orders.cancelRequestBody": "Order ini ditahan sampai Anda menanggapi. Terima untuk membatalkan dan melepas stok, atau tolak untuk melanjutkan proses.",
  "orders.acceptCancel": "Terima pembatalan",
  "orders.rejectCancel": "Tolak",
  "orders.responded": "Tanggapan dikirim ke marketplace.",
  "orders.recipient": "Penerima",
  "orders.address": "Alamat",
  "orders.payment": "Pembayaran",
  "orders.platformStatus": "Status marketplace",
  "orders.warehouse": "Gudang",
  "orders.lines": "Barang",
  "orders.qty": "Jml",
  "orders.unitPrice": "Harga",
  "orders.lineCancelled": "Dibatalkan",
  "orders.packages": "Paket & resi",
  "orders.carrier": "Kurir",
  "orders.trackingNo": "No. resi",
  "orders.noPackages": "Belum ada resi dari marketplace.",
  "orders.history": "Riwayat",
  "orders.history.marketplace": "Marketplace",
  "orders.history.user": "Pengguna",
  "orders.history.system": "Sistem",
  "orders.note.cancel_requested": "Pembeli meminta pembatalan",
  "orders.note.cancel_request_accepted": "Permintaan batal diterima",
  "orders.note.cancel_request_rejected": "Permintaan batal ditolak",
  "orders.note.cancelled_by_seller": "Dibatalkan penjual",
  "orders.note.shipment_arranged": "Pengiriman diatur",
  "orders.note.held": "Order ditahan",
  "orders.note.released": "Tahanan dilepas",
  "orders.note.auto_processed": "Diproses otomatis: stok terkunci",
  "orders.note.warehouse_changed": "Gudang diganti",
  "orders.hold.oos": "Stok kurang",
  "orders.hold.unmapped": "SKU belum dipetakan",
  "orders.hold.no_warehouse": "Tanpa gudang",
  "orders.hold.cancel_request": "Menunggu jawaban batal",
  "orders.hold.rule": "Ditahan aturan",
  "orders.hold.manual": "Ditahan manual",
  "orders.hold.combined": "Digabung TikTok",
  "orders.hold.arrange_failed": "Atur kirim gagal",
  "orders.holdHelp.oos": "Stok tidak cukup untuk semua barang, jadi belum ada yang dikunci. Order diproses otomatis begitu stok masuk (inbound, retur, transfer, penyesuaian), urut dari batas kirim terdekat.",
  "orders.holdHelp.unmapped": "Ada barang yang belum dipetakan ke SKU internal. Petakan, lalu order diproses otomatis.",
  "orders.holdHelp.no_warehouse": "Toko ini belum punya gudang. Atur gudang toko, atau pilih gudang untuk order ini.",
  "orders.holdHelp.cancel_request": "Pembeli meminta pembatalan; jawab permintaannya dulu.",
  "orders.holdHelp.rule": "Sesuai aturan tahan. Stok tetap terkunci; gudang belum memproses sampai ditahan dilepas.",
  "orders.holdHelp.manual": "Ditahan oleh tim. Stok tetap terkunci; gudang belum memproses sampai dilepas.",
  "orders.holdHelp.combined": "TikTok mengirim order ini dalam satu paket bersama order lain (lihat \"Satu grup dengan\" di atas). Zerpid mengemas satu parcel per order, jadi order ini tidak masuk picking dan tidak bisa diatur kirim atau dicetak labelnya di sini. Kemas bersama, lalu kirim lewat Seller Center TikTok. Lepas tahan hanya kalau TikTok memberi order ini paket sendiri.",
  "orders.holdHelp.quota": "Kuota order paket bulan ini sudah habis. Stok belum dikunci; order diproses otomatis begitu kuota tersedia (upgrade di menu Langganan, atau bulan baru).",
  "orders.holdHelp.arrange_failed": "Marketplace menolak atau gagal memesan kurir. Gangguan sementara dicoba ulang otomatis.",
  "orders.holdFilter.all": "Semua order",
  "orders.holdFilter.any": "Tertahan ({n})",
  "orders.holdRules": "Aturan tahan",
  "orders.heldDone": "Order ditahan.",
  "orders.releasedDone": "Tahanan dilepas; order diproses.",
  "orders.movedDone": "Gudang diganti; order diproses ulang di gudang baru.",
  "orders.holdAction": "Tahan",
  "orders.holdActionHelp": "Order tidak diambil gudang sampai dilepas. Stok tetap terkunci.",
  "orders.holdNote": "Alasan (opsional)",
  "orders.moveWarehouse": "Ganti gudang",
  "orders.moveWarehouseHelp": "Kunci stok pindah ke gudang yang dipilih dan order diproses ulang di sana. Perubahan tercatat di log aktivitas.",
  "orders.release": "Lepas tahanan",
  "orders.retryArrange": "Coba atur kirim lagi",
  "orders.processAgain": "Proses ulang",
  "orders.heldSince": "sejak {at}",
  "orders.line.bundle": "Bundle",
  "orders.line.component": "Isi bundle",
  "orders.line.gift": "Hadiah",
  "orders.lineNote.gift_out_of_stock": "Hadiah habis; dikirim tanpa hadiah",
  "orders.warehouseSource.marketplace": "dari marketplace",
  "orders.warehouseSource.store": "gudang toko",
  "orders.warehouseSource.manual": "dipilih manual",
  "orders.rule.add": "Buat aturan",
  "orders.rule.edit": "Ubah aturan",
  "orders.rule.help": "Order yang cocok dengan aturan ditahan di status Baru dengan stok tetap terkunci, sampai dilepas dari detail order atau aturannya berakhir. Aturan berlaku untuk order yang diproses sejak aturan dibuat.",
  "orders.rule.empty": "Belum ada aturan tahan.",
  "orders.rule.conditions": "Syarat",
  "orders.rule.conditionsHelp": "Semua syarat yang diisi harus cocok.",
  "orders.rule.until": "Berlaku sampai",
  "orders.rule.untilHelp": "Setelah itu aturan berhenti dan order yang ditahan diproses.",
  "orders.rule.held": "Ditahan",
  "orders.rule.active": "Aktif",
  "orders.rule.delete": "Hapus aturan",
  "orders.rule.deleteConfirm": "Hapus aturan {name}? {n} order yang ditahannya akan diproses.",
  "orders.rule.saved": "Aturan disimpan.",
  "orders.rule.note": "Catatan di order",
  "orders.rule.noteHelp": "Tampil di order yang ditahan, mis. \"Verifikasi COD\".",
  "orders.rule.allOrders": "Semua order",
  "orders.rule.stores": "Toko",
  "orders.rule.platforms": "Marketplace",
  "orders.rule.payment": "Metode bayar",
  "orders.rule.paymentHelp": "Cocok bila metode bayar mengandung salah satu teks ini, mis. COD.",
  "orders.rule.minTotal": "Total minimal",
  "orders.rule.maxTotal": "Total maksimal",
  "orders.rule.minUnits": "Jumlah barang minimal",
  "orders.rule.minUnitsValue": "≥ {n} barang",
  "orders.rule.skus": "Berisi SKU",
  "orders.rule.skusHelp": "Cocok bila order berisi salah satu SKU ini.",
  "orders.rule.skuCount": "{n} SKU",
  "orders.rule.carriers": "Kurir",
  "orders.rule.orderedBefore": "Dipesan sebelum",
  "orders.rule.orderedBeforeHelp": "Untuk order lama, mis. order toko dari sebelum dihubungkan ke Zerpid (aturan ini dibuat otomatis saat toko baru dihubungkan).",
  "promo.title": "Promosi hadiah",
  "promo.add": "Buat promosi",
  "promo.edit": "Ubah promosi",
  "promo.help": "Hadiah dari penjual sendiri, diberikan sekali saat order diproses. Hadiah masuk ke order sebagai baris Rp0, ikut dikunci stoknya, di-pick, dan dikemas. Voucher dan diskon marketplace bukan bagian dari ini.",
  "promo.empty": "Belum ada promosi.",
  "promo.examplesTitle": "Contoh",
  "promo.examples": "Beli A dapat B: SKU dibeli A, hadiah B. · Beli 1 dapat 2: SKU dibeli A minimal 1, hadiah A ×2. · Belanja 100rb dapat X: total minimal 100.000, hadiah X. · Belanja 100rb dan ada Z dapat Y: total minimal 100.000, SKU wajib Z, hadiah Y.",
  "promo.conditionsHelp": "Semua syarat yang diisi harus cocok. Isi minimal satu: SKU dibeli, total minimal, atau SKU wajib.",
  "promo.buySkus": "SKU yang dibeli (salah satu)",
  "promo.buyMinQty": "Jumlah minimal",
  "promo.minTotal": "Total order minimal",
  "promo.requiredSkus": "SKU wajib ada",
  "promo.gift": "Hadiah",
  "promo.giftSku": "SKU hadiah",
  "promo.giftQty": "Jumlah",
  "promo.multiply": "Berlipat sesuai jumlah dibeli",
  "promo.perQty": "Setiap dibeli",
  "promo.perText": "per {n} dibeli",
  "promo.maxPerOrder": "Maks. per order",
  "promo.quota": "Kuota total",
  "promo.used": "Terpakai",
  "promo.whenOutLabel": "Bila hadiah habis",
  "promo.whenOut.skip": "Kirim tanpa hadiah (dicatat)",
  "promo.whenOut.hold": "Tahan order sampai hadiah ada",
  "promo.period": "Periode",
  "promo.always": "Tanpa batas waktu",
  "promo.priority": "Prioritas",
  "promo.priorityHelp": "Angka kecil dicek lebih dulu.",
  "promo.exclusive": "Eksklusif",
  "promo.exclusiveHelp": "Tidak digabung dengan promosi lain.",
  "promo.saved": "Promosi disimpan.",
  "promo.delete": "Hapus promosi",
  "promo.deleteConfirm": "Hapus promosi {name}? Hadiah yang sudah diberikan tetap ada di order.",
  "promo.buyText": "beli {n}× {skus}",
  "promo.spendText": "belanja ≥ {amount}",
  "promo.withText": "ada {skus}",
  "promo.storesText": "{n} toko",
  "orders.label": "Cetak label",
  "orders.printOriginal": "Cetak label asli marketplace",
  "orders.printOriginalHelp": "File dari marketplace tanpa tambahan resi besar. Pakai bila label tercetak tidak sesuai.",
  "orders.arrange": "Atur pengiriman",
  "orders.arrangeTitle": "Atur pengiriman · {number}",
  "orders.arrangeTitleBulk": "Atur pengiriman {n} order",
  "orders.arrangeBody": "Kurir dipesan di marketplace. Setelah itu nomor resi terbit dan label bisa dicetak.",
  "orders.method": "Serah ke kurir",
  "orders.method.pickup": "Dijemput kurir (pickup)",
  "orders.method.dropoff": "Antar sendiri ke titik drop-off",
  "orders.methodLazada": "Untuk order Lazada, cara serah mengikuti pengaturan toko di Seller Center.",
  "orders.methodBlibli": "Untuk order Blibli, cara serah mengikuti tipe pengiriman toko di Blibli: Dropship (paket diantar ke kurir) atau Pickup (kurir Blibli menjemput).",
  "orders.arranged": "Pengiriman diatur. Resi sudah terbit.",
  "orders.arrangedBulk": "Pengiriman {ok} order diatur.",
  "orders.arrangedPartial": "{ok} order diatur, {failed} gagal.",
  "orders.arrangeSelected": "Atur pengiriman ({n})",
  "orders.printSelected": "Cetak label ({n})",
  "orders.selectedCount": "{n} order dipilih",
  "orders.clearSelection": "Batal pilih",
  "orders.preparing": "Menyiapkan label {done} dari {total}…",
  "orders.preparingTitle": "Menyiapkan label",
  "orders.labelFailedTitle": "{n} label belum bisa dicetak",
  "orders.labelFailedBody": "Label lainnya siap. Perbaiki order di bawah, lalu cetak ulang.",
  "orders.printReady": "Cetak {n} label yang siap",
  "orders.printing": "Menyiapkan file cetak…",
  "orders.popupBlocked": "Browser memblokir jendela cetak. Izinkan pop-up untuk Zerpid, lalu coba lagi.",
  "orders.labelStatus": "Label",
  "orders.shipBy": "Batas kirim",
  "orders.shipBy.late": "Terlambat",
  "orders.shipBy.inHours": "{n} jam lagi",
  "orders.labelPrinted": "Dicetak {n}×",
  "orders.labelNotPrinted": "Belum dicetak",
  "orders.outside": "Di luar Zerpid",
  "orders.outsideHelp": "Dikirim lewat gudang atau sistem lain, tanpa diproses di Zerpid. Stok Zerpid tidak berubah.",
  "orders.outsideBody": "Order ini dikirim lewat gudang atau sistem lain, tanpa diproses di Zerpid, sehingga stok Zerpid tidak berubah. Bila barangnya diambil dari gudang Zerpid, koreksi stoknya lewat penyesuaian stok.",
  "orders.handled.all": "Semua penanganan",
  "orders.labelFilter.all": "Semua label",
  "orders.labelFilter.unprinted": "Label belum dicetak",
  "orders.labelFilter.printed": "Label sudah dicetak",
  "orders.lastPrinted": "Terakhir dicetak {at} oleh {name}",
  "orders.labelSourceZerpid": "Marketplace tidak menyediakan label untuk order ini; Zerpid membuat label dari data order.",
  "orders.parcel": "Paket gudang",
  "orders.parcelSuggested": "saran {code}",
  "orders.parcelPacked": "Dikemas",
  "orders.playVideo": "Putar video packing",
  "orders.videoKept": "Disimpan sampai {at}",
  "orders.noVideo": "Tidak ada video packing",
  "orders.trackingPending": "Resi terbit setelah pengiriman diatur.",
  "orders.trackParcel": "Lacak paket",
  "orders.trackingEmpty": "Kurir belum melaporkan perjalanan paket.",
  "orders.combinedTag": "Gabung kirim (TikTok)",
  "orders.combinedHelp": "TikTok menggabungkan order LIVE dari pembeli yang sama menjadi satu kiriman. Zerpid masih mengemas per order: cek dengan order lain di grup ini agar tidak dikemas dua kali, dan atur penggabungannya di Seller Center.",
  "orders.combinedWith": "Satu grup dengan:",
  "orders.splitTag": "Dipecah (TikTok)",
  "orders.splitHelp": "TikTok memecah order ini menjadi beberapa paket. Zerpid masih mengemas satu paket per order: atur pengirimannya di Seller Center.",
  "orders.money.title": "Rincian harga & potongan",
  "orders.money.show": "Lihat rincian",
  "orders.money.listPrice": "Harga normal",
  "orders.money.sellerDiscount": "Diskon dari toko",
  "orders.money.platformDiscount": "Diskon dari marketplace",
  "orders.money.shippingFee": "Ongkir",
  "orders.money.shippingSeller": "Subsidi ongkir dari toko",
  "orders.money.shippingPlatform": "Subsidi ongkir dari marketplace",
  "orders.money.tax": "Pajak",
  "orders.money.buyerPaid": "Dibayar pembeli",
  "orders.money.shippingCost": "Biaya ongkir",
  "orders.money.received": "Diterima toko",
  "orders.money.estimate": "Belum cair. Perkiraan diterima {amount}",
  "orders.money.estimateAt": "sekitar {at}.",
  "orders.money.notSettled": "Belum cair, dan marketplace belum memberi perkiraan.",
  "inventory.title": "Ringkasan stok",
  "inventory.search": "Cari kode, nama, atau barcode",
  "inventory.allWarehouses": "Semua gudang",
  "inventory.lowOnly": "Stok kritis saja ({n})",
  "inventory.onHand": "On hand",
  "inventory.allocated": "Alokasi",
  "inventory.available": "Tersedia",
  "inventory.pickWarehouse": "Pilih gudang untuk melihat bin, hold, dan pergerakannya.",
  "inventory.formula": "Tersedia = Layak jual − Selisih − Alokasi order − Alokasi lain. Angka Tersedia inilah yang dikirim ke semua toko yang menjual SKU ini. Stok Rusak dan Karantina tetap tercatat di On hand, tetapi tidak dijual.",
  "inventory.low": "Kritis",
  "inventory.empty": "Belum ada SKU. Tambahkan di Produk & Harga.",
  "inventory.adjust": "Penyesuaian stok",
  "inventory.adjustBody": "Masukkan jumlah fisik yang benar untuk kondisi yang dipilih. Selisihnya dicatat di riwayat pergerakan beserta alasan.",
  "inventory.newQty": "Jumlah fisik baru",
  "inventory.reason": "Alasan",
  "inventory.reasonPlaceholder": "Contoh: hasil hitung ulang rak A-01",
  "inventory.adjusted": "Stok diperbarui. Toko akan menerima jumlah terbaru dalam beberapa detik.",
  "inventory.levels": "Stok per gudang",
  "inventory.soldOn": "Dijual di",
  "inventory.soldOnEmpty": "Belum ada toko yang menjual SKU ini.",
  "inventory.platformStock": "Stok di marketplace",
  "inventory.lastPushed": "Terakhir dikirim",
  "inventory.pushError": "Gagal mengirim",
  "inventory.mapping": "Pemetaan",
  "inventory.mapping.auto_code": "Otomatis (kode sama)",
  "inventory.mapping.manual": "Manual",
  "inventory.movements": "Pergerakan stok",
  "inventory.movementsEmpty": "Belum ada pergerakan.",
  "inventory.delta": "Perubahan",
  "inventory.reason.count": "Hitung stok",
  "inventory.reason.count_loss": "Selisih dikonfirmasi: hilang",
  "inventory.reason.count_gain": "Selisih dikonfirmasi: ditemukan",
  "inventory.reason.variance_netoff": "Selisih saling hapus antar lot",
  "inventory.reason.short_pick": "Tidak ada di bin (picking)",
  "inventory.reason.picking": "Picking",
  "inventory.reason.packing": "Packing",
  "inventory.reason.unpacking": "Batal kemas",
  "inventory.reason.transfer": "Transfer",
  "inventory.reason.transfer_in": "Transfer masuk",
  "inventory.reason.transfer_out": "Transfer keluar",
  "inventory.reason.return": "Retur",
  "inventory.reason.shipment_correction": "Koreksi pengiriman",
  "inventory.reason.vendor_return": "Retur ke supplier",
  "inventory.reason.vendor_replacement": "Ganti dari supplier",
  "inventory.reason.adjustment": "Penyesuaian",
  "inventory.reason.shipment": "Pengiriman",
  "inventory.reason.inbound": "Penerimaan",
  "inventory.reason.condition_change": "Perubahan kondisi",
  "inventory.reason.putaway": "Putaway",
  "inventory.reason.bin_move": "Pindah lokasi",
  "inventory.reason.wms_started": "WMS diaktifkan",
  "inventory.reason.wms_stopped": "WMS dinonaktifkan",
  "inventory.bins": "Stok per lokasi",
  "inventory.bin.location": "Lokasi",
  "inventory.bin.lot": "Lot",
  "inventory.bin.expires": "Kedaluwarsa",
  "inventory.bin.reserved": "Dipesan tugas",
  "inventory.bin.adjust": "Hitung",
  "inventory.bin.move": "Pindah",
  "inventory.bin.adjustTitle": "Hitung ulang {code} di {location}",
  "inventory.bin.moveTitle": "Pindahkan {code} dari {location}",
  "inventory.bin.toLocation": "Ke lokasi",
  "inventory.bin.toCondition": "Kondisi di tujuan",
  "inventory.bin.saved": "Stok lokasi diperbarui.",
  "inventory.wmsHint": "Gudang ini memakai WMS: ubah stok per lokasi di detail stok.",
  "inventory.sellable": "Layak jual",
  "inventory.damaged": "Rusak",
  "inventory.quarantine": "Karantina",
  "inventory.allocatedOrder": "Alokasi order",
  "inventory.allocatedOther": "Alokasi lain",
  "inventory.variance": "Selisih",
  "inventory.varianceHelp": "Unit layak jual di lokasi SELISIH yang belum dikonfirmasi. Positif: tercatat tapi tidak ditemukan saat hitung, jadi tidak dijual. Negatif: ditemukan di rak tapi belum tercatat.",
  "inventory.allocatedOtherHelp": "Stok yang ditahan manual, menunggu transfer, atau menunggu retur ke supplier.",
  "inventory.condition": "Kondisi",
  "inventory.condition.sellable": "Layak jual",
  "inventory.condition.damaged": "Rusak",
  "inventory.condition.quarantine": "Karantina",
  "inventory.current": "Saat ini: {n}",
  "inventory.move": "Ubah kondisi",
  "inventory.moveBody": "Pindahkan unit antarkondisi tanpa mengubah On hand, misalnya unit ditemukan rusak, atau hasil QC barang karantina.",
  "inventory.from": "Dari",
  "inventory.to": "Ke",
  "inventory.quantity": "Jumlah",
  "inventory.note": "Catatan",
  "inventory.moveNotePlaceholder": "Contoh: kemasan sobek saat opname",
  "inventory.moved": "Kondisi stok diperbarui.",
  "inventory.hold": "Tahan stok",
  "inventory.holdBody": "Stok yang ditahan keluar dari Tersedia dan tidak dijual di marketplace sampai dilepas. Hanya stok Tersedia yang dapat ditahan.",
  "inventory.holdNotePlaceholder": "Contoh: pesanan B2B Toko Sinar, sesi live 20.00",
  "inventory.holdMax": "Maksimal {n} (stok Tersedia)",
  "inventory.held": "Stok ditahan. Toko akan menerima jumlah terbaru dalam beberapa detik.",
  "inventory.holds": "Alokasi lain",
  "inventory.holdsEmpty": "Tidak ada stok yang ditahan.",
  "inventory.incoming": "+{n} dalam perjalanan",
  "inventory.incomingHelp": "Transfer masuk: sudah dikirim dari gudang lain ke gudang ini tapi belum diterima. Belum termasuk stok maupun available.",
  "inventory.incomingTitle": "Transfer masuk",
  "inventory.toReturn": "+{n} retur",
  "inventory.toReturnHelp": "To-return: barang yang diharapkan kembali ke gudang ini dari kasus purna jual, belum diterima. Belum termasuk stok maupun available.",
  "inventory.toReturnTitle": "Retur yang ditunggu",
  "inventory.holdReason": "Jenis",
  "inventory.holdReason.hold": "Tahan manual",
  "inventory.holdReason.transfer": "Transfer keluar",
  "inventory.holdReason.vendor_return": "Retur ke supplier",
  "inventory.release": "Lepas",
  "inventory.releaseConfirm": "Lepas {n} unit kembali ke stok Tersedia?",
  "inventory.released": "Stok dilepas kembali ke Tersedia.",
  "inventory.since": "Sejak",
  "wms.pickWarehouse": "Gudang",
  "shell.activeWarehouse": "Gudang aktif",
  "shell.activeWarehouseHelp": "Gudang aktif: semua layar Gudang bekerja di gudang ini.",
  "wms.activeNoWms": "Gudang aktif ({name}) belum memakai WMS. Ganti gudang aktif di atas, atau aktifkan WMS di Pengaturan > Gudang.",
  "wms.noWmsWarehouse": "Belum ada gudang dengan WMS aktif. Aktifkan di Pengaturan > Gudang.",
  "wms.openSettings": "Buka Pengaturan Gudang",
  "wms.scanPlaceholder": "Scan atau ketik kode, lalu Enter",
  "wms.loc.title": "Lokasi",
  "wms.loc.add": "Tambah lokasi",
  "wms.loc.bulk": "Buat massal",
  "wms.loc.bulkTitle": "Buat lokasi massal",
  "wms.loc.bulkBody": "Setiap kombinasi rak × level × bin di zona ini dibuat dengan kode ZONA-RAK-LEVEL-BIN, mis. A-01-02-03. Kode yang sudah ada dilewati.",
  "wms.loc.bulkCount": "{n} lokasi akan dibuat",
  "wms.loc.bulkDone": "{created} lokasi dibuat, {skipped} sudah ada.",
  "wms.loc.zone": "Zona",
  "wms.loc.rack": "Rak",
  "wms.loc.level": "Level",
  "wms.loc.bin": "Bin",
  "wms.loc.from": "Dari",
  "wms.loc.to": "Sampai",
  "wms.loc.code": "Kode lokasi",
  "wms.loc.codeHelp": "Kosongkan untuk memakai ZONA-RAK-LEVEL-BIN.",
  "wms.loc.kind": "Jenis",
  "wms.loc.kind.storage": "Rak simpan",
  "wms.loc.kind.receiving": "Penerimaan",
  "wms.loc.kind.returns": "Retur",
  "wms.loc.kind.packing": "Packing",
  "wms.loc.kind.outbound": "Kirim",
  "wms.loc.kind.damaged": "Rusak",
  "wms.loc.kind.quarantine": "Karantina",
  "wms.loc.kind.variance": "Selisih",
  "wms.loc.system": "Sistem",
  "wms.loc.units": "Unit",
  "wms.loc.skus": "SKU",
  "wms.loc.empty": "Belum ada lokasi.",
  "wms.loc.search": "Cari kode lokasi",
  "wms.loc.contents": "Isi lokasi {code}",
  "wms.loc.contentsEmpty": "Lokasi ini kosong.",
  "wms.loc.archive": "Arsipkan",
  "wms.loc.restore": "Aktifkan",
  "wms.loc.created": "Lokasi dibuat.",
  "wms.in.title": "Penerimaan",
  "wms.in.add": "Buat penerimaan",
  "wms.in.number": "No. penerimaan",
  "wms.in.supplier": "Pemasok",
  "wms.in.reference": "Referensi (surat jalan / PO)",
  "wms.in.note": "Catatan",
  "wms.in.lines": "Barang yang diharapkan",
  "wms.in.addLine": "Tambah barang",
  "wms.in.expected": "Diharapkan",
  "wms.in.unitCost": "Harga beli/unit",
  "wms.in.unitCostHelp": "Opsional. Harga beli per unit dari supplier, untuk menghitung HPP nanti. Hanya terlihat oleh manajer gudang.",
  "wms.in.received": "Diterima",
  "wms.in.difference": "Selisih",
  "wms.in.status.open": "Menunggu",
  "wms.in.status.receiving": "Diterima sebagian",
  "wms.in.status.done": "Selesai",
  "wms.in.status.cancelled": "Dibatalkan",
  "wms.in.empty": "Belum ada penerimaan.",
  "wms.in.scanTitle": "Terima barang",
  "wms.in.scanHelp": "Scan SKU atau barcode. Barang masuk ke lokasi TERIMA, lalu disimpan lewat tugas putaway.",
  "wms.in.quantity": "Jumlah",
  "wms.in.lotNo": "No. lot",
  "wms.in.expiresOn": "Kedaluwarsa",
  "wms.in.serials": "Nomor seri",
  "wms.in.serialsHelp": "Scan setiap unit. {n} ter-scan.",
  "wms.in.receive": "Terima",
  "wms.in.received1": "{qty} × {code} diterima.",
  "wms.in.complete": "Selesaikan penerimaan",
  "wms.in.completeConfirm": "Selesaikan penerimaan {number}? Selisih jumlah dicatat dan tugas putaway dibuat.",
  "wms.in.completed": "Penerimaan selesai. Tugas putaway dibuat.",
  "wms.in.cancel": "Batalkan",
  "wms.in.openPutaway": "Buka tugas putaway",
  "wms.task.title.putaway": "Putaway",
  "wms.task.title.picking": "Picking",
  "wms.task.number": "No. tugas",
  "wms.task.status.open": "Menunggu",
  "wms.task.status.in_progress": "Dikerjakan",
  "wms.task.status.done": "Selesai",
  "wms.task.status.cancelled": "Dibatalkan",
  "wms.task.progress": "Progres",
  "wms.task.assigned": "Petugas",
  "wms.task.empty": "Tidak ada tugas.",
  "wms.task.openOnly": "Hanya yang terbuka",
  "wms.task.fromReceiving": "Buat tugas dari lokasi TERIMA",
  "wms.task.fromPacking": "Kembalikan dari PACKING",
  "wms.task.fromOutbound": "Kembalikan dari KIRIM",
  "wms.task.source": "Asal",
  "wms.task.source.receiving": "TERIMA",
  "wms.task.source.inbound": "Penerimaan",
  "wms.task.source.packing": "Dari PACKING",
  "wms.task.source.outbound": "Dari KIRIM",
  "wms.task.source.transfer": "Transfer masuk",
  "wms.task.source.move": "Pindah lokasi",
  "wms.move.title": "Tugas pindah",
  "wms.move.create": "Buat tugas",
  "wms.move.help": "Pilih lokasi asal, isi jumlah yang dipindah per barang, dan (opsional) lokasi tujuan. Unit dikunci di bin asal sampai staf memindahkannya dengan scan, seperti putaway. Contoh: mengisi rak picking dari rak cadangan, mengosongkan bin.",
  "wms.move.from": "Dari lokasi",
  "wms.move.to": "Ke lokasi",
  "wms.move.toHelp": "Kosongkan agar sistem menyarankan bin yang sudah berisi SKU itu.",
  "wms.move.suggested": "Disarankan sistem",
  "wms.move.empty": "Tidak ada unit bebas di lokasi ini.",
  "wms.move.free": "Bebas",
  "wms.move.qty": "Pindahkan",
  "wms.task.start": "Mulai",
  "wms.task.cancel": "Batalkan tugas",
  "wms.task.cancelConfirm": "Batalkan tugas {number}? Barang yang belum dipindah dilepas kembali di lokasinya.",
  "wms.task.from": "Dari",
  "wms.task.suggested": "Saran",
  "wms.task.to": "Bin tujuan",
  "wms.task.confirm": "Simpan",
  "wms.task.lineDone": "Selesai",
  "wms.task.saved": "Tersimpan di {code}.",
  "wms.task.allDone": "Tugas selesai.",
  "wms.count.title": "Hitung stok",
  "wms.count.add": "Buat hitung stok",
  "wms.count.start": "Mulai hitung",
  "wms.count.empty": "Belum ada hitung stok.",
  "wms.count.kind": "Jenis",
  "wms.count.kind.full": "Stock opname",
  "wms.count.kind.cycle": "Cycle count",
  "wms.count.fullHelp": "Semua lokasi gudang dihitung (boleh dibatasi per zona). Lokasi dibekukan sampai masing-masing selesai dihitung.",
  "wms.count.cycleHelp": "Sebagian gudang: per zona, lokasi tertentu, SKU tertentu, atau lokasi yang lama tidak dihitung.",
  "wms.count.zones": "Zona",
  "wms.count.zonesHelp": "Kosongkan untuk semua zona.",
  "wms.count.allZones": "Semua zona",
  "wms.count.locations": "Lokasi",
  "wms.count.anyLocation": "Semua lokasi yang cocok",
  "wms.count.skus": "Hanya SKU",
  "wms.count.skusHelp": "Hanya lokasi yang menyimpan SKU ini, dan hanya SKU ini yang dibandingkan.",
  "wms.count.notCountedDays": "Belum dihitung sejak (hari)",
  "wms.count.notCountedDaysHelp": "Mis. 30: hanya lokasi yang terakhir dihitung lebih dari 30 hari lalu.",
  "wms.count.blind": "Hitung buta",
  "wms.count.blindHelp": "Penghitung tidak melihat angka sistem, jadi hasilnya tidak terpengaruh.",
  "wms.count.freezeNote": "Lokasi yang masuk hitung ini tidak bisa dipicking, di-putaway, atau diubah manual sampai selesai dihitung.",
  "wms.count.progress": "Lokasi dihitung",
  "wms.count.difference": "Selisih",
  "wms.count.createdBy": "Dibuat oleh",
  "wms.count.createdAt": "Dibuat",
  "wms.count.status.open": "Berjalan",
  "wms.count.status.done": "Selesai",
  "wms.count.status.cancelled": "Dibatalkan",
  "wms.count.loc.pending": "Belum dihitung",
  "wms.count.loc.counted": "Sudah dihitung",
  "wms.count.loc.skipped": "Dilewati",
  "wms.count.frozen": "Sedang dihitung",
  "wms.count.scanLocation": "Pilih lokasi",
  "wms.count.scanLocationHelp": "Scan kode lokasi di rak, atau klik lokasi di daftar.",
  "wms.count.counting": "Menghitung {code}",
  "wms.count.scanItems": "Scan setiap barang (setiap hasil scan menambah 1), atau ubah jumlahnya di tabel. Untuk SKU berseri, scan setiap unit.",
  "wms.count.notInCount": "Lokasi {code} tidak termasuk hitung ini.",
  "wms.count.alreadyCounted": "Lokasi {code} sudah dihitung.",
  "wms.count.round": "Ronde {n}",
  "wms.count.roundCol": "Ronde",
  "wms.count.books": "Menurut sistem",
  "wms.count.booksEmpty": "Kosong",
  "wms.count.nothingYet": "Belum ada barang di-scan.",
  "wms.count.scanSerials": "Scan nomor seri setiap unit",
  "wms.count.newLot": "Lot baru…",
  "wms.count.submit": "Kirim hasil hitung",
  "wms.count.empty1": "Lokasi kosong",
  "wms.count.submitConfirm": "Kirim hasil hitung {code} ({n} baris)? Selisih dengan sistem dipindah ke lokasi SELISIH, belum dicatat sebagai kerugian atau keuntungan.",
  "wms.count.emptyConfirm": "Catat {code} sebagai kosong? Semua stok yang tercatat di sana dipindah ke lokasi SELISIH.",
  "wms.count.submitted": "Hasil hitung {code} terkirim.",
  "wms.count.close": "Tutup hitung",
  "wms.count.closeConfirm": "{n} lokasi belum dihitung akan dilewati dan dilepas. Lanjutkan?",
  "wms.count.cancel": "Batalkan",
  "wms.count.toVariance": "{short} unit masuk ke SELISIH (tidak ditemukan) dan {over} unit keluar dari SELISIH (ditemukan). Konfirmasi di Gudang > Selisih.",
  "wms.count.countedBy": "Dihitung oleh",
  "wms.count.recount": "Hitung ulang",
  "wms.count.results": "Hasil per lokasi",
  "wms.count.system": "Sistem",
  "wms.count.counted": "Dihitung",
  "wms.var.title": "Selisih stok",
  "wms.var.help": "Selisih dari hitung stok menunggu di lokasi SELISIH dan belum tercatat sebagai kerugian atau keuntungan. Yang tidak ditemukan tidak dijual. Konfirmasi untuk membukukannya: tidak ditemukan menjadi kerugian, ditemukan menjadi keuntungan.",
  "wms.var.missing": "Tidak ditemukan (unit)",
  "wms.var.found": "Ditemukan lebih (unit)",
  "wms.var.empty": "Tidak ada selisih yang menunggu.",
  "wms.var.quantity": "Selisih",
  "wms.var.missingN": "Hilang {n}",
  "wms.var.foundN": "Ditemukan {n}",
  "wms.var.serials": "Nomor seri",
  "wms.var.lastAt": "Terakhir berubah",
  "wms.var.netOff": "Net-kan antar lot",
  "wms.var.netted": "{n} unit di-net antar lot.",
  "wms.var.confirm": "Konfirmasi ({n})",
  "wms.var.confirmTitle": "Konfirmasi selisih",
  "wms.var.confirmOk": "Bukukan",
  "wms.var.confirmBody": "{loss} unit dibukukan sebagai kerugian dan {gain} unit sebagai keuntungan. On hand berubah sesuai angka ini.",
  "wms.var.reasonPlaceholder": "Mis. Opname Oktober, disetujui kepala gudang",
  "wms.var.confirmed": "Dibukukan: kerugian {loss}, keuntungan {gain}.",
  "wms.pool.title": "Pool order",
  "wms.pool.add": "Tambah pool",
  "wms.pool.editTitle": "Ubah pool {name}",
  "wms.pool.saved": "Pool disimpan.",
  "wms.pool.deleteConfirm": "Hapus pool {name}? Ordernya pindah ke pool berikutnya yang cocok.",
  "wms.pool.other": "Lainnya",
  "wms.pool.otherHelp": "Order yang tidak cocok dengan pool mana pun",
  "wms.pool.inactive": "Nonaktif",
  "wms.pool.name": "Pool",
  "wms.pool.priority": "Prioritas",
  "wms.pool.priorityHelp": "Angka kecil diperiksa dulu. Order masuk ke pool pertama yang semua aturannya cocok.",
  "wms.pool.active": "Aktif",
  "wms.pool.method": "Metode",
  "wms.pool.orders": "Order",
  "wms.pool.units": "{n} pcs",
  "wms.pool.split": "Pembagian",
  "wms.pool.overdue": "{n} terlambat",
  "wms.pool.dueSoon": "{n} < 24 jam",
  "wms.pool.viewOrders": "Lihat order",
  "wms.pool.blocked": "{n} order terbuka belum bisa masuk wave: SKU belum terpetakan atau stok belum dialokasikan.",
  "wms.pool.help": "Pool dihitung ulang setiap saat dari order terbuka. Order baru atau aturan yang diubah langsung terlihat.",
  "wms.pool.rules": "Aturan",
  "wms.pool.rulesHelp": "Semua aturan yang diisi harus cocok. Kosongkan untuk tidak membatasi.",
  "wms.pool.any": "Semua",
  "wms.pool.shipWithin": "Batas kirim dalam",
  "wms.pool.shipWithinHelp": "0 = hanya yang sudah terlambat.",
  "wms.pool.hours": "jam",
  "wms.pool.platforms": "Marketplace",
  "wms.pool.stores": "Toko",
  "wms.pool.skus": "SKU",
  "wms.pool.skuAny": "Order berisi salah satu SKU ini",
  "wms.pool.skuOnly": "Order hanya berisi SKU ini",
  "wms.pool.shapes": "Bentuk order",
  "wms.pool.shape.single_pcs": "1 pcs",
  "wms.pool.shape.single_sku": "1 SKU, banyak pcs",
  "wms.pool.shape.multi_sku": "Multi SKU",
  "wms.pool.maxUnits": "Maks. pcs per order",
  "wms.pool.waves": "Wave",
  "wms.pool.cartSlots": "Order per tugas cluster",
  "wms.pool.cartSlotsHelp": "Berapa order dikerjakan sekaligus dalam satu tugas cluster: satu tote per order, atau satu slot cart per order.",
  "wms.pool.batchMin": "Min. order per batch",
  "wms.pool.batchMinHelp": "Batch dibuat bila ada sekian order dengan isi identik.",
  "wms.pool.maxOrders": "Maks. order per wave",
  "wms.pool.rule.late": "Terlambat",
  "wms.pool.rule.within": "Kirim ≤ {n} jam",
  "wms.pool.rule.stores": "{n} toko",
  "wms.pool.rule.skus": "Berisi {n} SKU",
  "wms.pool.rule.skusOnly": "Hanya {n} SKU",
  "wms.pool.rule.maxUnits": "≤ {n} pcs",
  "wms.pool.rule.none": "Semua order",
  "wms.method.auto": "Auto",
  "wms.method.autoHelp": "Single-pcs dulu, lalu batch untuk order berisi identik, sisanya cluster.",
  "wms.method.single": "Single-pcs",
  "wms.method.singleHelp": "Order 1 pcs, SKU apa saja. Diambil sekaligus; di meja packing, scan barang langsung keluar label.",
  "wms.method.batch": "Batch",
  "wms.method.batchHelp": "Order dengan isi identik (SKU dan qty sama) dari banyak pembeli: satu kali ambil untuk semua.",
  "wms.method.cluster": "Cluster",
  "wms.method.transfer": "Transfer",
  "wms.method.clusterHelp": "Order campuran. Satu tugas mengisi beberapa order sekaligus: satu tote per order (pick and seed), atau satu slot cart per order.",
  "wms.wave.title": "Wave",
  "wms.wave.empty": "Belum ada wave.",
  "wms.wave.release": "Rilis wave",
  "wms.wave.releaseTitle": "Rilis wave · {pool}",
  "wms.wave.releaseBody": "{n} order menunggu di pool ini. Stoknya dikunci di rak (FEFO, jalur terpendek) dan tugas picking dibuat.",
  "wms.wave.maxOrdersHelp": "Batas kirim terdekat diambil dulu.",
  "wms.wave.skipped": "{n} order dilewati",
  "wms.wave.status.open": "Berjalan",
  "wms.wave.status.done": "Selesai",
  "wms.wave.status.cancelled": "Dibatalkan",
  "wms.wave.picked": "Terpick",
  "wms.wave.tasks": "Tugas picking",
  "wms.wave.orders": "Order ({n})",
  "wms.wave.units": "Pcs",
  "wms.wave.slot": "Slot {n}",
  "wms.wave.cancel": "Batalkan wave",
  "wms.wave.cancelConfirm": "Batalkan {number}? Order yang belum selesai dipick kembali ke pool, dan barang yang sudah dipick untuknya menunggu di PACKING untuk dikembalikan ke rak. Order yang sudah lengkap dipick atau sudah dikemas tetap di wave untuk dikemas dan dikirim.",
  "wms.wave.order.picking": "Dipicking",
  "wms.wave.order.picked": "Terpick",
  "wms.wave.order.packed": "Dikemas",
  "wms.wave.order.shipped": "Dikirim",
  "wms.wave.order.removed": "Keluar",
  "wms.wave.note.short": "stok rak kurang",
  "wms.wave.note.order_changed": "order berubah/batal",
  "wms.wave.note.wave_cancelled": "wave dibatalkan",
  "wms.wave.note.task_cancelled": "tugas picking dibatalkan",
  "wms.pick.title": "Baris {n} dari {total}",
  "wms.pick.stepBin": "Bin",
  "wms.pick.stepItem": "Barang",
  "wms.pick.stepQty": "Jumlah",
  "wms.pick.goTo": "Ke lokasi",
  "wms.pick.take": "Ambil",
  "wms.pick.slots": "Masukkan ke (scan kodenya):",
  "wms.pick.confirm": "Ambil",
  "wms.pick.saved": "{code} diambil.",
  "wms.pick.short": "Tidak ada di bin",
  "wms.pick.shortConfirm": "{n} pcs {code} tidak ada di {bin}? Unit itu dipindah ke SELISIH dan dicari di bin lain. Order yang tidak bisa dipenuhi keluar dari wave.",
  "wms.pick.skip": "Lewati dulu",
  "wms.pick.wrongBin": "Bukan bin ini. Ke {code}.",
  "wms.pick.wrongItem": "Barang salah. Ambil {code}.",
  "wms.pick.for": "Untuk",
  "wms.paper.title": "Picking tanpa PDA",
  "wms.paper.help": "Cetak picklist (urutan lokasi, jumlah, dan ordernya), lalu input hasil yang ditulis picker di kertas.",
  "wms.paper.print": "Cetak picklist",
  "wms.paper.enter": "Input hasil kertas",
  "wms.paper.enterTitle": "Hasil picklist {number}",
  "wms.paper.enterHelp": "Isi jumlah yang diambil per lokasi. Bila kurang, sisanya dicatat tidak ada di bin dan dicari di bin lain (baris baru di tugas ini).",
  "wms.paper.asked": "Diminta",
  "wms.paper.taken": "Diambil",
  "wms.paper.short": "Kurang {n}",
  "wms.paper.scanSerial": "Scan serial",
  "wms.paper.bySlot": "Tugas ini memakai troli atau tote per order: tiap pick harus scan slotnya, jadi catat lewat scan.",
  "wms.paper.save": "Simpan hasil",
  "wms.paper.saved": "{n} lokasi dicatat.",
  "wms.paper.failed": "{n} lokasi gagal dicatat",
  "wms.pick.forOrders": "{n} order",
  "wms.pkg.title": "Kemasan",
  "wms.pkg.add": "Tambah kemasan",
  "wms.pkg.edit": "Ubah kemasan",
  "wms.pkg.saved": "Kemasan disimpan.",
  "wms.pkg.help": "Kardus dan polymailer yang tersedia di gudang ini. Meja packing menyarankan kemasan terkecil yang muat: setiap barang muat dengan diputar ke arah mana pun, total volume maksimal 85% dari kemasan, dan berat di bawah batas.",
  "wms.pkg.empty": "Belum ada kemasan. Tanpa kemasan, meja packing tidak bisa memberi saran.",
  "wms.pkg.none": "Belum ada kemasan di gudang ini, jadi tidak ada saran kardus.",
  "wms.pkg.code": "Kode",
  "wms.pkg.kind": "Jenis",
  "wms.pkg.kind.box": "Kardus",
  "wms.pkg.kind.mailer": "Polymailer / amplop",
  "wms.pkg.inside": "Ukuran dalam (mm)",
  "wms.pkg.insideHelp": "Panjang × lebar × tinggi ruang di dalam kemasan.",
  "wms.pkg.maxWeight": "Berat maks.",
  "wms.pkg.maxWeightHelp": "Kosongkan bila tidak dibatasi.",
  "wms.pkg.ownWeight": "Berat kemasan",
  "wms.pkg.deleteConfirm": "Hapus kemasan {code}? Paket yang sudah dikemas tetap mencatat kodenya.",
  "wms.pkg.printBarcodes": "Cetak barcode",
  "wms.pkg.printThermal": "Label 100×150 (3 per label)",
  "wms.pkg.printA4": "Kertas A4 (14 per lembar)",
  "wms.pack.title": "Packing",
  "wms.pack.awaitingHandover": "Menunggu serah terima: {n}",
  "wms.pack.modeSingle": "Single-pcs (scan langsung kemas)",
  "wms.pack.modeOrder": "Per order (batch, cluster)",
  "wms.pack.queue": "Wave berjalan",
  "wms.pack.queueEmpty": "Tidak ada wave yang berjalan.",
  "wms.pack.queueHelp": "Siap = order yang sudah terpick dan menunggu dikemas. Pilih wave untuk membatasi meja ke wave itu.",
  "wms.pack.wave": "Wave",
  "wms.pack.ready": "Siap",
  "wms.pack.pickWave": "Pilih wave di kiri untuk mulai mengemas per order.",
  "wms.pack.singleAll": "Single-pcs · semua wave",
  "wms.pack.singleInWave": "Single-pcs · {number}",
  "wms.pack.singleHelp": "Scan satu barang (kode, barcode, atau nomor seri). Sistem memilih order 1 pcs yang membutuhkannya dengan batas kirim terdekat, mengemasnya, lalu mencetak label.",
  "wms.pack.singleHelpBox": "Scan tote, lalu barang, lalu kemasan. Scan kemasan menutup paket: sistem memilih order 1 pcs yang membutuhkan barang itu (batas kirim terdekat), mengemasnya dengan kemasan tersebut, lalu mencetak label.",
  "wms.pack.scanBox": "Scan barcode kemasan",
  "wms.pack.scanBoxFirst": "Scan barcode kemasan untuk menutup paket.",
  "wms.pack.boxNeeded": "belum di-scan",
  "wms.pack.boxSuggestedEach": "saran sistem per paket (scan barcode kemasan untuk memakai satu jenis terus)",
  "wms.pack.promptBox": "Semua barang lengkap. Scan barcode kemasan, atau tekan Enter untuk memakai saran {code}.",
  "wms.pack.promptBoxNoSuggestion": "Semua barang lengkap. Scan barcode kemasan, atau tekan Enter untuk menutup tanpa kemasan terdaftar.",
  "wms.pack.promptBoxRequired": "Semua barang lengkap. Scan barcode kemasan yang dipakai untuk menutup paket.",
  "wms.pack.boxByScan": "dipilih dengan scan",
  "wms.pack.scanned": "Di-scan",
  "wms.pack.scanItem": "Scan barang",
  "wms.pack.scanOrder": "Scan nomor order atau nomor slot",
  "wms.pack.recent": "Baru dikemas",
  "wms.pack.box": "Kemasan",
  "wms.pack.noBox": "Tanpa kemasan terdaftar",
  "wms.pack.reprint": "Cetak ulang label",
  "wms.pack.labelFailed": "Label {number} belum bisa dicetak.",
  "wms.pack.noSize": "Tanpa ukuran: {codes}.",
  "wms.pack.noWeight": "Tanpa berat: {codes}.",
  "wms.pack.ordersOf": "Order di {number}",
  "wms.pack.readyCount": "{n} order siap dikemas",
  "wms.pack.next": "Order berikutnya",
  "wms.pack.notReady": "{code} bukan order yang siap dikemas di wave ini.",
  "wms.pack.notPicked": "Order ini belum selesai dipick.",
  "wms.pack.checked": "Diperiksa",
  "wms.pack.serialTwice": "Nomor seri {serial} sudah di-scan.",
  "wms.pack.notInOrder": "{code} tidak ada di order ini.",
  "wms.pack.scanSerial": "{code}: sekarang scan IMEI / nomor serinya.",
  "wms.pack.tooMany": "{code} sudah lengkap.",
  "wms.pack.weight": "berat barang {g} g",
  "wms.pack.suggested": "Saran",
  "wms.pack.reason.too_small": "{code} tidak muat",
  "wms.pack.reason.volume": "Volume tidak cukup",
  "wms.pack.reason.weight": "Terlalu berat",
  "wms.pack.nothingFits": "Tidak ada kemasan yang muat. Pilih yang paling mendekati atau tambahkan kemasan baru.",
  "wms.pack.close": "Selesai kemas & cetak label",
  "wms.pack.restart": "Scan ulang",
  "wms.pack.unpack": "Batal kemas",
  "wms.pack.unpackConfirm": "Buka lagi paket {number}? Barangnya kembali ke meja packing (tetap terkunci untuk order ini) dan order menunggu dikemas ulang. Label yang sudah dicetak tetap berlaku untuk order ini. Hanya di Zerpid: status di marketplace (resi, siap kirim) tidak berubah.",
  "wms.pack.unpacked": "Paket {number} dibuka lagi.",
  "wms.video.noCamera": "Kamera tidak bisa dipakai",
  "wms.video.noCameraHelp": "Gudang ini merekam packing, tapi browser belum mendapat izin kamera atau tidak ada kamera terpasang. Izinkan kamera untuk situs ini lalu muat ulang halaman. Packing tetap bisa berjalan tanpa video.",
  "wms.video.standby": "Siap merekam",
  "wms.video.starting": "Menyalakan kamera…",
  "wms.video.help": "Setiap paket direkam dari order dibuka sampai paket ditutup, lalu diunggah otomatis.",
  "wms.video.uploading": "Mengunggah {n} video…",
  "wms.video.failed": "{n} video gagal diunggah.",
  "wms.video.retry": "Ulangi {number}",
  "wms.video.unrecordedTitle": "Paket ini tidak akan terekam",
  "wms.video.notReady": "Perekam belum siap.",
  "wms.video.unrecordedHelp": "Tetap packing? Pertanyaan ini tidak muncul lagi sampai perekam siap.",
  "wms.video.packAnyway": "Tetap packing",
  "wms.desk.title": "Meja packing",
  "wms.desk.help": "Packing dengan PDA dimulai dengan scan QR meja, sehingga setiap paket mencatat meja dan jam mulai–selesai packing: cari videonya di CCTV meja itu.",
  "wms.desk.add": "Tambah meja",
  "wms.desk.edit": "Ubah meja",
  "wms.desk.code": "Kode",
  "wms.desk.codeHelp": "Tercetak di QR meja, mis. MEJA-01.",
  "wms.desk.name": "Nama",
  "wms.desk.active": "Dipakai",
  "wms.desk.inactive": "Tidak dipakai",
  "wms.desk.empty": "Belum ada meja.",
  "wms.desk.printQr": "Cetak QR meja",
  "wms.desk.deleteConfirm": "Hapus meja {code}? Paket yang dikemas di sana tetap menyimpan namanya.",
  "wms.desk.packedAt": "Meja & jam",
  "wms.video.singleLabel": "Meja single-pcs",
  "wms.pack.packed": "{number} dikemas.",
  "wms.mf.title": "Serah terima",
  "wms.mf.add": "Buat serah terima",
  "wms.mf.start": "Mulai serah terima",
  "wms.mf.waiting": "Paket menunggu kurir",
  "wms.mf.noCarrier": "Tanpa kurir",
  "wms.mf.parcelsUnit": "paket",
  "wms.mf.empty": "Belum ada serah terima.",
  "wms.mf.parcels": "Paket",
  "wms.mf.parcelsCount": "Paket ({n})",
  "wms.mf.courier": "Nama kurir",
  "wms.mf.handedAt": "Diserahkan",
  "wms.mf.carrierHelp": "Hanya paket untuk kurir ini yang bisa di-scan ke serah terima ini.",
  "wms.mf.status.open": "Berjalan",
  "wms.mf.status.done": "Diserahkan",
  "wms.mf.status.cancelled": "Dibatalkan",
  "wms.mf.cancel": "Batalkan serah terima",
  "wms.mf.cancelConfirm": "Batalkan {number}? Paketnya tetap dikemas dan bisa masuk serah terima lain.",
  "wms.mf.confirm": "Konfirmasi serah terima ({n})",
  "wms.mf.confirmTitle": "Serahkan {number}",
  "wms.mf.confirmBody": "{n} paket diserahkan ke kurir {carrier}. Stoknya keluar dari gudang dan order menjadi Dikirim.",
  "wms.mf.confirmOk": "Serahkan",
  "wms.mf.handed": "{n} paket diserahkan.",
  "wms.mf.handedSummary": "Diserahkan ke {courier} oleh {by}, {at}.",
  "wms.mf.print": "Cetak",
  "wms.mf.scanHelp": "Scan resi (atau nomor order) setiap paket {carrier} saat dinaikkan ke kendaraan kurir.",
  "wms.mf.scanPlaceholder": "Scan resi",
  "wms.mf.scanned": "{code} masuk.",
  "wms.mf.tracking": "Resi",
  "wms.mf.weight": "Berat",
  "wms.mf.remove": "Keluarkan",
  "wms.tr.title": "Transfer antar gudang",
  "wms.tr.add": "Buat transfer",
  "wms.tr.create": "Buat & kunci stok",
  "wms.tr.needTwo": "Transfer butuh minimal dua gudang aktif. Tambahkan gudang di Pengaturan > Gudang.",
  "wms.tr.allWarehouses": "Semua gudang",
  "wms.tr.out": "Keluar",
  "wms.tr.in": "Masuk",
  "wms.tr.empty": "Belum ada transfer.",
  "wms.tr.route": "Dari → ke",
  "wms.tr.unitsCol": "Pcs · dikirim · diterima",
  "wms.tr.unitsHelp": "Stok transfer yang sudah dikirim tapi belum diterima adalah stok dalam perjalanan: sudah keluar dari gudang asal, belum masuk ke gudang tujuan.",
  "wms.tr.from": "Dari gudang",
  "wms.tr.to": "Ke gudang",
  "wms.tr.reserveHelp": "Stok langsung dikunci di gudang asal (tidak dijual lagi di marketplace dari gudang itu). Gudang asal ber-WMS mendapat tugas picking.",
  "wms.tr.status.picking": "Dipicking",
  "wms.tr.status.ready": "Siap kirim",
  "wms.tr.status.shipped": "Dalam perjalanan",
  "wms.tr.status.receiving": "Diterima sebagian",
  "wms.tr.status.done": "Selesai",
  "wms.tr.status.cancelled": "Dibatalkan",
  "wms.tr.step.pick": "Picking",
  "wms.tr.step.reserve": "Stok dikunci",
  "wms.tr.step.ship": "Kirim",
  "wms.tr.step.receive": "Terima",
  "wms.tr.step.done": "Selesai",
  "wms.tr.cancel": "Batalkan transfer",
  "wms.tr.cancelConfirm": "Batalkan {number}? Stok yang dikunci dilepas. Barang yang sudah dipick menunggu di PACKING untuk dikembalikan ke rak.",
  "wms.tr.openTask": "Buka tugas picking {number}",
  "wms.tr.ship": "Kirim",
  "wms.tr.shipBody": "Barang keluar dari gudang asal dan menjadi stok dalam perjalanan ke {to}.",
  "wms.tr.shipNote": "Kendaraan, sopir, atau nomor resi (opsional)",
  "wms.tr.shipped1": "{number} dikirim.",
  "wms.tr.shippedSummary": "Dikirim oleh {by}, {at}",
  "wms.tr.completeShortWms": "Barang yang tidak sampai dibukukan ke SELISIH di gudang tujuan, lalu dikonfirmasi di Gudang > Selisih (hilang) atau di-net-off bila ditemukan.",
  "wms.tr.shortBooked": "{n} di SELISIH",
  "wms.tr.shortBookedHelp": "Tidak sampai. Dibukukan ke SELISIH gudang tujuan; konfirmasi di Gudang > Selisih.",
  "wms.tr.complete": "Selesai terima",
  "wms.tr.count": "Hitung",
  "wms.tr.counted1": "{qty} × {code} dihitung. Stok dibukukan saat Selesai terima.",
  "wms.tr.overHint": "Melebihi kiriman: sisa {left}, lebih {over}. Periksa lagi sebelum menghitung.",
  "wms.tr.overTitle": "Terima lebih dari kiriman?",
  "wms.tr.overBody": "{code}: sisa kiriman {left}, Anda menghitung {qty}. Lebih {over} unit akan dibukukan sebagai barang ditemukan di gudang ini saat transfer selesai, dan tercatat di transfer dan log aktivitas.",
  "wms.tr.overOk": "Ya, hitung {n}",
  "wms.tr.overTag": "Lebih",
  "wms.tr.scansTitle": "Hasil hitung (belum dibukukan)",
  "wms.tr.scansHelp": "Salah scan atau terhitung dua kali? Batalkan barisnya, lalu scan ulang. Stok baru dibukukan saat Selesai terima.",
  "wms.tr.undoScan": "Batal",
  "wms.tr.scanUndone": "Hitungan dibatalkan.",
  "wms.tr.completeBodyWms": "Semua barang sesuai kiriman. Barang dibukukan ke TERIMA dan tugas putaway dibuat. Tutup transfer ini?",
  "wms.tr.completeDiff": "Hasil hitung berbeda dengan kiriman:",
  "wms.tr.completeOver": "Kelebihan dibukukan sebagai barang ditemukan di gudang tujuan.",
  "error.transfer_differences": "Hasil hitung berbeda dengan kiriman. Periksa selisihnya, lalu konfirmasi.",
  "error.serial_counted": "Nomor seri ini sudah dihitung.",
  "wms.tr.completeBody": "Semua barang sesuai kiriman dan langsung masuk stok gudang ini. Tutup transfer ini?",
  "wms.tr.completeShort": "Sebagian barang belum diterima. Selisihnya tetap tercatat di transfer ini sebagai barang yang tidak sampai. Tutup sekarang?",
  "wms.tr.completed": "Transfer selesai.",
  "wms.tr.putawayCreated": "Tugas putaway dibuat untuk barang yang diterima.",
  "wms.tr.quantity": "Jumlah",
  "wms.tr.shipped": "Dikirim",
  "wms.tr.loweredHelp": "Jumlah dicoret: rak gudang asal kurang saat picking, jadi transfer membawa yang ditemukan.",
  "wms.tr.receiveTitle": "Terima di {to}",
  "wms.tr.receiveHelp": "Scan barang, isi jumlah, lalu Hitung. Stok masuk gudang ini saat Selesai terima.",
  "wms.tr.receiveHelpWms": "Scan barang, isi jumlah (atau scan nomor seri), lalu Hitung. Saat Selesai terima, barang dibukukan ke TERIMA dengan lot yang sama seperti saat dikirim, lalu tugas putaway dibuat.",
  "wms.tr.scanSerial": "Scan nomor seri",
  "wms.tr.left": "sisa {n}",
  "dashboard.card.newOrdersValue": "{n} order baru",
  "dashboard.card.processingValue": "{n} sedang diproses",
  "dashboard.card.cancelRequestsValue": "{n} permintaan batal menunggu",
  "dashboard.card.lowStockValue": "{n} SKU di bawah batas",
  "dashboard.card.storesActive": "{n} toko terhubung",
  "dashboard.card.storesProblem": "{n} toko perlu perhatian",
  "dashboard.card.open": "Buka",
  "channels.warehouse": "Gudang pemenuhan",
  "channels.warehouseHelp": "Stok gudang ini yang dikirim ke toko, dan order toko ini dipenuhi dari sini.",
  "channels.shipping": "Pengiriman",
  "channels.shippingSaved": "Pengaturan pengiriman disimpan.",
  "channels.shipMethod": "Metode kirim",
  "channels.arrangeAt": "Atur pengiriman",
  "channels.arrangeAt.process": "Otomatis saat order diproses",
  "channels.arrangeAt.pack": "Saat dikemas di meja packing",
  "channels.arrangeAt.manual": "Manual",
  "channels.arrangeAtHelp.process": "Resi sudah ada sebelum order masuk pool gudang.",
  "channels.arrangeAtHelp.pack": "Kurir dipesan saat label dicetak di meja packing.",
  "channels.arrangeAtHelp.manual": "Tim memesan kurir dari daftar order.",
  "channels.marketplaceWarehouses": "Gudang marketplace",
  "channels.marketplaceWarehousesHelp": "Untuk toko dengan beberapa gudang di marketplace: order mengikuti gudang yang ditentukan marketplace. Pilih gudang Zerpid untuk setiap gudang marketplace.",
  "channels.marketplaceWarehousesEmpty": "Belum ada order yang menyebut gudang marketplace.",
  "channels.marketplaceWarehouse": "Gudang marketplace",
  "channels.orders": "Order",
  "channels.shipsFrom": "Dikirim dari",
  "channels.warehouseOfStore": "Gudang toko",
  "channels.warehouseDefault": "Gudang utama (bawaan)",
  "channels.warehouseSaved": "Gudang toko disimpan.",
  "activity.order.cancelled_by_seller": "Membatalkan order",
  "activity.order.cancel_request_accepted": "Menerima permintaan batal",
  "activity.order.cancel_request_rejected": "Menolak permintaan batal",
  "activity.order.shipment_arranged": "Mengatur pengiriman",
  "activity.order.labels_printed": "Mencetak label",
  "activity.warehouse.wms_changed": "Mengubah pengaturan WMS",
  "activity.warehouse.locations_created": "Membuat lokasi rak",
  "activity.inbound.created": "Membuat penerimaan",
  "activity.inbound.completed": "Menyelesaikan penerimaan",
  "activity.count.created": "Memulai hitung stok",
  "activity.count.closed": "Menutup hitung stok",
  "activity.count.cancelled": "Membatalkan hitung stok",
  "activity.pool.created": "Membuat pool order",
  "activity.pool.updated": "Mengubah pool order",
  "activity.pool.deleted": "Menghapus pool order",
  "activity.wave.released": "Merilis wave",
  "activity.wave.cancelled": "Membatalkan wave",
  "activity.packaging.created": "Menambah kemasan",
  "activity.packaging.updated": "Mengubah kemasan",
  "activity.packaging.deleted": "Menghapus kemasan",
  "activity.manifest.handed_over": "Menyerahkan paket ke kurir",
  "activity.transfer.created": "Membuat transfer",
  "activity.transfer.shipped": "Mengirim transfer",
  "activity.transfer.received": "Menyelesaikan penerimaan transfer",
  "activity.transfer.cancelled": "Membatalkan transfer",
  "activity.parcel.unpacked": "Membatalkan kemasan paket",
  "activity.order.warehouse_changed": "Mengganti gudang order",
  "activity.order.held": "Menahan order",
  "activity.order.released": "Melepas tahanan order",
  "activity.order_hold_rule.created": "Membuat aturan tahan",
  "activity.order_hold_rule.updated": "Mengubah aturan tahan",
  "activity.order_hold_rule.deleted": "Menghapus aturan tahan",
  "activity.channel.shipping_updated": "Mengubah pengaturan pengiriman toko",
  "activity.channel.warehouse_mapped": "Memetakan gudang marketplace",
  "activity.promotion.created": "Membuat promosi",
  "activity.promotion.updated": "Mengubah promosi",
  "activity.promotion.deleted": "Menghapus promosi",
  "activity.aftersales.opened": "Membuka kasus purna jual",
  "activity.aftersales.updated": "Mengubah kasus purna jual",
  "activity.aftersales.received": "Menyelesaikan pemeriksaan retur",
  "activity.aftersales.resolved": "Memutuskan kasus purna jual",
  "activity.aftersales.cancelled": "Membatalkan kasus purna jual",
  "activity.aftersales.withdrawn": "Pembeli membatalkan permintaan retur",
  "activity.aftersales.platform_status": "Status retur di marketplace berubah",
  "activity.aftersales.linked": "Mencocokkan paket retur dengan order",
  "activity.aftersales.video": "Mengunggah video unboxing",

  "as.title": "Purna jual",
  "as.add": "Buat kasus",
  "as.empty": "Tidak ada kasus purna jual.",
  "as.number": "No. kasus",
  "as.kindLabel": "Jenis kasus",
  "as.reasonLabel": "Alasan sebenarnya",
  "as.counts": "{open} menunggu barang/keputusan · {receiving} sedang dibuka gudang · {received} menunggu keputusan CS",
  "as.filter.active": "Aktif",
  "as.filter.allKinds": "Semua jenis",
  "as.search": "No. kasus, resi retur, atau no. order",
  "as.col.order": "Order",
  "as.col.units": "Diharapkan · diterima",
  "as.col.created": "Dibuat",
  "as.source.marketplace": "Dari marketplace",
  "as.source.manual": "Dibuat CS",
  "as.source.warehouse": "Dibuat gudang",
  "as.kind.return_refund": "Retur & refund",
  "as.kind.refund_only": "Refund saja",
  "as.kind.failed_delivery": "Gagal kirim",
  "as.kind.complaint": "Komplain",
  "as.kind.exchange": "Tukar barang",
  "as.kind.unidentified": "Paket tak dikenal",
  "as.status.open": "Terbuka",
  "as.status.receiving": "Dibuka gudang",
  "as.status.received": "Sudah diperiksa",
  "as.status.resolved": "Selesai",
  "as.status.cancelled": "Batal",
  "as.reason.none": "Belum diisi",
  "as.reason.wrong_item": "Salah kirim barang",
  "as.reason.damaged": "Barang rusak",
  "as.reason.missing_item": "Barang kurang",
  "as.reason.not_as_described": "Tidak sesuai deskripsi",
  "as.reason.defective": "Cacat / tidak berfungsi",
  "as.reason.changed_mind": "Pembeli berubah pikiran",
  "as.reason.failed_delivery": "Gagal kirim",
  "as.reason.other": "Lainnya",
  "as.check.seal": "Segel / kemasan asli utuh",
  "as.check.serial": "Nomor seri cocok",
  "as.check.complete": "Kelengkapan isi",
  "as.check.function": "Barang berfungsi",
  "as.gradeShort.good": "Baik",
  "as.gradeShort.damaged": "Rusak",
  "as.gradeShort.incomplete": "Tidak lengkap",
  "as.gradeShort.wrong_item": "Barang lain",
  "as.grade.good": "Layak jual: kembali ke stok sellable.",
  "as.grade.damaged": "Rusak: masuk stok rusak, tidak dijual.",
  "as.grade.incomplete": "Tidak lengkap: masuk stok rusak, tidak dijual.",
  "as.grade.wrong_item": "Bukan barang yang dikirim: dicatat, tidak dihitung sebagai stok.",
  "as.resolution.refund": "Refund penuh",
  "as.resolution.partial_refund": "Refund sebagian",
  "as.resolution.rejected": "Ditolak",
  "as.resolution.appealed": "Banding ke marketplace",
  "as.resolution.replacement": "Kirim pengganti",
  "as.resolution.no_action": "Tanpa tindakan",
  "as.resolution.restocked": "Kembali ke stok",
  "as.instructions": "Instruksi untuk gudang",
  "as.instructionsHelp": "Apa yang perlu diperhatikan gudang saat membuka paket, agar tidak perlu bertanya ke CS.",
  "as.checks": "Wajib dicek",
  "as.returnTracking": "Resi retur",
  "as.returnTrackingHelp": "Resi paket yang dikirim balik pembeli. Sering berbeda dengan resi pengiriman awal.",
  "as.returnCarrier": "Kurir retur",
  "as.warehouse": "Gudang tujuan",
  "as.create.title": "Kasus purna jual untuk order {number}",
  "as.create.lines": "Barang",
  "as.create.linesHelp": "Isi jumlah barang yang akan kembali ke gudang.",
  "as.create.linesClaimHelp": "Isi barang yang dikeluhkan. Tidak ada barang yang kembali ke gudang.",
  "as.create.qty": "Jumlah",
  "as.item": "Barang",
  "as.created": "Kasus {number} dibuat.",
  "as.findOrder": "Nomor order",
  "as.findOrderHelp": "Nomor order dari marketplace.",
  "as.orderNotFound": "Order tidak ditemukan.",
  "as.openDock": "Buka di Terima retur",
  "as.cancel": "Batalkan kasus",
  "as.cancelConfirm": "Batalkan kasus {number}? Gunakan bila kasus dibuat keliru atau pembeli batal sebelum barang dikirim balik.",
  "as.receivingNow": "Gudang {warehouse} sedang membuka paket ini.",
  "as.unidentifiedHelp": "Paket ini diterima gudang tanpa kasus dan belum diketahui order-nya. Cocokkan dengan order sebelum mengambil keputusan.",
  "as.buyer": "Permintaan pembeli",
  "as.buyerReason": "Alasan pembeli",
  "as.refundRequested": "Refund diminta",
  "as.buyerNote": "Catatan pembeli",
  "as.platformStatus": "Status di marketplace",
  "as.externalId": "ID retur marketplace",
  "as.expected": "Barang yang diharapkan",
  "as.noLines": "Tidak ada barang yang diharapkan kembali.",
  "as.expectedCol": "Diharapkan",
  "as.receivedCol": "Diterima",
  "as.outboundTracking": "Resi pengiriman",
  "as.orderNotInZerpid": "Order ini lebih lama dari data Zerpid, jadi detailnya tidak tersedia.",
  "as.result": "Hasil pemeriksaan gudang",
  "as.noResult": "Belum diperiksa gudang.",
  "as.receivedBy": "Diperiksa {by} di {warehouse} · {at}",
  "as.unit.serial": "SN {sn}",
  "as.unit.lot": "Lot {lot}",
  "as.note": "Catatan",
  "as.by": "Oleh",
  "as.noVideo": "Tidak ada video unboxing.",
  "as.playVideo": "Putar video unboxing",
  "as.saved": "Kasus disimpan.",
  "as.cs": "Instruksi CS",
  "as.decision": "Keputusan",
  "as.refundAmount": "Nominal refund",
  "as.resolvedMsg": "Keputusan disimpan.",
  "as.waitReceiving": "Gudang sedang membuka paket. Keputusan bisa diambil setelah pemeriksaan selesai.",
  "as.linkFirst": "Cocokkan paket dengan order-nya terlebih dahulu.",
  "as.goodsPending": "Barang belum diterima gudang. Pastikan keputusan memang tidak menunggu hasil pemeriksaan.",
  "as.resolve": "Simpan keputusan",
  "as.link": "Cocokkan dengan order",
  "as.linkHelp": "Cari order dengan nomornya. Barang yang sudah dicatat gudang tetap, dan barang order menjadi barang yang diharapkan.",
  "as.linked": "Paket dicocokkan dengan order.",
  "as.orderCard": "Purna jual",
  "as.orderCardEmpty": "Belum ada kasus untuk order ini.",
  "as.dock.title": "Terima retur",
  "as.dock.videoHelp": "Setiap paket direkam dari kasus dibuka sampai pemeriksaan selesai, lalu diunggah otomatis.",
  "as.dock.scanTitle": "Scan paket",
  "as.dock.scan": "Scan resi retur, resi pengiriman, atau nomor order",
  "as.dock.pick": "Beberapa kasus cocok. Pilih yang sesuai.",
  "as.dock.open": "Buka",
  "as.dock.orderNoCase": "Order {number} belum punya kasus purna jual.",
  "as.dock.orderNoCaseHelp": "Pilih jenis penerimaannya. CS akan melihat hasil pemeriksaan di kasus yang dibuat.",
  "as.dock.asFailed": "Terima sebagai gagal kirim",
  "as.dock.asReturn": "Terima sebagai retur pembeli",
  "as.dock.notFound": "Tidak ada kasus atau order untuk {code}.",
  "as.dock.unknown": "Terima sebagai paket tak dikenal",
  "as.dock.unknownHelp": "Paket akan dibuka dan diperiksa sekarang. CS mencocokkannya dengan order nanti.",
  "as.dock.inProgress": "Sedang dibuka di gudang ini",
  "as.dock.noneInProgress": "Tidak ada paket yang sedang dibuka.",
  "as.dock.startUnboxing": "Mulai buka paket",
  "as.dock.tracking": "Resi di paket",
  "as.dock.finished": "Pemeriksaan {number} selesai.",
  "as.dock.finishedWms": "Barang baik menunggu di TERIMA dengan tugas putaway; barang rusak ada di RUSAK.",
  "as.dock.finishedLevel": "Barang baik masuk stok sellable; barang rusak dan tidak lengkap masuk stok rusak.",
  "as.dock.next": "Terima paket berikutnya",
  "as.dock.videoFailed": "Video unboxing gagal diunggah.",
  "as.dock.order": "Order {number}",
  "as.dock.leave": "Tinggalkan",
  "as.dock.finish": "Selesai periksa",
  "as.dock.finishConfirm": "Barang baik masuk stok sellable, barang rusak dan tidak lengkap masuk stok rusak, barang lain tidak dihitung. Setelah ini barang tidak bisa diubah.",
  "as.dock.finishConfirmWms": "Barang baik masuk TERIMA dengan tugas putaway, barang rusak dan tidak lengkap masuk RUSAK, barang lain tidak dihitung. Setelah ini barang tidak bisa diubah.",
  "as.dock.finishNote": "Catatan pemeriksaan (opsional)",
  "as.dock.instructions": "Instruksi CS",
  "as.dock.noInstructions": "Tidak ada instruksi khusus dari CS.",
  "as.dock.scanItem": "Scan barang",
  "as.dock.grade": "Kondisi",
  "as.dock.quantity": "Jumlah",
  "as.dock.itemNote": "Catatan barang (opsional)",
  "as.dock.scanItemPlaceholder": "Scan kode SKU atau barcode barang",
  "as.dock.notOurs": "Barang bukan milik kita",
  "as.dock.notOursHelp": "Untuk barang yang bukan produk kita (misalnya barang lain atau benda pengganti). Dicatat sebagai bukti, tidak masuk stok.",
  "as.dock.notOursDesc": "Deskripsi barang",
  "as.dock.items": "Barang yang ditemukan",
  "as.dock.serialTitle": "Nomor seri {code}",
  "as.dock.lotTitle": "Lot {code}",
  "as.dock.serial": "Scan nomor seri",
  "as.dock.lotHelp": "Lot saat barang dikirim tidak tercatat. Isi lot dan tanggal kedaluwarsa dari kemasan.",
  "as.dock.lotNo": "No. lot",
  "as.dock.lotExpiry": "Kedaluwarsa",
  "as.dock.closed": "Pemeriksaan kasus ini sudah selesai.",
  "activity.task.move_created": "Membuat tugas pindah",
  "activity.settings.labels_updated": "Mengubah pengaturan label",
  "activity.stock.adjusted": "Menyesuaikan stok",
  "activity.stock.moved": "Mengubah kondisi stok",
  "activity.stock.held": "Menahan stok",
  "activity.stock.hold_released": "Melepas stok yang ditahan",
  "activity.stock.variance_confirmed": "Mengonfirmasi selisih stok",
  "activity.stock.variance_netted": "Menet-kan selisih antar lot",
  "activity.channel.warehouse_changed": "Mengubah gudang toko",

  "page.forbidden.title": "Akses ditolak",
  "page.forbidden.body": "Role Anda tidak memiliki akses ke halaman ini. Hubungi Owner perusahaan bila Anda membutuhkannya.",
  "page.notFound.title": "Halaman tidak ditemukan",
  "page.notFound.body": "Alamat yang Anda buka tidak ada atau sudah dipindahkan.",
  "page.toHome": "Ke Beranda",
  "page.error.title": "Terjadi kesalahan",
  "nav.procurement": "Pembelian",
  "nav.procurement.orders": "Purchase Order",
  "nav.procurement.suppliers": "Supplier",
  "error.po_state": "Purchase order ini tidak bisa diproses seperti itu pada statusnya sekarang.",
  "error.po_has_receipts": "Sudah ada barang yang diterima dari PO ini; tutup PO-nya saja.",
  "error.po_receipt_open": "Masih ada penerimaan PO ini yang terbuka di gudang.",
  "error.po_nothing_outstanding": "Semua barang di PO ini sudah diterima.",
  "error.supplier_inactive": "Supplier tersebut sudah diarsipkan.",
  "error.supplier_code_taken": "Kode ini sudah dipakai supplier lain.",
  "error.supplier_not_found": "Supplier tidak ditemukan.",
  "error.sku_not_on_order": "SKU ini tidak ada di purchase order.",
  "error.supplier_email_missing": "Isi email supplier terlebih dahulu.",
  "error.supplier_phone_missing": "Isi nomor telepon supplier terlebih dahulu.",
  "error.warehouse_without_wms": "Gudang ini tanpa WMS: terima barang langsung di PO.",
  "error.warehouse_with_wms": "Gudang ini memakai WMS: buka penerimaan dan scan barangnya.",
  "inventory.incomingPo": "+{n} dipesan",
  "inventory.incomingPoHelp": "Incoming (PO): sudah dipesan ke supplier untuk gudang ini tapi belum diterima. Belum termasuk stok maupun available.",
  "inventory.incomingPoTitle": "Purchase order masuk",
  "po.title": "Purchase Order",
  "po.add": "Buat purchase order",
  "po.search": "Cari nomor atau supplier",
  "po.empty": "Belum ada purchase order.",
  "po.number": "Nomor PO",
  "po.supplier": "Supplier",
  "po.warehouse": "Kirim ke gudang",
  "po.orderDate": "Tanggal order",
  "po.expectedDate": "Diharapkan tiba",
  "po.paymentTerms": "Termin pembayaran (hari)",
  "po.paymentTermsValue": "{n} hari",
  "po.cod": "Tunai / COD",
  "po.tax": "PPN",
  "po.taxNone": "Tanpa PPN",
  "po.taxRate": "PPN {rate}%",
  "po.note": "Catatan untuk supplier",
  "po.lines": "Barang",
  "po.addLine": "Tambah barang",
  "po.quantity": "Qty",
  "po.unitPrice": "Harga satuan",
  "po.unitPriceHelp": "Kosong memakai harga kontrak supplier, atau harga PO terakhir yang disetujui.",
  "po.amount": "Jumlah",
  "po.received": "Diterima",
  "po.outstanding": "Sisa",
  "po.subtotal": "Subtotal",
  "po.total": "Total",
  "po.createdBy": "Dibuat oleh",
  "po.approvedBy": "Disetujui oleh",
  "po.status.draft": "Draf",
  "po.status.submitted": "Menunggu persetujuan",
  "po.status.approved": "Disetujui",
  "po.status.sent": "Terkirim",
  "po.status.partial": "Diterima sebagian",
  "po.status.received": "Diterima",
  "po.status.closed": "Ditutup",
  "po.status.cancelled": "Dibatalkan",
  "po.filter.open": "Terbuka",
  "po.filter.waiting": "Menunggu persetujuan",
  "po.saveDraft": "Simpan draf",
  "po.submit": "Ajukan persetujuan",
  "po.submitted": "Dikirim ke owner untuk disetujui.",
  "po.approve": "Setujui",
  "po.approved": "Purchase order disetujui.",
  "po.reject": "Kembalikan",
  "po.rejectTitle": "Kembalikan ke draf",
  "po.rejectNote": "Apa yang perlu diubah?",
  "po.rejected": "Dikembalikan dengan catatan: {note}",
  "po.waitingApproval": "Menunggu persetujuan owner.",
  "po.edit": "Ubah",
  "po.send": "Kirim ke supplier",
  "po.sendEmail": "Email beserta PDF",
  "po.sendWhatsApp": "WhatsApp",
  "po.downloadPdf": "Unduh PDF",
  "po.markSent": "Tandai sudah dikirim",
  "po.emailTitle": "Kirim purchase order lewat email",
  "po.emailTo": "Kepada",
  "po.emailToHelp": "Kosong dikirim ke email supplier.",
  "po.emailMessage": "Pesan (opsional)",
  "po.emailed": "Purchase order terkirim lewat email beserta PDF-nya.",
  "po.whatsappOpened": "WhatsApp dibuka dengan pesan dan tautan PDF.",
  "po.sentVia.email": "lewat email",
  "po.sentVia.whatsapp": "lewat WhatsApp",
  "po.sentVia.manual": "manual",
  "po.sentOn": "Dikirim {when} {via}",
  "po.receive": "Terima barang",
  "po.receiveTitle": "Terima barang",
  "po.receiveHelp": "Isi jumlah yang datang. Stok di {warehouse} langsung bertambah.",
  "po.receiveNone": "Isi minimal satu jumlah.",
  "po.receivedOk": "Barang diterima ke stok.",
  "po.openReceipt": "Buka penerimaan gudang",
  "po.openReceiptHelp": "{warehouse} memakai WMS: gudang memindai barang di dokumen penerimaan.",
  "po.receipts": "Penerimaan",
  "po.close": "Tutup PO",
  "po.closeConfirm": "Tutup {number}? Barang yang belum datang tidak ditunggu lagi.",
  "po.cancel": "Batalkan PO",
  "po.cancelReason": "Alasan (opsional)",
  "po.cancelConfirm": "Batalkan {number}?",
  "po.noSuppliers": "Tambahkan supplier terlebih dahulu.",
  "supplier.title": "Supplier",
  "supplier.add": "Tambah supplier",
  "supplier.edit": "Ubah supplier",
  "supplier.search": "Cari nama, kode, kontak, atau telepon",
  "supplier.empty": "Belum ada supplier.",
  "supplier.code": "Kode",
  "supplier.codeHelp": "Kosong dinomori otomatis (SUP-0001).",
  "supplier.name": "Nama",
  "supplier.contact": "Kontak",
  "supplier.phone": "Telepon / WhatsApp",
  "supplier.email": "Email",
  "supplier.address": "Alamat",
  "supplier.npwp": "NPWP",
  "supplier.pkp": "PKP (memungut PPN)",
  "supplier.pkpHelp": "PO dari supplier PKP otomatis ditambah PPN 11%.",
  "supplier.terms": "Termin pembayaran (hari)",
  "supplier.termsHelp": "0 berarti tunai / COD.",
  "supplier.method": "Metode bayar",
  "supplier.method.transfer": "Transfer bank",
  "supplier.method.cash": "Tunai",
  "supplier.method.giro": "Giro",
  "supplier.method.other": "Lainnya",
  "supplier.bank": "Bank",
  "supplier.bankAccountNo": "Nomor rekening",
  "supplier.bankAccountName": "Atas nama",
  "supplier.note": "Catatan",
  "supplier.status.active": "Aktif",
  "supplier.status.archived": "Diarsipkan",
  "supplier.archive": "Arsipkan",
  "supplier.restore": "Aktifkan lagi",
  "supplier.openOrders": "PO terbuka",
  "supplier.saved": "Supplier disimpan.",
  "supplier.prices": "Harga per SKU",
  "supplier.pricesHelp": "Harga kontrak mengisi baris PO baru; bila tidak ada, dipakai harga PO terakhir yang disetujui.",
  "supplier.contractPrice": "Harga kontrak",
  "supplier.lastPrice": "Harga terakhir",
  "supplier.addPrice": "Tambah harga SKU",
  "supplier.pricesSaved": "Harga disimpan.",
  "supplier.orders": "Purchase order",
  "supplier.newOrder": "Buat purchase order",
  "po.filter.incoming": "Menunggu barang",
  "po.draftSaved": "Draf disimpan.",
  "nav.finance.costs": "HPP",
  "cost.title": "HPP & nilai persediaan",
  "cost.totalValue": "Nilai persediaan",
  "cost.totalUnits": "{n} unit di gudang, dinilai dengan HPP rata-rata sebelum PPN",
  "cost.units": "Stok",
  "cost.value": "Nilai",
  "cost.unitCost": "HPP rata-rata",
  "cost.name": "Nama",
  "cost.updatedAt": "HPP diperbarui",
  "cost.missing": "Belum ada HPP",
  "cost.missingAlert": "{n} unit belum punya HPP dan belum dihitung dalam nilai. Isi HPP awalnya, atau terima barangnya lewat purchase order.",
  "cost.showMissing": "Tampilkan",
  "cost.search": "Cari kode SKU atau nama",
  "cost.filter.all": "Semua SKU",
  "cost.filter.missing": "Stok tanpa HPP",
  "cost.filter.set": "Sudah ada HPP",
  "cost.empty": "Tidak ada SKU",
  "cost.setOpening": "Isi HPP awal",
  "cost.correct": "Koreksi HPP",
  "cost.setHelp": "Untuk stok yang sudah ada sebelum harga belinya tercatat, atau untuk mengoreksi rata-rata. Barang yang diterima berikutnya dengan harga beli dirata-ratakan dari nilai ini.",
  "cost.note": "Catatan (mis. dari stock opname terakhir)",
  "cost.saved": "HPP disimpan.",
  "cost.history": "Riwayat HPP",
  "cost.historyEmpty": "Belum ada perubahan. HPP diperbarui saat barang masuk dengan harga beli.",
  "cost.when": "Waktu",
  "cost.source": "Sumber",
  "cost.in": "Masuk",
  "cost.change": "Rata-rata",
  "cost.by": "Oleh",
  "cost.kind.manual": "Diisi manual",
  "error.sku_not_single": "HPP bundle adalah jumlah HPP komponennya.",
  "cost.warehouse": "Gudang",
  "nav.finance.bills": "Hutang supplier",
  "bill.title": "Hutang supplier",
  "bill.status.draft": "Perlu dicek",
  "bill.status.open": "Belum dibayar",
  "bill.status.partial": "Dibayar sebagian",
  "bill.status.paid": "Lunas",
  "bill.status.void": "Batal",
  "bill.overdue": "Jatuh tempo lewat",
  "bill.outstanding": "Total hutang",
  "bill.outstandingHelp": "Tagihan terkonfirmasi yang belum dibayar",
  "bill.overdueTotal": "Lewat jatuh tempo",
  "bill.overdueBills": "{n} tagihan lewat jatuh tempo",
  "bill.dueSoon": "Jatuh tempo 7 hari",
  "bill.dueSoonHelp": "Rencanakan pembayarannya",
  "bill.toCheck": "Perlu dicek",
  "bill.toCheckHelp": "{n} draf dari penerimaan barang",
  "bill.aging": "Umur hutang per supplier",
  "bill.agingCurrent": "Belum jatuh tempo",
  "bill.aging1to30": "1–30 hari",
  "bill.aging31to60": "31–60 hari",
  "bill.aging61to90": "61–90 hari",
  "bill.agingOver90": "> 90 hari",
  "bill.search": "Cari tagihan, faktur, PO, atau supplier",
  "bill.filter.unpaid": "Belum lunas",
  "bill.filter.draft": "Perlu dicek",
  "bill.number": "No. tagihan",
  "bill.invoiceNo": "No. faktur supplier",
  "bill.invoiceNoHelp": "Nomor di faktur/invoice dari supplier. Wajib diisi untuk konfirmasi.",
  "bill.invoiceDate": "Tanggal faktur",
  "bill.dueDate": "Jatuh tempo",
  "bill.paid": "Dibayar",
  "bill.balance": "Sisa hutang",
  "bill.empty": "Tidak ada tagihan",
  "bill.void": "Batalkan",
  "bill.recordPayment": "Catat pembayaran",
  "bill.draftHelp": "Draf dibuat otomatis dari penerimaan barang. Cocokkan dengan faktur supplier: nomor faktur, harga, dan PPN, lalu konfirmasi.",
  "bill.voided": "Dibatalkan: {note}",
  "bill.source": "Dari",
  "bill.confirmedBy": "Dikonfirmasi oleh",
  "bill.payments": "Pembayaran",
  "bill.noPayments": "Belum ada pembayaran",
  "bill.paymentNo": "No. pembayaran",
  "bill.paidOn": "Tanggal bayar",
  "bill.reference": "Referensi",
  "bill.referencePlaceholder": "mis. no. transfer bank",
  "bill.amount": "Jumlah",
  "bill.paymentVoid": "Dibatalkan",
  "bill.voidPaymentConfirm": "Batalkan pembayaran ini? Tetap tercatat di riwayat, dicoret.",
  "bill.paymentVoided": "Pembayaran dibatalkan.",
  "bill.paymentSaved": "Pembayaran dicatat.",
  "bill.balanceLeft": "Sisa hutang: {amount}",
  "bill.lines": "Barang diterima",
  "bill.check": "Cocokkan dengan faktur supplier",
  "bill.adjustment": "Penyesuaian",
  "bill.adjustmentHelp": "Di luar PPN: ongkos kirim (+), diskon (−), pembulatan.",
  "bill.adjustmentNote": "Penyesuaian untuk",
  "bill.adjustmentPlaceholder": "mis. Ongkos kirim",
  "bill.saveDraft": "Simpan draf",
  "bill.confirm": "Konfirmasi tagihan",
  "bill.saved": "Draf disimpan.",
  "bill.confirmed": "Tagihan dikonfirmasi.",
  "bill.voidTitle": "Batalkan tagihan ini?",
  "bill.voidHelp": "Untuk tagihan yang tidak perlu dibayar, misalnya faktur ganda. Tulis alasannya.",
  "bill.voidPlaceholder": "Alasan",
  "error.bill_state": "Tagihan ini tidak bisa diproses pada statusnya sekarang.",
  "error.bill_has_payments": "Batalkan dulu pembayaran pada tagihan ini.",
  "error.payment_exceeds_balance": "Jumlah pembayaran melebihi sisa hutang.",
  "error.bill_negative": "Total tagihan tidak boleh kurang dari nol.",
  "error.payment_void": "Pembayaran ini sudah dibatalkan.",
  "wms.task.scanSku": "Scan SKU dari tugas ini",
  "wms.task.scanBin": "Scan bin tujuan (Enter: pakai saran)",
  "wms.task.scanSerial": "Scan setiap nomor seri",
  "wms.task.stepSku": "SKU",
  "wms.task.stepQty": "Jumlah",
  "wms.task.stepBin": "Bin",
  "wms.task.changeBin": "Ganti",
  "wms.task.binHelp": "Scan label bin, atau pilih dari daftar. Scan bin langsung menyimpan baris ini.",
  "wms.task.pickBin": "Pilih bin",
  "wms.task.noBins": "Belum ada bin di gudang ini. Tambahkan di Gudang > Lokasi.",
  "wms.task.useSuggested": "Pakai bin saran {code}",
  "orders.step.wave": "Masuk wave",
  "orders.step.pick_started": "Mulai dipick",
  "orders.step.picked": "Selesai dipick",
  "orders.step.packed": "Dipacking",
  "orders.step.label_printed": "Label dicetak",
  "orders.step.handed_over": "Diserahkan ke kurir",
  "orders.step.prints": "{n}× dicetak",
  "mpStatus.other": "{status}",
  "mpStatus.UNPAID": "Belum dibayar",
  "mpStatus.ON_HOLD": "Ditahan (masa pembatalan)",
  "mpStatus.AWAITING_SHIPMENT": "Menunggu dikirim",
  "mpStatus.PARTIALLY_SHIPPING": "Dikirim sebagian",
  "mpStatus.AWAITING_COLLECTION": "Menunggu pickup kurir",
  "mpStatus.IN_TRANSIT": "Dalam perjalanan",
  "mpStatus.DELIVERED": "Terkirim",
  "mpStatus.COMPLETED": "Selesai",
  "mpStatus.CANCELLED": "Dibatalkan",
  "mpStatus.CANCELED": "Dibatalkan",
  "mpStatus.READY_TO_SHIP": "Siap dikirim",
  "mpStatus.PROCESSED": "Pengiriman diatur",
  "mpStatus.RETRY_SHIP": "Kirim ulang",
  "mpStatus.SHIPPED": "Dikirim",
  "mpStatus.TO_CONFIRM_RECEIVE": "Terkirim, menunggu konfirmasi pembeli",
  "mpStatus.IN_CANCEL": "Pembatalan diajukan",
  "mpStatus.TO_RETURN": "Pengembalian diajukan",
  "mpStatus.INVOICE_PENDING": "Menunggu faktur",
  "mpStatus.PENDING": "Menunggu",
  "mpStatus.PACKED": "Dikemas",
  "mpStatus.CONFIRMED": "Diterima pembeli",
  "mpStatus.FAILED_DELIVERY": "Gagal kirim",
  "mpStatus.RETURNED": "Dikembalikan",
  "mpStatus.LOST_BY_3PL": "Hilang oleh kurir",
  "mpStatus.DAMAGED_BY_3PL": "Rusak oleh kurir",
  // Blibli item statuses (Order List V2; PC seen on staging).
  "mpStatus.C": "Menunggu verifikasi Blibli",
  "mpStatus.FP": "Pesanan baru",
  "mpStatus.PC": "Paket dibuat",
  "mpStatus.PU": "Siap dijemput kurir",
  "mpStatus.PF": "Dipenuhi sebagian",
  "mpStatus.BP": "Siap diantar penjual",
  "mpStatus.CR": "Pembeli minta batal",
  "mpStatus.CX": "Dalam pengiriman",
  "mpStatus.D": "Terkirim",
  "mpStatus.DF": "Gagal kirim",
  "mpStatus.OS": "Batal, stok habis",
  "mpStatus.X": "Dibatalkan",
  "wms.pool.auto.title": "Rilis otomatis",
  "wms.pool.auto.help": "Pool merilis wave sendiri sesuai jadwal, tercatat sebagai Sistem. Jam mengikuti zona waktu workspace.",
  "wms.pool.auto.off": "Mati (rilis manual)",
  "wms.pool.auto.times": "Jam tetap",
  "wms.pool.auto.interval": "Setiap N jam",
  "wms.pool.auto.timesLabel": "Rilis pada jam",
  "wms.pool.auto.timesHelp": "Biasanya sedikit sebelum jam cut-off pickup tiap kurir.",
  "wms.pool.auto.everyLabel": "Setiap",
  "wms.pool.auto.hours": "jam",
  "wms.pool.auto.from": "Mulai",
  "wms.pool.auto.until": "Sampai",
  "wms.pool.auto.minOrders": "Minimal order",
  "wms.pool.auto.minOrdersHelp": "Kalau order yang menunggu kurang dari ini, jadwal dilewati; order menunggu jadwal berikutnya.",
  "wms.pool.auto.atTimes": "Otomatis jam {times}",
  "wms.pool.auto.every": "Otomatis tiap {n} jam, {from}–{until}",
  "wms.pool.auto.next": "berikutnya {at}",
  "wms.pool.auto.lastReleased": "terakhir: {wave}",
  "wms.pool.auto.last.nothing": "terakhir: tidak ada yang bisa dipick",
  "wms.pool.auto.last.below_min": "terakhir: di bawah minimal",
  "wms.pool.auto.last.failed": "terakhir: gagal",
  "error.wave_below_minimum": "Order yang menunggu kurang dari minimal pool untuk wave otomatis.",
  "wms.task.takeNext": "Ambil tugas berikutnya",
  "wms.task.unassigned": "— Bebas —",
  "wms.task.mine": "Anda",
  "error.no_open_task": "Tidak ada tugas yang menunggu di gudang ini.",
  "error.not_a_warehouse_worker": "Anggota itu tidak bisa bekerja di gudang ini.",
  "wms.pick.scanTote": "Scan tote kosong dulu: semua yang dipick di tugas ini masuk ke tote itu.",
  "wms.pick.scanCart": "Scan tote untuk order #{n} dari {total} (satu tote per order, berurutan), atau scan label cart.",
  "wms.pick.scanTotePlaceholder": "Scan tote (TOTE-...)",
  "wms.pick.scanCartPlaceholder": "Scan tote (TOTE-...) atau cart (CART-...)",
  "wms.pick.scanSlotPlaceholder": "Scan tote atau label slot order itu (mis. CART-01-03)",
  "wms.pick.stepSlot": "Slot",
  "wms.pick.intoTote": "Masuk tote",
  "wms.pick.intoCart": "Masuk cart",
  "wms.pick.useTote": "Pakai tote",
  "wms.pick.useCart": "Pakai cart",
  "wms.pick.containerBound": "{code} siap.",
  "wms.pick.wrongSlot": "Tidak ada order di {code} yang butuh barang ini.",
  "error.container_required": "Scan tote (cluster: satu tote per order, atau cart) untuk tugas ini dulu.",
  "error.container_not_found": "Tidak ada tote atau cart dengan kode itu di gudang ini.",
  "error.container_kind": "Wadah tidak sesuai: cluster memakai satu tote per order atau cart; single dan batch memakai satu tote.",
  "error.container_busy": "Tote atau cart itu sedang dipakai (tugas lain, atau belum dikosongkan).",
  "error.container_locked": "Picking sudah dimulai ke tote atau cart lain.",
  "error.cart_slot_scanned": "Scan label cart-nya, bukan label slot.",
  "error.cart_too_small": "Slot cart ini lebih sedikit dari jumlah order di tugas.",
  "error.slot_required": "Scan slot tujuan barang.",
  "error.wrong_slot": "Order di slot itu tidak butuh barang ini.",
  "wms.pack.fromTote": "Dari tote",
  "wms.pack.toteEmpty": "Tidak ada yang menunggu dipacking di {code}.",
  "wms.pack.scanTitle": "Scan tote, slot cart, atau nomor order",
  "wms.pack.pickWaveOrScan": "Scan tote atau slot cart, atau pilih wave di kiri.",
  "nav.warehouse.containers": "Tote & cart",
  "wms.ct.title": "Tote & cart",
  "wms.ct.helpRequired": "Gudang ini picking ke tote dan cart: tugas single dan batch mengisi satu tote, tugas cluster mengisi satu tote per order atau slot cart. Cetak labelnya lalu tempel.",
  "wms.ct.helpOptional": "Picking ke tote dan cart di gudang ini opsional (aktifkan di Pengaturan > Gudang > WMS). Picker tetap bisa memilih pakai per tugas.",
  "wms.ct.addTote": "Tambah tote",
  "wms.ct.addCart": "Tambah cart",
  "wms.ct.print": "Cetak label ({n})",
  "wms.ct.empty": "Belum ada tote atau cart.",
  "wms.ct.code": "Kode",
  "wms.ct.kind": "Jenis",
  "wms.ct.tote": "Tote",
  "wms.ct.cartSlots": "Cart · {n} slot",
  "wms.ct.inTask": "Dipakai: {task} ({who})",
  "wms.ct.holding": "Berisi barang",
  "wms.ct.free": "Kosong",
  "wms.ct.units": "Unit",
  "wms.ct.count": "Jumlah",
  "wms.ct.countHelpTote": "Nomor lanjut dari yang terakhir: TOTE-0001, TOTE-0002, ...",
  "wms.ct.countHelpCart": "Nomor lanjut dari yang terakhir: CART-01, CART-02, ...",
  "wms.ct.slots": "Slot per cart",
  "wms.ct.slotsHelp": "Setiap slot punya label sendiri (CART-01-01, ...). Wave cluster menaruh satu order di tiap slot.",
  "wms.ct.added": "Ditambahkan: {codes}",
  "settings.warehouses.containerRequired": "Picking ke tote dan cart",
  "settings.warehouses.containerRequiredHelp": "Setiap tugas picking dimulai dengan scan tote (single, batch), atau satu tote per order atau cart (cluster); meja packing scan tote atau slot untuk memanggil order.",
  "common.refresh": "Perbarui",
  "orders.refreshFromMarketplace": "Perbarui dari marketplace",
  "orders.refreshed": "Order diperbarui dari marketplace.",
  "orders.arrangeOnHold": "Pembeli masih bisa membatalkan (masa pembatalan): marketplace belum membuat paket untuk dikirim. Zerpid booking kurir otomatis begitu bisa.",
  "error.package_not_ready": "Marketplace belum membuat paket order ini: masih dalam masa pembatalan pembeli. Zerpid booking kurir otomatis begitu bisa.",
  "error.marketplace_permission": "Marketplace belum memberi izin Zerpid untuk aksi ini.",
  "logs.entity.supplier": "Supplier",
  "logs.entity.purchase_order": "Purchase order",
  "logs.entity.sku_cost": "HPP",
  "logs.entity.supplier_bill": "Tagihan supplier",
  "activity.aftersales.answered": "Menjawab permintaan retur ke marketplace",
  "activity.aftersales.reopened": "Marketplace membuka lagi permintaan retur (banding)",
  "activity.aftersales.evidence": "Menambah foto bukti",
  "activity.aftersales.evidence_removed": "Menghapus foto bukti",
  "activity.aftersales.corrected": "Mengoreksi pengiriman (stok dan HPP)",
  "as.respond.overdue": "Lewat batas jawab",
  "as.respond.inHours": "Jawab ≤ {n} jam",
  "as.respond.until": "Jawab sebelum {at}",
  "as.respond.deadline": "Marketplace menunggu jawaban Anda sampai {at}; tanpa jawaban, biasanya diputuskan untuk pembeli.",
  "as.kindShort.return_refund": "Retur",
  "as.kindShort.refund_only": "Refund",
  "as.kindShort.failed_delivery": "Gagal kirim",
  "as.kindShort.complaint": "Komplain",
  "as.kindShort.exchange": "Tukar",
  "as.kindShort.unidentified": "Retur",
  "as.progress.respond": "perlu jawaban",
  "as.progress.receipt": "konfirmasi paket",
  "as.progress.receiving": "sedang dibongkar",
  "as.progress.received": "sudah dicek gudang",
  "as.progress.resolved": "sudah diputuskan",
  "as.progress.cancelled": "dibatalkan",
  "as.progress.decide": "menunggu CS",
  "as.progress.awaitingShip": "menunggu pembeli kirim",
  "as.progress.inTransit": "dalam perjalanan balik",
  "as.progress.awaitingGoods": "menunggu barang",
  "as.filter.respond": "Perlu jawaban",
  "as.filter.late": "Belum datang >7 hari",
  "as.col.respondBy": "Batas jawab",
  "as.countsRespond": "{n} perlu jawaban ({urgent} mendesak)",
  "as.ev.source.packing_video": "Video packing",
  "as.ev.source.unboxing_video": "Video unboxing",
  "as.ev.source.upload": "Foto",
  "as.ev.captured": "Foto diambil pada {at}.",
  "as.ev.capture": "Ambil foto bukti",
  "as.ev.captureHelp": "Jeda di saat barang dan resi terlihat; foto disimpan dengan nomor order dan waktunya.",
  "as.ev.packing": "Bukti packing",
  "as.ev.noParcel": "Order ini tidak dipacking di gudang Zerpid: tidak ada catatan maupun video packing.",
  "as.ev.heldUntil": "Disimpan untuk kasus ini sampai {at}, lalu terhapus otomatis.",
  "as.ev.title": "Foto bukti",
  "as.ev.upload": "Unggah foto",
  "as.ev.empty": "Belum ada foto. Ambil dari video packing atau unboxing, atau unggah foto (tangkapan layar chat, kondisi paket).",
  "as.ev.sent": "Terkirim ke marketplace",
  "as.ev.remove": "Hapus foto ini?",
  "as.answer.title": "Jawab ke marketplace",
  "as.answer.ask.refund": "Pembeli meminta refund tanpa mengembalikan barang.",
  "as.answer.ask.return": "Pembeli meminta mengembalikan barang.",
  "as.answer.askReceipt": "Paket retur sedang dikirim atau sudah tiba: konfirmasi paket sesuai klaim, atau tolak.",
  "as.answer.approve": "Setujui",
  "as.answer.reject": "Tolak",
  "as.answer.partial": "Tawarkan refund sebagian",
  "as.answer.approveReceipt": "Paket sesuai",
  "as.answer.rejectReceipt": "Tolak paket",
  "as.answer.effect.refund": "Marketplace mengembalikan {amount} ke pembeli. Barang tidak kembali dan stok tidak berubah. Kasus selesai.",
  "as.answer.effect.return": "Pembeli mengirim barang kembali; dock retur menerima dan menilainya. Refund menyusul setelah Anda mengonfirmasi paketnya.",
  "as.answer.effect.exchange": "Pembeli mengirim barang kembali untuk ditukar; dock retur menerimanya.",
  "as.answer.effect.receipt": "Marketplace mengembalikan {amount} ke pembeli. Kasus selesai.",
  "as.answer.goodsNotChecked": "Gudang belum menerima atau memeriksa paket ini di Zerpid.",
  "as.answer.rejectEffect": "Marketplace menerima alasan, komentar, dan foto Anda. Pembeli masih bisa banding ke marketplace; kalau begitu, kasus terbuka lagi.",
  "as.answer.reason": "Alasan (daftar dari marketplace)",
  "as.answer.comment": "Komentar",
  "as.answer.commentHelp": "Apa yang ditunjukkan bukti, mis. video packing memperlihatkan 2 unit masuk ke kotak.",
  "as.answer.pictures": "Foto yang dikirim (maks. {n})",
  "as.answer.tooMany": "Maksimal {n} foto.",
  "as.answer.noPictures": "Belum ada foto: penolakan tanpa bukti sering dibatalkan. Ambil foto dari video packing dulu.",
  "as.answer.partialEffect": "Pembeli menyimpan barang dan ditawari sebagian dari {amount} yang diminta. Kasus selesai saat marketplace membayarnya.",
  "as.answer.send": "Kirim ke marketplace",
  "as.answer.sent": "Jawaban terkirim ke marketplace.",
  "as.answer.evidenceHint": "Mau menolak? Ambil foto bukti dari video packing dulu.",
  "as.answer.inSellerCenter": "Marketplace menunggu jawaban penjual untuk kasus ini. Marketplace ini dijawab lewat seller center-nya.",
  "as.records.title": "Riwayat di marketplace",
  "as.records.role.BUYER": "Pembeli",
  "as.records.role.SELLER": "Penjual",
  "as.records.role.PLATFORM": "Marketplace",
  "as.records.role.SYSTEM": "Sistem",
  "as.fix.title": "Koreksi pengiriman",
  "as.fix.open": "Koreksi pengiriman",
  "as.fix.shippedHelp": "Yang tercatat keluar bersama order ini. Kalau video packing menunjukkan lain, koreksi di sini: stok dan HPP ikut menyesuaikan.",
  "as.fix.shipped": "Tercatat keluar",
  "as.fix.done": "Dikoreksi oleh {by} · {at}",
  "as.fix.back": "{n} tidak keluar (kembali ke stok)",
  "as.fix.out": "{n} keluar tanpa tercatat",
  "as.fix.scenario": "Yang terjadi",
  "as.fix.scenario.wrong_item": "Salah kirim",
  "as.fix.scenario.short": "Kurang kirim",
  "as.fix.scenario.over": "Lebih kirim",
  "as.fix.help.wrong_item": "SKU lain terkirim sebagai ganti SKU pesanan: unit pesanan kembali ke stok, SKU yang terkirim dikurangi, dan barang yang ditunggu kembali adalah SKU yang terkirim.",
  "as.fix.help.short": "Unit yang keluar lebih sedikit dari catatan: kekurangannya kembali ke stok (ke bin asal pick).",
  "as.fix.help.over": "Unit yang keluar lebih banyak dari catatan: kelebihannya dikurangi dari stok.",
  "as.fix.orderedSku": "SKU pesanan (tercatat keluar)",
  "as.fix.shortSku": "SKU yang kurang",
  "as.fix.actualSku": "SKU yang sebenarnya terkirim",
  "as.fix.extraSku": "SKU yang terkirim lebih",
  "as.fix.note": "Alasan",
  "as.fix.noteHelp": "Buktinya, mis. video packing 00:12: SKU-03 masuk ke kotak.",
  "as.fix.effect": "Stok dan HPP langsung berubah, dan stok baru dikirim ke marketplace. Satu kasus hanya bisa dikoreksi sekali.",
  "as.fix.save": "Koreksi",
  "as.fix.saved": "Pengiriman dikoreksi.",
  "orders.caseFilter.all": "Semua purna jual",
  "orders.caseFilter.respond": "Retur: perlu jawaban",
  "orders.caseFilter.active": "Retur/komplain terbuka",
  "orders.caseFilter.any": "Pernah retur/komplain",
  "nav.products": "Master produk",
  "activity.listing.created": "Membuat produk marketplace",
  "activity.listing.updated": "Mengubah produk marketplace",
  "activity.listing.image_added": "Menambah foto produk",
  "activity.listing.image_removed": "Menghapus foto produk",
  "activity.listing.channel_saved": "Mengatur produk untuk toko",
  "activity.listing.pushed": "Mempublikasikan produk ke toko",
  "activity.listing.push_edited": "Memperbarui produk di toko",
  "activity.listing.push_failed": "Toko menolak produk",
  "activity.listing.status": "Status produk di toko berubah",
  "activity.listing.imported": "Mengimpor produk dari toko",
  "prod.title": "Master produk",
  "prod.subtitle": "Satu produk, dipublikasikan ke setiap toko sesuai aturannya. Varian adalah SKU Anda: stok dan order tetap di SKU.",
  "prod.add": "Produk baru",
  "prod.import": "Tarik dari listing toko",
  "prod.show.active": "Aktif",
  "prod.show.archived": "Diarsipkan",
  "prod.search": "Nama atau kode SKU",
  "prod.filter.anyStatus": "Semua status",
  "prod.empty": "Belum ada produk. Buat baru, atau impor yang sudah ada di toko.",
  "prod.col.product": "Produk",
  "prod.col.price": "Harga",
  "prod.col.stores": "Toko",
  "prod.col.updated": "Diubah",
  "prod.col.variants": "Varian",
  "prod.col.mapping": "SKU",
  "prod.variants": "{n} varian",
  "prod.notInStores": "Belum di toko",
  "prod.imported": "{n} produk diimpor.",
  "prod.importN": "Impor {n}",
  "prod.importHelp": "Listing toko menjadi produk di Zerpid, lengkap dengan foto, varian, kategori, dan atributnya. Varian memakai SKU yang sudah dipetakan, atau SKU dengan kode = seller SKU (dibuat kalau belum ada). Bila semua variannya sudah varian produk lain (barang yang sama di toko lain), listing ditautkan ke produk itu.",
  "prod.importDone": "{ok} diimpor, {failed} gagal.",
  "prod.importEmpty": "Semua listing toko ini sudah menjadi produk.",
  "prod.unmappedN": "{n} belum dipetakan",
  "prod.allMapped": "Semua terpetakan",
  "prod.status.not_published": "Belum dipublikasikan",
  "prod.status.not_set": "Belum diatur",
  "prod.status.draft": "Draft",
  "prod.status.in_review": "Ditinjau marketplace",
  "prod.status.live": "Tayang",
  "prod.status.rejected": "Ditolak",
  "prod.status.inactive": "Nonaktif",
  "prod.status.deleted": "Dihapus",
  "prod.status.failed": "Gagal dikirim",
  "prod.saved": "Produk disimpan.",
  "prod.info": "Produk",
  "prod.name": "Judul",
  "prod.nameHelp": "Seperti yang dilihat pembeli. Marketplace menyukai 25 karakter atau lebih: merek, jenis, keunggulan.",
  "prod.description": "Deskripsi",
  "prod.descriptionHelp": "Setiap baris menjadi satu paragraf.",
  "prod.brand": "Merek",
  "prod.price": "Harga",
  "prod.priceHelp": "Untuk semua varian dan toko, kecuali diatur khusus.",
  "prod.variantsTitle": "Varian",
  "prod.sku": "SKU",
  "prod.variantPrice": "Harga",
  "prod.samePrice": "Harga produk",
  "prod.variantImage": "Foto",
  "prod.imageN": "Foto {n}",
  "prod.shipping": "Paket",
  "prod.weight": "Berat",
  "prod.lengthCm": "Panjang",
  "prod.widthCm": "Lebar",
  "prod.heightCm": "Tinggi",
  "prod.photos": "Foto",
  "prod.saveFirst": "Simpan produk dulu.",
  "prod.stores": "Toko",
  "prod.newSku": "SKU baru",
  "prod.skuCode": "Kode SKU",
  "prod.skuCodeHelp": "Dikirim ke marketplace sebagai seller SKU, sehingga order langsung terpetakan.",
  "prod.skuName": "Nama SKU",
  "prod.uploadPhoto": "Unggah",
  "prod.noPhotos": "Belum ada foto",
  "prod.cover": "Sampul",
  "prod.photosHelp": "Maksimal sembilan, JPEG atau PNG, persegi dan minimal 600×600. Foto pertama jadi sampul.",
  "prod.noStores": "Belum ada toko TikTok Shop atau Tokopedia yang terhubung.",
  "prod.storesHelp": "Publikasi ke TikTok Shop juga menayangkan produk di Tokopedia. Shopee dan Lazada menyusul.",
  "prod.variant": "Varian",
  "prod.basePrice": "Harga",
  "prod.noPrice": "Belum ada harga",
  "prod.store.setup": "Atur & publikasikan",
  "prod.store.manage": "Kelola",
  "prod.store.saved": "Pengaturan toko disimpan.",
  "prod.store.published": "Terkirim ke toko.",
  "prod.store.publish": "Publikasikan",
  "prod.store.update": "Perbarui di toko",
  "prod.store.status": "Status",
  "prod.store.check": "Cek status",
  "prod.store.externalId": "ID produk di toko",
  "prod.store.pushed": "Terakhir dikirim",
  "prod.store.inReview": "Marketplace meninjau produk baru dan perubahan, biasanya dalam sehari. Cek statusnya di sini.",
  "prod.store.rejected": "Ditolak marketplace",
  "prod.ai.write": "Bantu tulis dengan AI",
  "prod.ai.fix": "Perbaiki dengan AI",
  "prod.ai.title": "Bantu tulis dengan AI",
  "prod.ai.store": "Untuk toko",
  "prod.ai.storeHelp": "Memakai kategori dan atribut toko itu, serta batas panjang nama produknya.",
  "prod.ai.anyStore": "Semua marketplace",
  "prod.ai.notes": "Apa yang ingin ditonjolkan?",
  "prod.ai.notesHelp": "Keunggulan, bahan, untuk siapa, kata kunci. AI hanya memakai fakta yang Anda berikan.",
  "prod.ai.fixNote": "Draf akan menjawab catatan perbaikan dari marketplace.",
  "prod.ai.generate": "Tulis draf",
  "prod.ai.again": "Tulis ulang",
  "prod.ai.use": "Pakai draf ini",
  "prod.ai.used": "Draf dimasukkan ke form. Periksa dulu, lalu simpan produk.",
  "prod.ai.placeholders": "Isi setiap tanda [LENGKAPI: ...] sebelum menyimpan: AI tidak punya informasi itu.",
  "prod.store.lastError": "Pengiriman terakhir ditolak",
  "prod.store.warnings": "Peringatan dari marketplace",
  "prod.store.category": "Kategori",
  "prod.store.categoryHelp": "Produk masuk ke level terakhir. Minta saran kategori dari judul.",
  "prod.store.pickCategory": "Cari atau pilih kategori",
  "prod.store.recommend": "Sarankan",
  "prod.store.brand": "Merek",
  "prod.store.brandHelp": "Merek yang dikenal marketplace; kosongkan bila tanpa merek.",
  "prod.store.noBrand": "Tanpa merek",
  "prod.store.attributes": "Atribut",
  "prod.store.attrRequired": "Wajib dari marketplace",
  "prod.store.attrCustom": "Pilih, atau ketik sendiri",
  "prod.store.salesAttrs": "Varian dikirim sebagai {names} bila namanya sama dengan pembeda varian Anda.",
  "prod.store.sizeChart": "Tabel ukuran",
  "prod.store.sizeChartHelp": "Gambar tabel ukuran.",
  "prod.store.uploadChart": "Unggah tabel ukuran",
  "prod.store.replaceChart": "Ganti",
  "prod.store.cod": "Bayar di tempat (COD)",
  "prod.store.prices": "Harga di toko ini",
  "prod.store.pricesHelp": "Kosong: ikut harga produk atau varian. Perubahan harga massal tetap bisa lewat Produk & Harga.",
  "prod.store.price": "Harga toko",
  "prod.store.samePrice": "Sama",
  "prod.missing.title": "Yang masih dibutuhkan toko",
  "prod.missing.categoryId": "Kategori (level terakhir)",
  "prod.missing.images": "Minimal satu foto",
  "prod.missing.weightG": "Berat paket",
  "prod.missing.dimensions": "Dimensi paket",
  "prod.missing.sizeChartId": "Tabel ukuran",
  "prod.missing.variants": "Minimal satu varian",
  "prod.missing.attribute": "Atribut {name}",
  "prod.missing.variant.price": "Harga untuk {sku}",
  "prod.missing.variant.sku": "{sku} sudah diarsipkan",
  "prod.discardTitle": "Buang perubahan?",
  "prod.discardText": "Perubahan di halaman ini belum disimpan.",
  "prod.discard": "Buang",
  "prod.keepEditing": "Lanjut mengedit",
  "prod.var.groupN": "Variasi {n}",
  "prod.var.namePlaceholder1": "mis. Ukuran",
  "prod.var.namePlaceholder2": "mis. Warna",
  "prod.var.values": "Pilihan (ketik, lalu Enter)",
  "prod.var.valuesPlaceholder1": "mis. S, M, L, XL",
  "prod.var.valuesPlaceholder2": "mis. Hitam, Putih",
  "prod.var.addGroup": "Tambah variasi",
  "prod.var.noGroups": "Tanpa variasi: produk ini satu SKU. Tambah variasi (ukuran, warna) bila ada pilihan.",
  "prod.var.bulkPrice": "Harga untuk semua",
  "prod.var.applyAll": "Terapkan ke semua",
  "prod.var.autoSku": "Buat SKU otomatis ({n})",
  "prod.var.autoTitle": "Buat SKU untuk kombinasi",
  "prod.var.autoHelp": "Setiap kombinasi yang belum punya SKU dibuatkan: awalan + pilihannya. Kode yang sudah ada dipakai ulang.",
  "prod.var.prefix": "Awalan kode",
  "prod.var.autoOk": "Buat {n}",
  "prod.var.autoDone": "{n} SKU dibuat.",
  "prod.var.pickSku": "Pilih SKU",
  "prod.var.problem.name": "Beri nama setiap variasi (mis. Ukuran).",
  "prod.var.problem.sameName": "Dua variasi memakai nama yang sama.",
  "prod.var.problem.values": "Setiap variasi butuh minimal satu pilihan.",
  "prod.var.problem.sku": "Setiap kombinasi butuh SKU: pilih, atau buat otomatis.",
  "prod.var.problem.sameSku": "Satu SKU dipakai dua kombinasi.",
  "nav.stockSync": "Sinkron stok",
  "activity.stock_sync.updated": "Mengubah pengaturan sinkron stok",
  "activity.stock_sync.pushed": "Mengirim stok ke toko sekarang",
  "activity.stock_sync.rule_saved": "Mengatur aturan sinkron SKU",
  "activity.stock_sync.rule_removed": "Menghapus aturan sinkron SKU",
  "activity.stock_sync.campaign_created": "Mengunci stok untuk campaign",
  "activity.stock_sync.campaign_cancelled": "Membatalkan kunci campaign",
  "sync.title": "Sinkron stok",
  "sync.subtitle": "Berapa stok tersedia yang dikirim ke setiap toko. Stok gudang tidak berubah di sini.",
  "sync.tab.stores": "Pengaturan toko",
  "sync.tab.rules": "Aturan SKU",
  "sync.tab.campaigns": "Campaign",
  "sync.tab.check": "Cek SKU",
  "sync.pushAll": "Sinkron semua sekarang",
  "sync.pushStore": "Sinkron sekarang",
  "sync.pushed": "{n} SKU dikirim ulang ke toko.",
  "sync.saved": "Tersimpan; toko sedang diperbarui.",
  "sync.mode.shared": "Berbagi",
  "sync.mode.split": "Dibagi",
  "sync.modeHelp.shared": "Setiap toko melihat persentase dari seluruh stok tersedia (100% = semua). Order mengambil dari stok yang sama; persentase di bawah 100 menjadi cadangan anti-oversell.",
  "sync.modeHelp.split": "Stok tersedia dibagi ke toko-toko satu gudang, boleh tidak rata, total maksimal 100%. Paling aman dari oversell; satu toko bisa habis saat toko lain masih ada stok.",
  "sync.overSplit": "Total persentase toko dalam satu gudang lebih dari 100%.",
  "sync.noStores": "Belum ada toko terhubung.",
  "sync.col.percent": "Ditampilkan",
  "sync.col.share": "Bagian",
  "sync.col.warehouseTotal": "Total gudang",
  "sync.evenly": "Bagi rata",
  "sync.rule.add": "Tambah aturan SKU",
  "sync.rule.help": "Aturan SKU menggantikan persentase toko untuk SKU itu: untuk semua toko, atau satu toko (yang lebih diutamakan).",
  "sync.rule.empty": "Belum ada aturan SKU: semua SKU mengikuti pengaturan toko.",
  "sync.rule.col": "Aturan",
  "sync.rule.allStores": "Semua toko",
  "sync.rule.storeHelp": "Aturan untuk satu toko lebih diutamakan daripada aturan semua toko.",
  "sync.rule.mode.fixed": "Angka tetap (stok virtual)",
  "sync.rule.mode.percent": "Persentase sendiri",
  "sync.rule.mode.off": "Tidak disinkron (toko memakai angkanya sendiri)",
  "sync.rule.fixed": "Angka yang ditampilkan",
  "sync.rule.percent": "Persen dari tersedia",
  "sync.rule.fixedWarn": "Angka tetap tidak mengikuti stok nyata: order melebihi stok akan kekurangan (cocok untuk pre-order atau barang dibuat sesuai pesanan).",
  "sync.rule.offText": "Tidak disinkron",
  "sync.rule.fixedText": "Selalu {n}",
  "sync.rule.percentText": "{n}% dari tersedia",
  "sync.rule.remove": "Hapus aturan ini?",
  "sync.rule.removeText": "{sku} kembali mengikuti pengaturan toko.",
  "sync.camp.help": "Campaign mengunci stok untuk satu toko selama periode tertentu (flash sale, campaign marketplace). Toko lain melihat stok tanpa unit yang dikunci; penjualan toko itu selama campaign mengurangi kunci. Mulai dan berakhir otomatis.",
  "sync.camp.add": "Kunci stok campaign",
  "sync.camp.empty": "Belum ada campaign.",
  "sync.camp.name": "Nama campaign",
  "sync.camp.namePlaceholder": "mis. Flash sale 11.11",
  "sync.camp.period": "Periode",
  "sync.camp.locked": "Dikunci",
  "sync.camp.lockedN": "{units} unit · {skus} SKU",
  "sync.camp.lines": "SKU dan jumlah yang dikunci",
  "sync.camp.qty": "Jumlah",
  "sync.camp.addLine": "Tambah SKU",
  "sync.camp.lock": "Kunci",
  "sync.camp.created": "Campaign disimpan.",
  "sync.camp.overTitle": "Campaign mengunci lebih dari stok tersedia",
  "sync.camp.overLine": "{sku}: {locked} dikunci di periode ini, tersedia {available}",
  "sync.camp.state.scheduled": "Terjadwal",
  "sync.camp.state.active": "Berjalan",
  "sync.camp.state.ended": "Selesai",
  "sync.camp.state.cancelled": "Dibatalkan",
  "sync.camp.cancel": "Akhiri kunci",
  "sync.camp.cancelText": "Unit yang dikunci kembali ke semua toko sekarang.",
  "sync.camp.cancelled": "Kunci diakhiri.",
  "sync.camp.sold": "Terjual",
  "sync.camp.remaining": "Sisa dikunci",
  "sync.camp.soldHelp": "Terjual: order toko ini yang masuk ke Zerpid sejak campaign dimulai.",
  "sync.check.pick": "Pilih SKU",
  "sync.check.help": "Pilih SKU untuk melihat angka yang dikirim ke setiap toko dan alasannya.",
  "sync.check.none": "SKU ini belum dipetakan ke toko mana pun.",
  "sync.check.available": "Tersedia",
  "sync.check.told": "Dilihat toko",
  "sync.check.notSynced": "Tidak disinkron",
  "sync.check.why": "Alasan",
  "sync.check.lastPush": "Terakhir dikirim",
  "sync.why.all": "Semua stok tersedia",
  "sync.why.off": "Aturan SKU: tidak disinkron",
  "sync.why.fixed": "Aturan SKU: angka tetap",
  "sync.why.rulePercent": "Aturan SKU: {n}%",
  "sync.why.share": "Toko: {n}%",
  "sync.why.split": "Dibagi: {n}%",
  "sync.why.elsewhere": "{n} dikunci campaign toko lain",
  "sync.why.locked": "{n} dikunci untuk campaign toko ini",
  "activity.stock_sync.promotion_created": "Membuat promosi marketplace",
  "sync.camp.manual": "Kunci stok",
  "sync.promo.add": "Buat promosi TikTok",
  "sync.promo.create": "Buat di TikTok",
  "sync.promo.created": "Promosi dibuat di marketplace.",
  "sync.promo.type": "Jenis promosi",
  "sync.promo.type.flash_sale": "Flash sale",
  "sync.promo.type.discount": "Diskon",
  "sync.promo.type.fixed_price": "Harga spesial",
  "sync.promo.noLock": "Stok tidak dikunci",
  "sync.promo.lock": "Kunci kuota untuk toko ini",
  "sync.promo.lockHelp": "Toko lain tidak melihat kuota selama promo berjalan: aman dari oversell.",
  "sync.promo.lines": "SKU dalam promosi",
  "sync.promo.discount": "Diskon",
  "sync.promo.price": "Harga promo",
  "sync.promo.quota": "Kuota",
  "sync.promo.perUser": "Per pembeli",
  "sync.promo.offer": "Penawaran",
  "sync.promo.used": "Terjual di promo",
  "sync.promo.noStore": "Hubungkan toko TikTok Shop atau Tokopedia dulu.",
  "sync.promo.help": "SKU harus sudah dijual di toko (terpetakan). Kuota: berapa unit yang boleh terjual dengan harga promo. Mengakhiri campaign di sini juga mengakhiri promosi di TikTok.",
  "nav.finance.cash": "Kas & Bank",
  "logs.entity.cash": "Kas & bank",
  "activity.cash.account_created": "Membuat akun kas/bank",
  "activity.cash.account_updated": "Mengubah akun kas/bank",
  "activity.cash.entry_created": "Mencatat uang masuk/keluar",
  "activity.cash.entry_voided": "Membatalkan mutasi kas",
  "activity.cash.transfer": "Transfer antar akun",
  "cash.title": "Kas & Bank",
  "cash.moneyIn": "Uang masuk",
  "cash.moneyOut": "Uang keluar",
  "cash.transfer": "Transfer",
  "cash.addAccount": "Akun baru",
  "cash.editAccount": "Ubah akun",
  "cash.totalBalance": "Saldo semua akun",
  "cash.inThisMonth": "Masuk bulan ini",
  "cash.outThisMonth": "Keluar bulan ini",
  "cash.noAccounts": "Belum ada akun. Tambahkan rekening bank dan kas beserta saldo awalnya.",
  "cash.account": "Akun",
  "cash.closed": "Ditutup",
  "cash.in": "Masuk (bulan ini)",
  "cash.out": "Keluar (bulan ini)",
  "cash.balance": "Saldo",
  "cash.allAccounts": "Semua akun",
  "cash.allKinds": "Semua jenis",
  "cash.category": "Kategori",
  "cash.search": "Nomor, pihak, referensi",
  "cash.number": "Nomor",
  "cash.date": "Tanggal",
  "cash.kindLabel": "Jenis",
  "cash.counterparty": "Pihak",
  "cash.entry": "Mutasi",
  "cash.noEntries": "Belum ada mutasi.",
  "cash.void": "Batalkan",
  "cash.voidText": "{number} tetap ada di riwayat (dicoret) dan tidak dihitung di saldo.",
  "cash.voidTransferText": "Kedua sisi transfer {number} dibatalkan.",
  "cash.voided": "Mutasi dibatalkan.",
  "cash.kind.bank": "Bank",
  "cash.kind.cash": "Kas tunai",
  "cash.kind.ewallet": "E-wallet",
  "cash.kind.marketplace": "Saldo marketplace",
  "cash.entryKind.income": "Pemasukan",
  "cash.entryKind.expense": "Pengeluaran",
  "cash.entryKind.adjustment": "Penyesuaian",
  "cash.entryKind.transfer_in": "Transfer masuk",
  "cash.entryKind.transfer_out": "Transfer keluar",
  "cash.entryKind.supplier_payment": "Bayar supplier",
  "cash.entryKind.receipt": "Pencairan marketplace",
  "cash.accountName": "Nama akun",
  "cash.accountNamePlaceholder": "mis. BCA Operasional",
  "cash.bankName": "Bank",
  "cash.provider": "Penyedia",
  "cash.accountNo": "Nomor rekening",
  "cash.openingBalance": "Saldo awal",
  "cash.openingOn": "Per tanggal",
  "cash.openingHelp": "Mutasi dicatat mulai tanggal ini.",
  "cash.active": "Aktif",
  "cash.accountSaved": "Akun disimpan.",
  "cash.new.income": "Uang masuk",
  "cash.new.expense": "Uang keluar",
  "cash.new.adjustment": "Penyesuaian",
  "cash.adjustHelp": "Negatif untuk mengurangi saldo.",
  "cash.from": "Dari",
  "cash.to": "Dibayar ke",
  "cash.entrySaved": "{number} dicatat.",
  "cash.fromAccount": "Dari akun",
  "cash.toAccount": "Ke akun",
  "cash.sameAccount": "Pilih akun lain.",
  "cash.transferSaved": "Transfer dicatat.",
  "bill.paidFrom": "Dibayar dari",
  "bill.paidFromHelp": "Pembayaran tercatat sebagai mutasi keluar akun ini.",
  "bill.paidFromNone": "Bukan dari akun di Zerpid",
  "bill.noCashAccounts": "Tambahkan rekening di Kas & Bank agar pembayaran tercatat di sana.",
  "nav.finance.receivables": "Piutang marketplace",
  "activity.cash.payout_account": "Mengatur rekening penarikan toko",
  "ar.title": "Piutang marketplace",
  "ar.subtitle": "Yang masih terutang marketplace untuk order terkirim, yang sudah dicairkan (setelah potongan biaya), dan yang ditarik ke rekening.",
  "ar.owed": "Belum cair (terkirim, belum diselesaikan)",
  "ar.settledMonth": "Cair bulan ini (bersih)",
  "ar.feesMonth": "Biaya marketplace bulan ini ({pct}%)",
  "ar.noStores": "Belum ada toko terhubung.",
  "ar.unsupported": "Pencairan marketplace ini belum dibaca otomatis",
  "ar.syncFailed": "Sinkron terakhir gagal",
  "ar.syncedAt": "Dibaca {at}",
  "ar.neverSynced": "Belum dibaca (tiap jam)",
  "ar.owedCol": "Belum cair",
  "ar.ordersN": "{n} order",
  "ar.settledCol": "Cair bulan ini",
  "ar.feeLine": "biaya {fees} ({pct}%)",
  "ar.balance": "Saldo",
  "ar.payoutTo": "Ditarik ke",
  "ar.payoutPick": "Pilih rekening",
  "ar.payoutSaved": "Tersimpan; penarikan dicatat ke rekening itu.",
  "ar.sync": "Baca sekarang",
  "ar.synced": "Pencairan dibaca.",
  "ar.noBank": "Tambahkan rekening bank di Kas & Bank, lalu pilih di sini: penarikan saldo akan dicatat ke rekening itu.",
  "ar.tab.orders": "Order",
  "ar.tab.statements": "Pencairan",
  "ar.tab.payouts": "Penarikan",
  "ar.state.unsettled": "Belum cair",
  "ar.state.settled": "Sudah cair",
  "ar.ordered": "Tanggal order",
  "ar.total": "Total order",
  "ar.revenue": "Pendapatan",
  "ar.fees": "Biaya",
  "ar.other": "Ongkir & penyesuaian",
  "ar.adjustment": "Penyesuaian",
  "ar.net": "Bersih",
  "ar.estimatedNet": "Perkiraan cair {amount} ({n} order, dari marketplace)",
  "ar.estimateNet": "Perkiraan bersih",
  "ar.estimateRelease": "Perkiraan cair",
  "ar.estimateHelp": "Perkiraan dari marketplace, bukan angka final",
  "ar.fee.platform_commission": "Komisi platform",
  "ar.fee.transaction_fee": "Biaya transaksi",
  "ar.fee.affiliate_commission": "Komisi affiliate",
  "ar.fee.referral_fee": "Biaya referral",
  "ar.fee.sfp_service_fee": "Biaya layanan gratis ongkir",
  "ar.fee.voucher_xtra_service_fee": "Biaya layanan Voucher Xtra",
  "ar.fee.flash_sales_service_fee": "Biaya layanan flash sale",
  "ar.fee.live_specials_fee": "Biaya LIVE Specials",
  "ar.fee.vat": "PPN",
  "ar.settledAt": "Dicairkan",
  "ar.noOrders": "Tidak ada order.",
  "ar.noStatements": "Belum ada pencairan.",
  "ar.statement": "Pencairan",
  "ar.linesN": "{n} baris",
  "ar.unmatchedN": "{n} order tidak ada di Zerpid",
  "ar.noPayouts": "Belum ada penarikan.",
  "ar.payout": "Penarikan",
  "ar.posted": "Kas & Bank",
  "ar.postedYes": "Tercatat",
  "ar.postedWaiting": "Menunggu rekening dipilih",
  "wms.wave.cancelAsked": "Pembeli minta batal: sisihkan",
  "orders.note.cancel_request_auto_rejected": "Permintaan batal ditolak otomatis (sudah dipacking)",
  "activity.order.cancel_auto_rejected": "Menolak permintaan batal otomatis",
  "activity.order.settings_updated": "Mengubah pengaturan order",
  "orders.cancelSettings.title": "Permintaan batal dari pembeli",
  "orders.cancelSettings.notPacked": "Belum dipacking (di pool, wave, picking, atau packing): order ditahan dan menunggu CS menerima atau menolak permintaannya.",
  "orders.cancelSettings.autoReject": "Tolak otomatis bila sudah dipacking",
  "orders.cancelSettings.autoRejectHelp": "Zerpid menolak permintaan lewat marketplace dengan alasan 'sudah dikemas'. Bila marketplace menolak, order ditahan untuk CS.",
  "orders.cancelSettings.saved": "Tersimpan.",
  "wms.zone.title": "Zona",
  "wms.zone.help": "Rute picking melewati zona sesuai urutan ini. Zona yang dipakai lokasi baru otomatis ditambahkan di akhir. Dengan pick per zona, setiap wave dipecah menjadi satu tugas per zona; picker yang diberi zona mengambil tugas zonanya.",
  "wms.zone.add": "Tambah zona",
  "wms.zone.edit": "Zona {code}",
  "wms.zone.empty": "Belum ada zona. Zona terbentuk dari lokasi yang dibuat (A-01-01-01 ada di zona A).",
  "wms.zone.walk": "Urutan",
  "wms.zone.zone": "Zona",
  "wms.zone.code": "Kode",
  "wms.zone.name": "Nama",
  "wms.zone.namePlaceholder": "mis. Fast moving, Mezanin",
  "wms.zone.kind": "Jenis",
  "wms.zone.kind.general": "Umum",
  "wms.zone.kind.fast_moving": "Fast moving",
  "wms.zone.kind.bulk": "Bulk",
  "wms.zone.kind.high_value": "Barang bernilai tinggi",
  "wms.zone.kind.cold": "Dingin",
  "wms.zone.locations": "Lokasi",
  "wms.zone.pickers": "Picker",
  "wms.zone.pickersHelp": "Mereka mengambil tugas picking zona ini (dan tugas yang tidak dipecah per zona). Kosongkan: siapa saja.",
  "wms.zone.anyPicker": "Siapa saja",
  "wms.zone.up": "Lebih awal di rute",
  "wms.zone.down": "Lebih akhir di rute",
  "wms.zone.inUse": "Masih ada lokasi di zona ini.",
  "wms.zone.deleteConfirm": "Hapus zona {code}?",
  "wms.zone.saved": "Zona tersimpan.",
  "wms.zone.planNote": "Urutan dan jenis zona berlaku di semua paket. Pick per zona dan penugasan picker ke zona tersedia mulai paket Scale.",
  "wms.zone.tag": "Zona {code}",
  "wms.task.stops": "Titik ambil",
  "wms.pack.waitingZones": "Menunggu zona {zones}: barang dari zona itu belum dipick.",
  "wms.pool.zones": "Zona",
  "wms.pool.zonesHelp": "Order yang stoknya ada di zona ini.",
  "wms.pool.singleZone": "Hanya order dari 1 zona",
  "wms.pool.singleZoneHelp": "Semua barangnya ada di rak satu zona: dipick satu orang, tanpa digabung di packing.",
  "wms.pool.rule.singleZone": "1 zona",
  "wms.pool.rule.singleZoneOf": "1 zona dari {zones}",
  "wms.pool.rule.zones": "Zona {zones}",
  "settings.warehouses.pickByZone": "Pick per zona",
  "settings.warehouses.pickByZoneHelp": "Setiap wave dipecah menjadi satu tugas picking per zona yang dikerjakan paralel; meja packing menggabungkan lagi barang satu order.",
  "settings.warehouses.pickByZonePlan": "Tersedia mulai paket Scale.",
  "activity.warehouse.zone_created": "Menambah zona",
  "activity.warehouse.zone_updated": "Mengubah zona",
  "activity.warehouse.zone_deleted": "Menghapus zona",
  "activity.warehouse.zones_ordered": "Mengubah urutan zona",
  "wms.zone.none": "Tanpa zona",
  "wms.loc.allZones": "Semua zona",
  "wms.loc.zoneHelp": "Pilih zona gudang ini atau ketik kode baru; zona menentukan rute picking.",
  "wms.loc.zoneAssign": "Atur zona",
  "wms.loc.zoneSelected": "Atur zona ({n})",
  "wms.loc.zoneAssignBody": "Kode lokasi tetap seperti di label; hanya zonanya yang berubah. Tugas yang sudah dirilis tetap memakai zona lamanya.",
  "wms.loc.zoneScopeSelected": "{n} lokasi yang dicentang",
  "wms.loc.zoneScopePrefix": "Semua lokasi yang kodenya diawali…",
  "wms.loc.codePrefix": "Kode diawali",
  "wms.loc.codePrefixHelp": "mis. A-01 untuk semua bin di rak A-01, atau A untuk semua A.",
  "wms.loc.zoneTarget": "Zona",
  "wms.loc.zoneTargetHelp": "Pilih zona atau ketik kode baru; kosongkan untuk mengeluarkan dari zona.",
  "wms.loc.zoneMoved": "{n} lokasi dipindahkan.",
  "inventory.locationSearch": "Lokasi atau zona (A-01)",
  "inventory.atLocation": "Di lokasi",
  "activity.warehouse.locations_zoned": "Memindahkan lokasi ke zona",
  "nav.procurement.returns": "Retur ke supplier",
  "nav.finance.credits": "Nota kredit supplier",
  "logs.entity.vendor_return": "Retur ke supplier",
  "logs.entity.supplier_credit": "Nota kredit supplier",
  "vr.title": "Retur ke supplier",
  "vr.subtitle": "Barang yang dikembalikan ke supplier: rusak, salah kirim, kedaluwarsa, atau kelebihan. Supplier menyelesaikannya dengan uang (nota kredit) atau barang pengganti.",
  "vr.add": "Buat retur",
  "vr.search": "Cari nomor atau supplier",
  "vr.filter.open": "Berjalan",
  "vr.number": "Nomor",
  "vr.empty": "Belum ada retur ke supplier.",
  "vr.status.draft": "Draf",
  "vr.status.ready": "Siap dikirim",
  "vr.status.shipped": "Terkirim, menunggu penyelesaian",
  "vr.status.closed": "Selesai",
  "vr.status.cancelled": "Dibatalkan",
  "vr.reason": "Alasan",
  "vr.reason.damaged": "Rusak / cacat",
  "vr.reason.wrong_item": "Salah barang",
  "vr.reason.expired": "Kedaluwarsa",
  "vr.reason.quality": "Masalah kualitas",
  "vr.reason.excess": "Kelebihan kirim",
  "vr.reason.other": "Lainnya",
  "vr.settlement": "Penyelesaian",
  "vr.settlement.credit": "Nota kredit (uang)",
  "vr.settlement.replace": "Barang pengganti",
  "vr.shippedAt": "Dikirim",
  "vr.fromWarehouse": "Dari gudang",
  "vr.conditionHelp": "Dari stok mana barangnya diambil: rusak, karantina, atau layak jual (berhenti dijual begitu retur disiapkan).",
  "vr.unitPriceHelp": "Nilai yang dikreditkan supplier per unit. Kosong: harga supplier, atau HPP rata-rata.",
  "vr.unitPriceAuto": "Otomatis",
  "vr.fromLocation": "Ambil dari",
  "vr.fromLocationHelp": "Lokasi yang diambil lebih dulu; bila kosong dari rak serta area rusak dan karantina.",
  "vr.total": "Total dikreditkan",
  "vr.makeReady": "Simpan & siapkan",
  "vr.readyOk": "Retur disiapkan: stoknya disisihkan.",
  "vr.readyHelp": "Saat disiapkan, stok disisihkan: barang layak jual berhenti dijual di marketplace. Lalu gudang mengumpulkan barang dan mengirimnya.",
  "vr.readyNote": "Stok retur ini disisihkan di {warehouse}. Kumpulkan barangnya, lalu kirim.",
  "vr.cancel": "Batalkan retur",
  "vr.cancelConfirm": "Batalkan {number}? Stok yang disisihkan bisa dijual lagi.",
  "vr.unready": "Kembalikan ke draf",
  "vr.ship": "Kirim ke supplier",
  "vr.shipTitle": "Kirim {number}",
  "vr.shipHelp": "Barang keluar dari stok gudang sekarang.",
  "vr.shipHelpWms": "Barang keluar dari bin sekarang: yang rusak dari area rusak, yang layak jual dari rak (atau lokasi yang dipilih).",
  "vr.shipNotePlaceholder": "Kurir, nomor resi, atau siapa yang mengambil",
  "vr.shipNote": "Pengiriman",
  "vr.serialsFor": "Nomor seri {code} ({n} unit), dipisah spasi atau baris baru",
  "vr.shipped": "Retur dikirim.",
  "vr.credit": "Nota kredit",
  "vr.creditNote": "Nota kredit {number}: {left} masih harus diselesaikan supplier (potong tagihan atau refund).",
  "vr.openCredit": "Buka nota kredit",
  "vr.replaceOwed": "{n} unit barang pengganti belum datang.",
  "vr.openReceipt": "Terima pengganti (scan)",
  "vr.receive": "Terima pengganti",
  "vr.receiveHelp": "Barang pengganti masuk ke stok {warehouse} dengan HPP rata-rata.",
  "vr.owed": "Belum datang",
  "vr.replaced": "Diganti",
  "vr.receipts": "Penerimaan barang pengganti",
  "vr.close": "Tutup retur",
  "vr.closeConfirm": "Tutup {number}? Gunakan bila supplier tidak akan menyelesaikan sisanya. Nota kredit yang tersisa tetap bisa dipakai.",
  "supplier.method.credit": "Nota kredit",
  "bill.creditNote": "Nota kredit",
  "bill.creditNoteHelp": "Membayar tagihan dari nilai retur yang terutang supplier; tidak ada uang keluar.",
  "bill.creditsOpen": "Supplier masih berutang {amount} dari {n} nota kredit retur.",
  "bill.creditsOpenView": "Lihat nota kredit",
  "cash.entryKind.supplier_refund": "Refund supplier",
  "credit.title": "Nota kredit supplier",
  "credit.subtitle": "Nilai yang terutang supplier atas barang yang diretur: pakai untuk memotong tagihannya, atau catat uang yang dikembalikan.",
  "credit.status.open": "Belum habis",
  "credit.status.used": "Terpakai",
  "credit.status.void": "Batal",
  "credit.remainingTotal": "Masih terutang:",
  "credit.empty": "Belum ada nota kredit.",
  "credit.number": "Nomor",
  "credit.return": "Retur",
  "credit.issuedOn": "Terbit",
  "credit.amount": "Nilai",
  "credit.used": "Terpakai",
  "credit.remaining": "Sisa",
  "credit.useHelp": "Pakai untuk tagihan dari halaman tagihan (metode bayar: nota kredit), atau catat refund di bawah.",
  "credit.noUses": "Belum dipakai.",
  "credit.use": "Dipakai untuk",
  "credit.use.bill": "Tagihan",
  "credit.use.refund": "Refund",
  "credit.on": "Tanggal",
  "credit.voidRefund": "Batalkan",
  "credit.voidRefundConfirm": "Batalkan refund ini? Mutasi kasnya ikut dibatalkan.",
  "credit.refundTitle": "Catat refund",
  "credit.into": "Diterima di",
  "credit.receivedOn": "Tanggal diterima",
  "credit.recordRefund": "Catat refund",
  "credit.refunded": "Refund dicatat.",
  "activity.vendor_return.created": "Membuat retur ke supplier",
  "activity.vendor_return.updated": "Mengubah retur ke supplier",
  "activity.vendor_return.ready": "Menyiapkan retur ke supplier",
  "activity.vendor_return.unready": "Mengembalikan retur ke supplier ke draf",
  "activity.vendor_return.cancelled": "Membatalkan retur ke supplier",
  "activity.vendor_return.shipped": "Mengirim retur ke supplier",
  "activity.vendor_return.closed": "Menutup retur ke supplier",
  "activity.vendor_return.receipt_opened": "Membuka penerimaan barang pengganti",
  "activity.vendor_return.replaced": "Menerima barang pengganti",
  "activity.supplier_credit.refunded": "Mencatat refund supplier",
  "activity.supplier_credit.refund_voided": "Membatalkan refund supplier",
  "nav.finance.reports": "Laporan",
  "report.title": "Laporan keuangan",
  "report.profit": "Laba kotor",
  "report.cash": "Arus kas",
  "report.aging": "Umur hutang & piutang",
  "report.by.store": "Toko",
  "report.by.platform": "Marketplace",
  "report.by.sku": "SKU",
  "report.by.month": "Bulan",
  "report.profitHelp": "Dihitung dari barang yang keluar gudang dalam periode: harga baris order, HPP saat barang keluar, dan biaya marketplace dari order yang pencairannya sudah terbaca. Order batal dan retur tidak dihitung.",
  "report.revenue": "Pendapatan",
  "report.cost": "HPP",
  "report.grossProfit": "Laba kotor",
  "report.margin": "Margin {pct}",
  "report.marginCol": "Margin",
  "report.fees": "Biaya marketplace",
  "report.feesLine": "Biaya marketplace {fees}",
  "report.afterFees": "Setelah biaya MP",
  "report.orders": "Order",
  "report.units": "Unit",
  "report.unmapped": "Belum terpetakan ke SKU",
  "report.noCost": "{n} unit keluar sebelum SKU-nya punya HPP: dihitung 0. Isi HPP di menu HPP.",
  "report.profitEmpty": "Tidak ada barang terkirim di periode ini.",
  "report.cashHelp": "Uang masuk dan keluar semua akun. Perpindahan antar akun sendiri (penarikan saldo marketplace ke bank, isi kas) tidak dihitung sebagai arus kas.",
  "report.cashHelpAccount": "Uang masuk dan keluar akun ini, termasuk transfer.",
  "report.opening": "Saldo awal",
  "report.started": "termasuk {amount} dari akun baru di periode ini",
  "report.moneyIn": "Uang masuk",
  "report.moneyOut": "Uang keluar",
  "report.closing": "Saldo akhir",
  "report.net": "Bersih {amount}",
  "report.netCol": "Bersih",
  "report.byCategory": "Per jenis dan kategori",
  "report.byMonth": "Per bulan",
  "report.byAccount": "Per akun",
  "report.month": "Bulan",
  "report.cashEmpty": "Tidak ada mutasi di periode ini.",
  "report.apTotal": "Hutang ke supplier",
  "report.apOverdue": "Lewat jatuh tempo {amount}",
  "report.arTotal": "Piutang marketplace",
  "report.arHelp": "Order terkirim yang belum cair",
  "report.credits": "Nota kredit supplier",
  "report.creditsHelp": "{n} nota dari retur yang masih terutang",
  "report.apAging": "Umur hutang (hari lewat jatuh tempo)",
  "report.apEmpty": "Tidak ada tagihan belum lunas.",
  "report.arAging": "Umur piutang (hari sejak order)",
  "report.arEmpty": "Tidak ada piutang marketplace.",
  "report.ar.d7": "0-7 hari",
  "report.ar.d14": "8-14 hari",
  "report.ar.d30": "15-30 hari",
  "report.ar.older": "> 30 hari",
  "report.total": "Total",
  "report.balance": "Saldo toko",
  "platform.manual": "Manual",
  "channels.manual.add": "Tambah saluran manual",
  "channels.manual.added": "Saluran ditambahkan.",
  "channels.manual.help": "Untuk penjualan di luar marketplace: website, Instagram, WhatsApp, toko offline, atau B2B. Ordernya dibuat di Zerpid dan melewati alur gudang yang sama.",
  "channels.manual.namePlaceholder": "mis. Website, Instagram, WhatsApp",
  "channels.manual.drawerHelp": "Saluran manual tidak terhubung ke marketplace: buat ordernya dari Order > Buat order manual. Stoknya tidak dikirim ke mana pun.",
  "manual.add": "Buat order manual",
  "manual.title": "Order manual baru",
  "manual.save": "Buat order",
  "manual.noChannel": "Tambahkan saluran manual dulu (Toko > Tambah saluran manual), mis. Website atau Instagram.",
  "manual.created": "Order {number} dibuat.",
  "manual.createdUnpaid": "Order {number} dibuat; stoknya disisihkan dan menunggu pembayaran.",
  "manual.buyer": "Pembeli dan alamat",
  "manual.channel": "Saluran penjualan",
  "manual.buyerName": "Nama pembeli",
  "manual.recipientName": "Penerima",
  "manual.recipientHelp": "Kosong: sama dengan pembeli.",
  "manual.phone": "Telepon",
  "manual.address": "Alamat",
  "manual.city": "Kota",
  "manual.postalCode": "Kode pos",
  "manual.items": "Barang",
  "manual.price": "Harga",
  "manual.payment": "Pembayaran",
  "manual.shippingFee": "Ongkir",
  "manual.discount": "Diskon",
  "manual.total": "Total",
  "manual.paymentStatus": "Status bayar",
  "manual.pay.unpaid": "Belum bayar",
  "manual.pay.paid": "Lunas",
  "manual.pay.cod": "COD",
  "manual.unpaidHelp": "Stok disisihkan untuk pembeli; order ditahan dan baru diproses setelah ditandai lunas.",
  "manual.paidInto": "Diterima di",
  "manual.paidIntoHelp": "Mencatat pembayaran ke Kas & Bank (arus kas). Kosong: tidak dicatat.",
  "manual.paidOn": "Tanggal bayar",
  "manual.shipping": "Pengiriman",
  "manual.carrier": "Kurir",
  "manual.trackingNo": "Nomor resi",
  "manual.trackingHelp": "Bisa diisi nanti; dibutuhkan untuk cetak label.",
  "manual.panel": "Order manual",
  "manual.noTracking": "Belum diisi",
  "manual.markPaid": "Tandai lunas",
  "manual.markUnpaid": "Tandai belum bayar",
  "manual.payBody": "Pembeli sudah membayar {amount}.",
  "manual.setTracking": "Isi resi",
  "manual.editTracking": "Ubah resi",
  "manual.markShipped": "Tandai dikirim",
  "manual.markCompleted": "Tandai selesai",
  "manual.saved": "Tersimpan.",
  "orders.hold.unpaid": "Menunggu pembayaran",
  "orders.holdHelp.unpaid": "Order manual yang belum dibayar. Stoknya disisihkan; order diproses setelah ditandai lunas.",
  "orders.note.manual_created": "Order manual dibuat",
  "orders.note.payment": "Pembayaran",
  "orders.note.tracking_set": "Resi diisi",
  "orders.note.manual_shipped": "Ditandai dikirim",
  "orders.note.manual_completed": "Ditandai selesai",
  "orders.reason.paid": "Lunas",
  "orders.reason.unpaid": "Belum bayar",
  "orders.reason.cod": "COD",
  "error.manual_tracking_required": "Isi nomor resi order manual ini dulu.",
  "error.not_manual_order": "Hanya order manual yang bisa begitu.",
  "error.order_not_processed": "Order belum diproses (belum bayar, stok kosong, atau ditahan).",
  "error.manual_channel": "Saluran manual tidak punya marketplace untuk disinkronkan.",
  "activity.order.manual_created": "Membuat order manual",
  "activity.order.payment": "Mengubah pembayaran order manual",
  "activity.order.tracking_set": "Mengisi resi order manual",
  "activity.channel.manual_created": "Menambah saluran manual",
  "activity.channel.manual_renamed": "Mengganti nama saluran manual",
  "wms.pack.trackingTitle": "Nomor resi {number}",
  "wms.agent.agent_unreachable": "Agen perekam tidak berjalan di laptop ini.",
  "wms.agent.agent_not_paired": "Agen perekam belum dipasangkan dengan Zerpid.",
  "wms.agent.agent_other_warehouse": "Agen di laptop ini dipasangkan ke gudang lain.",
  "wms.agent.agent_no_camera": "Agen perekam belum memilih kamera.",
  "wms.agent.agent_camera": "Agen perekam tidak bisa membuka kamera.",
  "wms.agent.fixHelp": "Packing tetap bisa, tapi paket tidak direkam. Buka pengaturan agen, atau pasang agen di laptop ini.",
  "wms.agent.openSetup": "Pengaturan agen",
  "wms.agent.download": "Unduh agen",
  "wms.agent.on": "Perekam {name} · {camera}",
  "wms.agent.keptHere": "Video disimpan di laptop ini.",
  "wms.agent.preview": "Preview kamera",
  "wms.agent.onLaptop": "Tersimpan di gudang (meja packing atau hub): bisa diputar di PC gudang yang memasang agen Zerpid; dari tempat lain, minta dikirim.",
  "wms.agent.requestUpload": "Minta laptop mengirim",
  "wms.agent.requested": "Diminta. Laptop mengirim dalam semenit bila sedang menyala.",
  "wms.agent.waitingUpload": "Menunggu PC gudang mengirim videonya.",
  "settings.warehouses.recorder": "Perekam",
  "settings.warehouses.recorder.browser": "Di browser (diunggah ke Zerpid)",
  "settings.warehouses.recorder.agent": "Agen perekam di laptop packing (disimpan di laptop)",
  "settings.warehouses.recorderHelp": "Agen merekam webcam atau kamera CCTV dan menyimpan video di disk laptop sendiri; hanya yang diminta yang dikirim ke Zerpid.",
  "settings.warehouses.recorderPlan": "Agen perekam tersedia mulai paket Scale.",
  "rec.manage": "Perangkat perekam",
  "rec.title": "Perangkat perekam · {name}",
  "rec.help": "Laptop packing yang menjalankan agen perekam Zerpid. Setiap laptop dipasangkan sekali dengan kode; cabut di sini dan tokennya berhenti berlaku.",
  "rec.install": "Pasang agen di laptop packing",
  "rec.installSteps": "Unduh zip di laptop itu, ekstrak, klik dua kali Install.cmd (tanpa hak admin). Lalu klik Tambah perangkat di sini dan ketik kodenya di halaman agen.",
  "rec.download": "Unduh agen {version}",
  "rec.add": "Tambah perangkat",
  "rec.empty": "Belum ada perekam yang dipasangkan.",
  "rec.pending": "Kode menunggu dipakai: {names}",
  "rec.device": "Perangkat",
  "rec.online": "Online",
  "rec.offline": "Offline",
  "rec.revoked": "Dicabut",
  "rec.noCamera": "Belum ada kamera",
  "rec.lastSeen": "Terakhir terlihat",
  "rec.clips": "Video",
  "rec.clipsValue": "{n} video · sisa {free}",
  "rec.uploadsWaiting": "{n} diminta, belum terkirim",
  "rec.revoke": "Cabut",
  "rec.hub": "Hub",
  "rec.hubHelp": "Hub: satu PC di jaringan gudang yang menyimpan video semua meja. Meja mengirim videonya ke hub; PC mana pun yang memasang agen (meja, PC manager) memutarnya lewat jaringan. Video naik ke Zerpid hanya untuk kasus aftersales atau bila diminta.",
  "rec.makeHub": "Jadikan hub",
  "rec.makeHubConfirm": "Jadikan {name} hub gudang? Meja mengirim videonya ke PC ini mulai check-in berikutnya; biarkan PC ini menyala dan diskonya cukup.",
  "rec.unhub": "Lepas hub",
  "rec.unhubConfirm": "Lepas {name} sebagai hub? Video baru kembali disimpan di meja masing-masing; video yang sudah di hub tetap di sana.",
  "rec.hubAddrs": "Di jaringan: {addrs}",
  "rec.hubWaiting": "Menunggu hub melaporkan alamat jaringannya",
  "rec.revokeConfirm": "Cabut {name}? Laptop berhenti merekam untuk Zerpid; videonya tetap di laptop.",
  "rec.deviceName": "Nama perangkat",
  "rec.deviceNameHelp": "Meja mana yang direkam, sesuai sebutan di gudang.",
  "rec.deviceNamePlaceholder": "mis. Meja packing 1",
  "rec.makeCode": "Buat kode",
  "rec.codeTitle": "Kode pasangan · {name}",
  "rec.codeExpires": "Berlaku sampai {at}, sekali pakai.",
  "rec.codeSteps": "Di laptop packing, buka Zerpid Agen Perekam (menu Start), ketik kode ini, lalu pilih kamera.",
  "activity.warehouse.recorder_pairing": "Membuat kode pasangan perekam",
  "activity.warehouse.recorder_paired": "Memasangkan perekam",
  "activity.warehouse.recorder_revoked": "Mencabut perekam",
  "error.video_on_device": "Video tersimpan di gudang (meja packing atau hub). Putar di PC gudang yang memasang agen Zerpid, atau minta dikirim.",
  "error.clip_not_on_device": "Video ini sudah tidak ada di perekam itu.",
  "error.no_hub": "Gudang ini belum punya hub perekam.",
  "nav.section.sales": "Penjualan · OMS",
  "nav.section.warehouse": "Gudang · WMS",
  "nav.section.purchasing": "Pembelian",
  "nav.section.finance": "Keuangan",
  "nav.section.system": "Sistem",
  "nav.group.products": "Produk",
  "nav.group.stock": "Stok",
  "nav.group.inbound": "Inbound",
  "nav.group.outbound": "Outbound",
  "nav.group.whStock": "Inventori gudang",
  "nav.warehouse.stock": "Stok per lokasi",
  "nav.favorites": "Favorit",
  "nav.favorite": "Tambah ke favorit",
  "nav.unfavorite": "Hapus dari favorit",
  "nav.search": "Cari menu",
  "nav.noMatch": "Tidak ada menu yang cocok.",
  "nav.collapse": "Ciutkan",
  "nav.expand": "Lebarkan menu",
  "inventory.view.sku": "Total semua gudang",
  "inventory.view.warehouse": "Per gudang",
  "inventory.warehouses": "Gudang",
  "bins.title": "Stok per lokasi",
  "bins.subtitle": "{name}: setiap bin dengan lot, kondisi, dan tanggal terima.",
  "bins.search": "Cari SKU, barcode, atau nomor lot",
  "bins.allConditions": "Semua kondisi",
  "bins.allKinds": "Semua jenis lokasi",
  "bins.olderThan": "Diterima > {n} hari lalu",
  "bins.anyAge": "Semua umur stok",
  "bins.anyExpiry": "Semua kedaluwarsa",
  "bins.expired": "Sudah kedaluwarsa",
  "bins.expiringIn": "Kedaluwarsa ≤ {n} hari",
  "bins.sort.location": "Urut rute ambil",
  "bins.sort.received": "Terima terlama dulu",
  "bins.sort.expiry": "Kedaluwarsa terdekat dulu",
  "bins.free": "Bebas",
  "bins.receivedAt": "Tgl terima",
  "bins.receivedHelp": "Tanggal unit tertua di bin ini diterima di gudang. Tetap terbawa saat dipindah (putaway, pindah bin, picking).",
  "bins.age": "Umur",
  "bins.days": "{n} hari",
  "bins.empty": "Tidak ada stok di lokasi yang cocok.",
  "nav.storage": "Penyimpanan cloud",
  "sub.kind.storage_mb": "Penyimpanan cloud",
  "storage.title": "Penyimpanan cloud",
  "storage.help": "File yang disimpan Zerpid untuk workspace ini: video packing yang diunggah, video unboxing retur, foto bukti komplain, dan gambar produk. Video yang disimpan agen perekam di laptop packing tidak dihitung.",
  "storage.used": "Terpakai",
  "storage.of": "dari {limit}",
  "storage.unlimited": "Tanpa batas di paket Anda",
  "storage.full": "Penyimpanan penuh: video packing baru dan gambar produk tidak bisa diunggah. Perpendek masa simpan video, rekam dengan agen, atau hubungi tim Zerpid.",
  "storage.warn": "Penyimpanan hampir penuh ({pct}%).",
  "storage.byKind": "Per jenis file",
  "storage.kind": "Jenis",
  "storage.kind.packing_video": "Video packing",
  "storage.kind.return_video": "Video unboxing retur",
  "storage.kind.evidence_photo": "Foto bukti komplain",
  "storage.kind.product_image": "Gambar produk",
  "storage.files": "File",
  "storage.size": "Ukuran",
  "storage.share": "Porsi",
  "storage.byWarehouse": "Video packing per gudang",
  "storage.settings": "Atur masa simpan",
  "storage.recorder": "Perekam",
  "storage.recorder.browser": "Browser (diunggah)",
  "storage.recorder.agent": "Agen (di laptop)",
  "storage.recorder.off": "Tidak merekam",
  "storage.retention": "Masa simpan",
  "storage.retentionDays": "{n} hari",
  "storage.cloud": "Di cloud",
  "storage.local": "Di laptop packing",
  "storage.sizeFiles": "{size} · {n} file",
  "storage.localNote": "Di laptop packing: {size} ({n} video), tidak dihitung. Sisa disk tiap laptop terlihat di Perangkat perekam.",
  "storage.agentTip": "Gudang yang merekam lewat browser mengunggah semua video ke cloud. Agen perekam (paket Scale) menyimpannya di laptop packing dan hanya mengunggah yang diminta.",
  "pda.manage": "Perangkat Android",
  "pda.title": "Perangkat Android · {name}",
  "pda.help": "PDA dan HP yang menjalankan aplikasi gudang Zerpid di gudang ini. Setiap perangkat dipasangkan sekali dengan kode; setelah itu staf masuk dengan ID dan PIN masing-masing (User & Role). Cabut di sini dan yang sedang masuk di perangkat itu otomatis keluar.",
  "pda.noWms": "Aktifkan WMS di gudang ini untuk memakai aplikasi gudang.",
  "pda.install": "Pasang aplikasi di PDA",
  "pda.installSteps": "Buka halaman ini di PDA (atau salin APK ke PDA), pasang aplikasinya (izinkan pemasangan dari sumber ini sekali), lalu klik Tambah perangkat di sini dan ketik kodenya di aplikasi.",
  "pda.download": "Unduh aplikasi {version}",
  "pda.add": "Tambah perangkat",
  "pda.empty": "Belum ada perangkat yang dipasangkan.",
  "pda.lastUser": "Terakhir dipakai",
  "pda.revokeConfirm": "Cabut {name}? Aplikasinya berhenti bekerja sampai dipasangkan lagi, dan yang sedang masuk otomatis keluar.",
  "pda.nameHelp": "Sebutan di gudang, mis. nomor di stikernya.",
  "pda.namePlaceholder": "mis. PDA 1",
  "pda.codeSteps": "Buka Zerpid Gudang di PDA, ketik kode ini, lalu staf masuk dengan ID dan PIN masing-masing.",
  "pin.column": "ID aplikasi",
  "pin.set": "Atur ID & PIN",
  "pin.title": "ID & PIN · {name}",
  "pin.help": "Untuk aplikasi gudang: masuk di PDA yang dipasangkan ke gudang tempat member ini bekerja.",
  "pin.id": "ID masuk",
  "pin.idHelp": "3-32 huruf kecil, angka, titik, strip, atau garis bawah, mis. budi atau budi.g",
  "pin.idFormat": "Pakai 3-32 huruf kecil, angka, . _ atau -",
  "pin.pin": "PIN",
  "pin.newPin": "PIN baru",
  "pin.pinHelp": "6 angka, tidak boleh sama semua atau berurutan (bukan 111111 atau 123456). Salah 5 kali, terkunci 15 menit.",
  "pin.pinFormat": "6 angka",
  "pin.saved": "ID & PIN {name} disimpan.",
  "pin.clear": "Hapus PIN",
  "pin.clearConfirm": "{name} tidak bisa lagi masuk di PDA.",
  "pin.noEmail": "Hanya aplikasi gudang (ID & PIN)",
  "pin.staffAdd": "Tambah staf gudang (ID & PIN)",
  "pin.staffTitle": "Staf gudang tanpa email",
  "pin.staffHelp": "Untuk staf yang hanya bekerja di PDA: tanpa email dan tidak bisa masuk web. Dihitung sebagai user di paket Anda.",
  "pin.staffAdded": "{name} ditambahkan. Sudah bisa masuk di PDA.",
  "pin.warehousesHelp": "Kosong: semua gudang.",
  "error.login_id_taken": "ID ini sudah dipakai member lain.",
  "activity.warehouse.pda_pairing": "Membuat kode pasangan PDA",
  "activity.warehouse.pda_paired": "Memasangkan PDA",
  "activity.warehouse.pda_revoked": "Mencabut PDA",
  "activity.member.pin_set": "Mengatur ID & PIN aplikasi",
  "activity.member.pin_cleared": "Menghapus PIN aplikasi",
  "activity.member.staff_created": "Menambah staf gudang (ID & PIN)",
  "wms.pack.scanItemFirst": "Scan barangnya dulu, baru kemasan.",
  "wms.pack.item": "Barang",
  "wms.pack.boxNow": "scan kemasan sekarang untuk menutup paket",
  "wms.pack.boxAfterItem": "di-scan setelah barang",
  "nav.warehouse.performance": "Performa staf",
  "perf.title": "Performa staf",
  "perf.help": "Pekerjaan tiap staf di gudang ini dalam periode, dihitung dari tugas, paket, serah terima, penerimaan, dan hitung stok yang mereka kerjakan. Klik nama untuk rincian harian.",
  "perf.helpSelf": "Pekerjaan Anda di gudang ini dalam periode. Klik barisnya untuk rincian harian.",
  "perf.empty": "Belum ada pekerjaan tercatat di periode ini.",
  "perf.member": "Staf",
  "perf.daysOf": "{name} per hari",
  "perf.pickTasks": "Tugas picking",
  "perf.pickUnits": "Unit di-pick",
  "perf.putawayTasks": "Tugas putaway",
  "perf.putawayUnits": "Unit putaway",
  "perf.perHourHelp": "Unit per jam waktu tugas, dari mulai sampai selesai tiap tugas (termasuk jeda).",
  "perf.packed": "Paket di-packing",
  "perf.handed": "Paket diserahkan",
  "perf.received": "Unit diterima",
  "perf.counted": "Lokasi dihitung",
  "perf.short": "Unit kurang",
  "perf.shortHelp": "Unit yang ternyata tidak ada di bin saat picking.",
  "perf.pickPerHour": "Pick/jam",
  "perf.putawayPerHour": "Putaway/jam",
  "an.staffLink": "Performa staf",
  "an.tab.sales": "Penjualan",
  "an.tab.fulfillment": "Pemenuhan order",
  "an.revenue": "Omzet",
  "an.revenueHint": "Order yang tidak batal dan tidak retur",
  "an.orders": "Order",
  "an.units": "Unit",
  "an.avgOrder": "Rata-rata per order",
  "an.cancelled": "Batal",
  "an.returned": "Retur",
  "an.revenuePerDay": "Omzet per hari",
  "an.ordersPerDay": "Order per hari",
  "an.chart": "Grafik",
  "an.table": "Tabel",
  "an.empty": "Tidak ada order di periode ini.",
  "an.day": "Hari",
  "an.byStore": "Per toko",
  "an.store": "Toko",
  "an.topSkus": "SKU terlaris",
  "an.sku": "SKU",
  "an.name": "Nama",
  "an.packed": "Sudah packing",
  "an.handed": "Diserahkan ke kurir",
  "an.late": "Terlambat kirim",
  "an.overdue": "Lewat batas kirim",
  "an.overdueHint": "Belum diserahkan",
  "an.toPacked": "ke packing",
  "an.packedToHanded": "packing ke kurir",
  "an.toHanded": "Order sampai kurir",
  "an.hours": "{n} jam",
  "an.perDay": "Per hari (order yang masuk hari itu)",
  "an.heldNow": "Tertahan sekarang",
  "an.reason": "Alasan",
  "an.noHeld": "Tidak ada order tertahan.",
  "an.fulfillmentHelp": "Dari order yang masuk di periode ini (tidak batal). Waktu packing dan serah terima berasal dari gudang yang memakai WMS; waktunya median.",
  "an.tab.products": "Produk & stok",
  "an.ins.title": "Insight",
  "an.ins.help": "Pola yang terdeteksi beberapa minggu terakhir, yang paling mendesak di atas.",
  "an.ins.none": "Tidak ada yang janggal belakangan ini.",
  "an.ins.seeProducts": "Lihat produk",
  "an.ins.seeOrders": "Lihat order",
  "an.ins.seeFulfillment": "Lihat pemenuhan",
  "an.ins.sales_up": "Omzet 7 hari terakhir naik {pct}% dari minggu sebelumnya ({revenue} vs {previous}).",
  "an.ins.sales_down": "Omzet 7 hari terakhir turun {pct}% dari minggu sebelumnya ({revenue} vs {previous}).",
  "an.ins.orders_spike": "Lonjakan order pada {day}: {orders} order, biasanya sekitar {usual}.",
  "an.ins.orders_drop": "Order anjlok pada {day}: {orders}, biasanya sekitar {usual}. Cek sinkron toko.",
  "an.ins.sku_returns": "{code} banyak diretur: {pct}% ({returned} dari {sold} unit dalam 30 hari).",
  "an.ins.store_failures": "{store}: {pct}% order batal atau retur dalam 30 hari ({cancelled} batal, {returned} retur).",
  "an.ins.orders_overdue": "{orders} order lewat batas kirim dan belum diserahkan ke kurir.",
  "an.ins.shipping_late": "{pct}% paket 7 hari terakhir diserahkan setelah batas kirim ({late} dari {handed}).",
  "an.ins.orders_held": "{orders} order tertahan; terbanyak karena: {reason} ({reasonOrders}).",
  "an.ins.stock_out": "{skus} SKU yang laku sudah habis stoknya.",
  "an.ins.stock_low": "{skus} SKU akan habis dalam seminggu dengan laju jual sekarang.",
  "an.ins.stock_dead": "{skus} SKU ({units} unit) punya stok tapi tidak laku dalam {days} hari.",
  "an.classA": "Kelas A",
  "an.classB": "Kelas B",
  "an.classC": "Kelas C",
  "an.skus": "{n} SKU",
  "an.ofRevenue": "{pct}% omzet",
  "an.runningOut": "Mau habis",
  "an.runningOutHint": "Cukup < 2 minggu",
  "an.runningOutHelp": "Stok tersedia dibagi laju jual 30 hari terakhir.",
  "an.noRunningOut": "Tidak ada yang habis dalam dua minggu.",
  "an.dead": "Tidak laku",
  "an.deadHint": "{units} unit, tidak terjual 60 hari",
  "an.pareto": "Pareto (ABC)",
  "an.paretoHelp": "A: SKU penyumbang 80% omzet pertama; B: 15% berikutnya; C: sisanya.",
  "an.share": "Porsi",
  "an.cumShare": "Kumulatif",
  "an.available": "Tersedia",
  "an.soldPerDay": "Terjual/hari",
  "an.cover": "Cukup",
  "an.empty0": "Habis",
  "an.days": "{n} hari",
  "an.incoming": "Di PO",
  "nav.couriers": "Kurir",
  "courier.title": "Kurir",
  "courier.help": "Tiap toko menulis nama kurir dengan caranya sendiri (J&T di Shopee beda dengan J&T di TikTok). Petakan setiap nama ke satu kurir di sini: order, pool, wave, dan serah terima memakai nama hasil pemetaan. Kurir instan dan same day baru dipesan saat paket selesai dikemas, jadi driver tidak datang sebelum paket siap.",
  "courier.add": "Tambah kurir",
  "courier.edit": "Ubah kurir",
  "courier.list": "Daftar kurir",
  "courier.kind": "Layanan",
  "courier.kindHelp": "Instan dan same day: dipesan saat dikemas, bukan saat order diproses.",
  "courier.kind.regular": "Reguler",
  "courier.kind.instant": "Instan",
  "courier.kind.sameday": "Same day",
  "courier.kind.cargo": "Kargo",
  "courier.names": "Nama dari toko",
  "courier.delete": "Hapus kurir",
  "courier.deleteConfirm": "Hapus {name}? {n} nama dari toko jadi belum dipetakan.",
  "courier.storeNames": "Nama kurir dari toko",
  "courier.unmapped": "{n} belum dipetakan",
  "courier.unmappedOnly": "Hanya yang belum dipetakan",
  "courier.noNames": "Belum ada nama kurir dari toko",
  "courier.platform": "Marketplace",
  "courier.storeName": "Nama dari toko",
  "courier.orders30": "Order (30 hari)",
  "courier.mappedTo": "Kurir",
  "courier.pick": "Pilih kurir",
  "wms.pool.courierKindsHelp": "Mis. pool khusus instan dan same day dengan prioritas tinggi.",
  "error.courier_name_taken": "Nama kurir ini sudah dipakai.",
  "wms.count.source.spot": "Di tempat",
  "wms.count.source.schedule": "Terjadwal",
  "wms.cycle.title": "Jadwal hitung siklus",
  "wms.cycle.help": "Setiap hari sistem membuat satu cycle count berisi lokasi yang sudah jatuh tempo, menurut kelas barang di dalamnya (A, B, C dari omzet 90 hari terakhir; yang tidak laku masuk C). Lokasi yang saat picking ternyata kurang didahulukan. 0 hari: kelas itu tidak dijadwalkan.",
  "wms.cycle.saved": "Jadwal disimpan.",
  "wms.cycle.days": "hari",
  "wms.cycle.classA": "Kelas A tiap",
  "wms.cycle.classB": "Kelas B tiap",
  "wms.cycle.classC": "Kelas C tiap",
  "wms.cycle.max": "Maksimal lokasi per hari",
  "wms.cycle.maxHelp": "Isi satu hitungan harian; sisanya menunggu hari berikutnya.",
  "wms.cycle.status": "{due} lokasi jatuh tempo sekarang. Terakhir jalan: {last}.",
  "wms.var.missingValue": "Nilai hilang (HPP)",
  "wms.var.foundValue": "Nilai lebih (HPP)",
  "wms.var.value": "Nilai (HPP)",
  "wms.var.confirmValue": "Dampak ke laba: {value}",
  "report.stockVariance": "Selisih stok",
  "report.stockVarianceHelp": "Selisih yang dikonfirmasi dalam periode, dinilai dengan HPP rata-rata, untuk seluruh workspace (tidak per toko). Selisih yang belum dikonfirmasi belum dihitung.",
  "report.varianceLoss": "Susut (hilang)",
  "report.varianceGain": "Lebih (ditemukan)",
  "report.afterVariance": "Setelah biaya & selisih",
  "report.varianceNoCost": "{n} unit dikonfirmasi saat SKU-nya belum punya HPP; tidak masuk nilai ini.",
  "nav.finance.books": "Tutup buku",
  "logs.entity.books": "Tutup buku",
  "books.title": "Tutup buku",
  "books.help": "Di akhir bulan, angka bulan itu dinyatakan final: Zerpid menyimpan posisi akhir bulan (laba rugi, nilai persediaan, kas, hutang) dan transaksi bertanggal di bulan itu tidak bisa dicatat atau dibatalkan lagi. Kesalahan yang ketahuan belakangan dikoreksi di bulan yang masih terbuka. Bulan ditutup berurutan setelah lewat; hanya owner yang bisa membuka kembali bulan terakhir yang ditutup.",
  "books.closedThrough": "Buku ditutup sampai {date}. Catatan kas, pembayaran, dan tagihan bertanggal sampai tanggal itu terkunci.",
  "books.neverClosed": "Belum ada bulan yang ditutup. Tutup buku pertama juga mengunci semua bulan sebelumnya.",
  "books.month": "Bulan",
  "books.status.current": "Berjalan",
  "books.status.open": "Terbuka",
  "books.status.closed": "Ditutup",
  "books.closedBy": "Ditutup oleh",
  "books.close": "Tutup buku",
  "books.view": "Lihat",
  "books.reopen": "Buka kembali",
  "books.reopenTitle": "Buka kembali {month}?",
  "books.reopenBody": "Tanggal di bulan ini bisa diubah lagi. Catatan tutup buku tetap tersimpan; tutup lagi setelah selesai.",
  "books.reopenReason": "Alasan (wajib)",
  "books.reasonRequired": "Isi alasannya.",
  "books.reopened": "Bulan dibuka kembali.",
  "books.closeTitle": "Tutup buku {month}",
  "books.closeBody": "Zerpid menyusun ulang posisi akhir bulan dari ledger stok lalu menyimpannya. Setelah itu tidak ada transaksi bertanggal di bulan ini yang bisa dicatat atau dibatalkan.",
  "books.closeOk": "Tutup buku",
  "books.closed": "{month} sudah ditutup.",
  "books.blockers": "Wajib beres",
  "books.warnings": "Sebaiknya dicek",
  "books.blocked": "Bereskan yang wajib dulu.",
  "books.note": "Catatan (opsional)",
  "books.check.open_counts": "Hitung stok yang dimulai sampai akhir bulan masih terbuka: {n}",
  "books.check.open_counts.help": "Tutup atau batalkan di Gudang > Hitung stok.",
  "books.check.open_variance": "Selisih dari bulan ini belum dikonfirmasi: {n}",
  "books.check.open_variance.help": "Konfirmasi atau saling hapus di Gudang > Selisih: stok yang hilang masuk laba rugi bulan ini.",
  "books.check.units_no_cost": "Unit terjual tanpa HPP: {n}",
  "books.check.units_no_cost.help": "HPP-nya dihitung nol; isi di Keuangan > HPP.",
  "books.check.draft_bills": "Tagihan supplier masih draf: {n}",
  "books.check.draft_bills.help": "Barang sudah diterima tapi belum ditagih: hutang tercatat terlalu kecil.",
  "books.check.unsettled_orders": "Order marketplace terkirim tapi belum dicairkan: {n}",
  "books.check.unsettled_orders.help": "Wajar di awal bulan; biaya marketplace-nya belum masuk laba.",
  "books.check.open_transfers": "Transfer antar gudang belum selesai: {n}",
  "books.check.open_transfers.help": "Barang di jalan dihitung di gudang asal.",
  "books.viewTitle": "Buku {month}",
  "books.wasReopened": "Bulan ini dibuka kembali: {reason}. Angka di bawah dari penutupan terakhirnya.",
  "books.pnl": "Laba rugi",
  "books.fees": "Biaya marketplace",
  "books.variance": "Selisih stok",
  "books.net": "Laba setelah biaya & selisih",
  "books.position": "Posisi akhir bulan",
  "books.stockValue": "Nilai persediaan",
  "books.cash": "Kas & bank",
  "books.payables": "Hutang supplier",
  "books.stockNoCost": "{n} unit belum punya HPP dan tidak masuk nilai persediaan.",
  "books.stock": "Persediaan akhir bulan",
  "books.qty": "Qty",
  "books.unitCost": "HPP rata-rata",
  "books.value": "Nilai",
  "books.history": "Riwayat",
  "books.closedLine": "Ditutup oleh {name}, {at}",
  "books.reopenedLine": "Dibuka kembali oleh {name}, {at}: {reason}",
  "books.closedWithWarnings": "Ditutup dengan catatan: {list}",
  "error.period_closed": "Buku untuk tanggal ini sudah ditutup. Catat di bulan yang masih terbuka.",
  "error.close_order": "Bulan ditutup berurutan: tutup bulan setelah bulan terakhir yang ditutup.",
  "error.month_not_over": "Bulan baru bisa ditutup setelah lewat.",
  "error.close_blocked": "Bereskan checklist dulu.",
  "error.reopen_latest_only": "Hanya bulan terakhir yang ditutup yang bisa dibuka kembali.",
  "error.month_not_closed": "Bulan ini belum ditutup.",
  "wms.in.condition.sellable": "Baik",
  "wms.in.condition.damaged": "Rusak",
  "wms.in.condition.quarantine": "Perlu dicek",
  "wms.in.damagedN": "{n} rusak",
  "wms.in.quarantineN": "{n} perlu dicek",
  "po.settings": "Pengaturan penerimaan",
  "po.settingsSaved": "Pengaturan penerimaan disimpan.",
  "po.overReceipt": "Terima lebih dari PO",
  "po.overReceiptHelp": "Dicek per SKU di setiap penerimaan PO, baik dari web maupun PDA.",
  "po.overReceipt.none": "Tidak boleh: maksimal sesuai PO",
  "po.overReceipt.tolerance": "Boleh, maksimal lebih",
  "po.overReceipt.any": "Boleh, tanpa batas",
  "error.over_receipt": "Melebihi jumlah yang diizinkan PO untuk SKU ini.",
  "nav.warehouse.pallets": "Pallet",
  "wms.plt.title": "Pallet",
  "wms.plt.add": "Cetak label baru",
  "wms.plt.addOk": "Buat & cetak",
  "wms.plt.added": "{n} pallet dibuat: {first} s/d {last}.",
  "wms.plt.countHelp": "Nomor lanjut dari yang terakhir (PLT-000001...). Tempel di pallet saat terima barang.",
  "wms.plt.size": "Ukuran label",
  "wms.plt.helpOn": "Gudang ini terima barang per pallet: scan pallet dulu sebelum barang. Tiap pallet punya putaway sendiri, dibuka dengan scan palletnya.",
  "wms.plt.helpOff": "Terima per pallet belum aktif di gudang ini (Pengaturan > Gudang > Atur WMS). Label tetap bisa dicetak duluan.",
  "wms.plt.empty": "Belum ada pallet",
  "wms.plt.waiting": "Menunggu putaway ({task})",
  "wms.plt.current": "Pallet {code}",
  "wms.plt.scanFirst": "Scan pallet dulu (maksimal {n} SKU per pallet).",
  "wms.plt.change": "Ganti",
  "wms.plt.wholeTitle": "Pallet {code}: taruh utuh",
  "wms.plt.wholeHelp": "Semua isinya masuk ke satu rak tanpa scan barang lagi. Untuk memecah pallet, putaway per baris di bawah.",
  "wms.plt.placeAll": "Taruh semua di sini",
  "wms.plt.placed": "Pallet ditaruh di {code}.",
  "settings.warehouses.palletReceiving": "Terima barang per pallet",
  "settings.warehouses.palletReceivingHelp": "Barang di-scan ke pallet saat diterima; tiap pallet di-putaway utuh atau dipecah. Mati: semua masuk TERIMA seperti biasa.",
  "settings.warehouses.palletMaxSkus": "Maksimal SKU per pallet",
  "settings.warehouses.palletLabel": "Ukuran label pallet",
  "error.pallet_full": "Pallet ini sudah berisi jumlah SKU maksimal; pakai pallet lain.",
  "error.pallet_busy": "Pallet ini sedang menunggu putaway; pakai pallet lain.",
  "error.pallet_not_found": "Tidak ada pallet dengan kode ini di gudang ini.",
  "error.pallet_no_putaway": "Pallet ini tidak punya barang yang menunggu putaway.",
  "error.not_a_pallet": "Hanya pallet yang bisa ditaruh utuh.",
  "orders.tracking": "Resi",
  "orders.priority.all": "Semua prioritas",
  "orders.priority.urgent": "Prioritas (semua)",
  "orders.priority.instant": "Instan & same day",
  "orders.priority.due_soon": "Batas kirim < 1 hari",
  "orders.priority.late": "Telat",
  "orders.priority.lateTag": "Telat",
  "orders.priority.soonTag": "Sisa {n} jam",
  "orders.courierFilter.all": "Semua kurir",
  "orders.dateBy.ordered": "Tanggal order",
  "orders.dateBy.created": "Masuk Zerpid",
  "orders.dateBy.shipped": "Tanggal dikirim",
  "error.order_picking_started": "Order ini sudah mulai di-picking; keluarkan dari wave dulu.",
  "orders.dateBy.shipBy": "Batas kirim (SLA)",
  "orders.edit.swap": "Ganti barang",
  "orders.edit.swapTitle": "Ganti barang",
  "orders.edit.swapOk": "Ganti",
  "orders.edit.swapHelp": "{name} ({code}, {n} pcs) dikirim sebagai SKU yang dipilih di bawah, mis. warna lain atau pengganti saat stok kosong. Order di marketplace tidak berubah; kabari pembeli lewat chat.",
  "orders.edit.note": "Catatan (opsional), mis. pembeli minta warna hitam",
  "orders.edit.swapped": "Barang diganti; stok dipesan untuk SKU baru.",
  "orders.edit.switchedTo": "Diganti ke {code}",
  "orders.edit.lines": "Ubah barang",
  "orders.edit.linesTitle": "Ubah barang order",
  "orders.edit.linesHelp": "Ubah jumlah, tambah atau hapus barang; total menyesuaikan (ongkir dan diskon tetap). Hanya sampai picking dimulai.",
  "orders.edit.addLine": "Tambah barang",
  "orders.edit.linesSaved": "Barang disimpan.",
  "orders.note.line_swapped": "Barang diganti",
  "orders.note.lines_edited": "Barang diubah",
  "error.order_not_editable": "Hanya order yang belum dikemas yang bisa diubah.",
  "error.line_not_swappable": "Hanya barang order yang bisa diganti.",
  "orders.peek.prev": "Order sebelumnya",
  "orders.peek.next": "Order berikutnya",
  "orders.peek.keys": "↑ ↓ untuk pindah",
  "orders.peek.openTab": "Buka di tab",
  "views.title": "Filter tersimpan:",
  "views.save": "Simpan filter ini",
  "views.saveHelp": "Filter yang sedang tampil disimpan dengan nama; sekali klik untuk memakainya lagi.",
  "views.namePlaceholder": "mis. Telat J&T Shopee",
  "views.share": "Bagikan ke seluruh tim",
  "views.saved": "Tersimpan: {name}",
  "views.sharedBy": "Dibagikan oleh {name}",
  "views.deleteTitle": "Hapus “{name}”?",
  "orders.due.title": "Batas kirim:",
  "orders.due.all": "Semua",
  "orders.due.expired": "Telat",
  "orders.due.0_3": "0–3 jam",
  "orders.due.3_6": "3–6 jam",
  "orders.due.6_12": "6–12 jam",
  "orders.due.12_48": "12–48 jam",
  "orders.due.48_plus": "> 48 jam",
  "orders.due.none": "Tanpa batas",
  "orders.bulk.button": "Cari banyak nomor sekaligus",
  "orders.bulk.title": "Cari banyak order",
  "orders.bulk.help": "Tempel nomor order atau nomor resi, satu per baris (atau dipisah koma/spasi), maksimal 500.",
  "orders.bulk.ok": "Cari",
  "orders.bulk.active": "{n} nomor dicari · {found} ketemu",
  "nav.section.tools": "Alat",
  "nav.tools.barcodes": "Cetak barcode",
  "bc.title": "Cetak barcode",
  "bc.kind.location": "Lokasi",
  "bc.kind.tote": "Tote & cart",
  "bc.kind.pallet": "Pallet",
  "bc.kind.packaging": "Kemasan",
  "bc.kind.sku": "SKU",
  "bc.kind.custom": "Teks bebas",
  "bc.needWms": "Lokasi, tote, pallet dan kemasan milik gudang yang memakai WMS. Pilih gudangnya di bagian atas halaman.",
  "bc.setup": "Label",
  "bc.symbology": "Jenis kode",
  "bc.symHelp.code128": "Terbaca semua scanner. Paling cocok untuk kode SKU dan kode lokasi yang pendek.",
  "bc.symHelp.qr": "Terbaca dari jauh dan dari samping: cocok untuk rak tinggi dan kode yang panjang.",
  "bc.symHelp.ean13": "12–13 angka, untuk barang yang dijual di toko. Huruf tidak bisa jadi EAN-13.",
  "bc.size": "Ukuran label",
  "bc.sizeCustom": "Ukuran sendiri…",
  "bc.paper": "Dicetak di",
  "bc.paperRoll": "Label gulungan (printer label)",
  "bc.paperA4": "Kertas A4 (printer biasa)",
  "bc.copies": "Jumlah salinan",
  "bc.print": "Cetak ({n})",
  "bc.printAll": "Cetak semua yang tampil ({n})",
  "bc.printTip": "Cetak dengan skala 100% (Actual size)",
  "bc.printTipRoll": "Di jendela cetak pilih “Actual size” atau skala 100%, bukan “Fit to page”, dan atur kertas printer ke {w} × {h} mm. Kalau tidak, barcode mengecil dan bisa tidak terbaca.",
  "bc.printTipA4": "Pilih “Actual size” atau skala 100% di jendela cetak. Label disusun rapat dari tengah kertas.",
  "bc.cartSlots": "Cart · {n} slot (label slotnya ikut tercetak)",
  "bc.addSku": "Tambah SKU (kode, nama atau barcode)",
  "bc.generate": "Buatkan barcode untuk {n} SKU yang belum punya",
  "bc.generated": "{n} barcode dibuat dan disimpan ke SKU",
  "bc.skuEmpty": "Tambahkan SKU yang mau dilabeli",
  "bc.sku": "SKU",
  "bc.barcode": "Barcode",
  "bc.noBarcode": "belum ada (kode SKU yang dicetak)",
  "bc.customHelp": "Satu kode per baris. Untuk mencetak keterangan di bawahnya, tambahkan tab atau “;” setelah kode (tempel dua kolom dari Excel juga bisa).",
  "nav.finance.margins": "Margin harga",
  "logs.entity.cost_profile": "Profil biaya toko",
  "activity.cost_profile.set": "Mengubah profil biaya toko",
  "margin.title": "Margin harga",
  "margin.subtitle": "Apakah harga sekarang masih untung, dan harga berapa yang memberi margin target. Dihitung dari HPP dan profil biaya tiap toko.",
  "margin.belowAlert": "Ada SKU yang dijual di bawah harga impas.",
  "margin.skus": "{n} SKU",
  "margin.profiles": "Profil biaya per toko",
  "margin.noStores": "Belum ada toko yang terhubung.",
  "margin.fee": "Potongan marketplace",
  "margin.fixedFee": "Biaya tetap per order",
  "margin.fixedFeeHelp": "Mis. biaya proses pesanan. Dibebankan penuh ke setiap unit.",
  "margin.ads": "Iklan",
  "margin.adsHelp": "Biaya iklan dibagi omzet dari dasbor iklan (ROAS 10× = 10%). Isi 0 bila tidak beriklan.",
  "margin.target": "Target margin",
  "margin.realFee": "Potongan nyata 90 hari",
  "margin.realFeeNone": "Belum cukup data ({n} order, minimal 30)",
  "margin.realFeeIs": "Potongan nyata 90 hari: {pct} dari {n} order",
  "margin.useReal": "Pakai",
  "margin.default": "Bawaan",
  "margin.edit": "Profil biaya {store}",
  "margin.saved": "Profil biaya disimpan.",
  "margin.totalTooHigh": "Potongan, iklan, dan margin harus kurang dari 95% dari harga.",
  "margin.search": "Cari SKU atau nama produk",
  "margin.filter.all": "Semua SKU platform",
  "margin.filter.below_break_even": "Di bawah impas",
  "margin.filter.below_target": "Margin di bawah target",
  "margin.filter.no_cost": "Tanpa HPP",
  "margin.filter.unmapped": "Belum dipetakan",
  "margin.sellerSku": "SKU penjual",
  "margin.price": "Harga sekarang",
  "margin.cost": "HPP",
  "margin.deduction": "Potongan per unit",
  "margin.margin": "Margin sekarang",
  "margin.breakEven": "Harga impas",
  "margin.suggested": "Harga saran",
  "margin.empty": "Tidak ada SKU platform",
  "margin.problem.no_cost": "Belum ada HPP",
  "margin.problem.unmapped": "Belum dipetakan",
  "fillCost.button": "Pakai HPP sekarang",
  "fillCost.done": "{sold} unit terjual dan {counted} unit selisih stok sekarang memakai HPP saat ini.",
  "fillCost.none": "Tidak ada yang perlu diisi.",
  "fillCost.open": "{n} unit masih tanpa HPP: isi dulu HPP SKU-nya di menu HPP.",
  "fillCost.closed": "{n} unit di bulan yang sudah tutup buku dibiarkan seperti yang dilaporkan.",
  "activity.sku_cost.filled": "Memakai HPP saat ini untuk unit yang belum punya HPP",
  "nav.warehouse.serials": "IMEI / SN",
  "wms.pack.scanItemBeforeSerial": "Ada beberapa barang ber-IMEI: scan barcode barangnya dulu, lalu IMEI-nya.",
  "serial.title": "IMEI / nomor seri",
  "serial.help": "Semua IMEI di gudang ini: masuk dari mana dan keluar ke mana. HP diterima, di-putaway, di-pick dan dipindah berdasarkan jumlah; IMEI di-import setelah penerimaan dan disebut saat packing.",
  "serial.search": "IMEI atau kode SKU",
  "serial.number": "IMEI / SN",
  "serial.status.in_stock": "Stok",
  "serial.status.shipped": "Terjual / dikirim",
  "serial.status.removed": "Keluar (hilang / retur supplier)",
  "serial.status.all": "Semua status",
  "serial.inDate": "Masuk",
  "serial.outDate": "Keluar",
  "serial.inRef": "Penerimaan",
  "serial.outKind": "Keluar sebagai",
  "serial.outRef": "Order / dokumen",
  "serial.empty": "Belum ada IMEI. Import dari Penerimaan, atau lewat “Import IMEI stok lama”.",
  "serial.inWarehouse": "Gudang: {name}",
  "serial.kind.received": "Diterima",
  "serial.kind.shipped": "Dikirim dengan order",
  "serial.kind.returned": "Diretur pembeli",
  "serial.kind.transfer_out": "Ditransfer ke gudang lain",
  "serial.kind.transfer_in": "Tiba dari gudang lain",
  "serial.kind.count_loss": "Hilang saat hitung stok",
  "serial.kind.count_gain": "Ditemukan saat hitung stok",
  "serial.kind.vendor_return": "Diretur ke supplier",
  "serial.noSerial": "{n} tanpa IMEI",
  "serial.noSerialHelp": "Unit di gudang yang IMEI-nya belum di-import: belum bisa dijual sampai IMEI-nya masuk (Penerimaan > Import IMEI).",
  "serial.receiptCount": "IMEI {n}/{of}",
  "serial.receive.count": "Jumlah saja",
  "serial.receive.scan": "Scan IMEI sekarang",
  "serial.import.button": "Import IMEI",
  "serial.import.titleFor": "Import IMEI · {code}",
  "serial.import.help": "Tempel daftar (satu per baris), scan ke kotak ini, atau pilih file Excel (.xlsx) atau CSV: kolom pertama yang dibaca.",
  "serial.import.receiptHelp": "Daftar IMEI dari supplier untuk unit yang datang di penerimaan ini. Selama IMEI-nya belum masuk, unit itu belum bisa dijual.",
  "serial.import.file": "Pilih file Excel / CSV",
  "serial.import.count": "{n} IMEI",
  "serial.import.countOf": "{n} dari {max} unit tanpa IMEI",
  "serial.import.ok": "Import {n}",
  "serial.import.done": "{n} IMEI terdaftar.",
  "serial.register.button": "Import IMEI stok lama",
  "serial.register.pick": "SKU yang mana? Untuk stok yang sudah ada sebelumnya, atau penerimaan tanpa daftar IMEI.",
  "serial.register.help": "IMEI unit yang sudah ada di gudang tapi belum tercatat. Maksimal sebanyak unit tanpa IMEI.",
  "serial.audit.button": "Audit IMEI",
  "serial.audit.title": "Audit IMEI",
  "serial.audit.help": "Scan semua IMEI di gudang (atau tempel daftarnya). Tidak ada yang berubah: Anda melihat yang cocok, yang hilang, dan yang tidak dikenal sistem. Selisihnya diselesaikan lewat hitung stok.",
  "serial.audit.allSkus": "Semua SKU",
  "serial.audit.run": "Bandingkan {n} IMEI",
  "serial.audit.matched": "{n} cocok dengan sistem",
  "serial.audit.missing": "Ada di sistem, tidak ter-scan",
  "serial.audit.unknown": "Ter-scan, tidak ada di sistem",
  "serial.audit.elsewhere": "Ter-scan, tapi menurut sistem sudah terjual atau di tempat lain",
  "serial.audit.after": "Unit yang hilang atau ditemukan diselesaikan lewat Hitung stok; saat konfirmasi selisih, IMEI-nya diminta.",
  "serial.var.needed": "{n} IMEI perlu disebut",
  "serial.var.missingHelp": "IMEI dari {n} unit yang hilang",
  "serial.var.foundHelp": "IMEI dari {n} unit yang ditemukan",
  "serial.var.placeholder": "Satu IMEI per baris",
  "serial.transfer.help": "IMEI dari {n} unit yang dikirim",
  "serial.return.title": "IMEI {serial} tidak keluar dengan order ini",
  "serial.return.help": "Pembeli mengembalikan unit dengan IMEI berbeda dari yang dikirim. Terima hanya dengan alasan: kasus ini ditandai untuk dicek (video unboxing, pembeli).",
  "serial.return.placeholder": "mis. Pembeli mengirim unit lain, sudah dicek di video unboxing",
  "serial.return.ok": "Tetap terima",
  "serial.return.overridden": "IMEI bukan yang dikirim: {reason}",
  "activity.inbound.serials_registered": "Import IMEI untuk penerimaan",
  "activity.stock.serials_registered": "Import IMEI stok yang sudah ada",
  "wms.var.tab.open": "Belum dikonfirmasi",
  "wms.var.tab.history": "Riwayat",
  "wms.var.historySearch": "Kode atau nama SKU",
  "wms.var.historyAt": "Dikonfirmasi",
  "wms.var.historyQty": "Selisih",
  "wms.var.unitCost": "HPP rata-rata / unit",
  "wms.var.historyBy": "Dikonfirmasi oleh",
  "wms.var.historyEmpty": "Belum ada selisih yang dikonfirmasi.",
  "wms.var.lost": "Hilang {n}",
  "wms.var.noCost": "Belum ada HPP saat itu",
  "sync.safety.title": "Stok pengaman per gudang",
  "sync.safety.help": "Unit yang ditahan dari semua toko, supaya pesanan yang masuk sebelum stok toko terupdate tidak oversold. Toko diberi angka tersedia dikurangi stok pengaman (tidak pernah di bawah 0). SKU bisa punya angka sendiri: Produk & Harga, centang SKU, Stok pengaman.",
  "sync.why.safety": "{n} ditahan sebagai stok pengaman",
  "catalog.safety": "Stok pengaman",
  "catalog.safety.follow": "Ikut gudang",
  "catalog.safety.own": "Angka sendiri",
  "catalog.safety.bulk": "Stok pengaman ({n})",
  "catalog.safety.title": "Stok pengaman untuk {n} SKU",
  "catalog.safety.help": "Unit yang ditahan dari semua toko untuk SKU ini, di setiap gudang. Pilih “Ikut gudang” untuk memakai angka per gudang di Sinkron stok.",
  "catalog.safety.saved": "Stok pengaman {n} SKU disimpan; toko sedang diperbarui.",
  "nav.warehouse.damaged": "Barang rusak",
  "damage.title": "Barang rusak",
  "damage.noWarehouse": "Pilih gudang terlebih dahulu.",
  "damage.tab.stock": "Stok rusak",
  "damage.tab.history": "Pemusnahan",
  "damage.help": "Barang rusak tidak pernah dijual. Beri keputusan: Kembalikan ke sellable (diperbaiki atau lolos QC ulang, tanpa rugi), Retur ke supplier, atau Musnahkan: gudang mengajukan, keuangan menyetujui, lalu gudang memusnahkan barang dengan foto; nilainya dengan HPP rata-rata menjadi rugi “Barang rusak”.",
  "damage.search": "Kode atau nama SKU",
  "damage.total": "{n} unit rusak",
  "damage.disposeN": "Ajukan pemusnahan ({n})",
  "damage.toSupplierN": "Retur ke supplier ({n})",
  "damage.empty": "Tidak ada stok rusak di gudang ini.",
  "damage.qty": "Jumlah",
  "damage.locations": "Lokasi",
  "damage.value": "Nilai",
  "damage.restore": "Kembalikan ke sellable",
  "damage.dispose": "Ajukan pemusnahan",
  "damage.restoreTitle": "{code} kembali ke sellable",
  "damage.restoreHelp": "Sudah diperbaiki atau lolos QC ulang: unit bisa dijual lagi. Tidak ada rugi yang dicatat.",
  "damage.restoreHelpWms": "Sudah diperbaiki atau lolos QC ulang: unit masuk TERIMA sebagai sellable untuk di-putaway. Tidak ada rugi yang dicatat.",
  "damage.restoreNote": "Apa yang dilakukan (wajib)",
  "damage.restored": "Sudah kembali ke sellable.",
  "damage.restoredWms": "Sudah kembali ke sellable, menunggu putaway di TERIMA.",
  "damage.disposeHelp": "Unit keluar dari stok selamanya dan nilainya dengan HPP rata-rata menjadi rugi (Barang rusak). Tidak bisa dibatalkan.",
  "damage.serials": "IMEI / SN dari {n} unit, satu per baris",
  "damage.disposeValue": "Nilai dengan HPP rata-rata: {value}",
  "damage.reason": "Alasan",
  "damage.reasonPlaceholder": "mis. layar pecah, tidak bisa diperbaiki; dibuang bersama sampah gudang",
  "damage.photos": "Foto",
  "damage.photosHelp": "Minimal satu foto barang yang dimusnahkan, maksimal 10. Foto masuk ke berita acara.",
  "damage.disposed": "Sudah dimusnahkan dan dicatat sebagai Barang rusak.",
  "damage.historySearch": "SKU atau alasan",
  "damage.historyEmpty": "Belum ada yang dimusnahkan.",
  "damage.at": "Waktu",
  "damage.goods": "Barang",
  "damage.noPhoto": "Tanpa foto",
  "damage.addPhoto": "Tambah foto",
  "damage.ba.title": "Berita Acara Pemusnahan Barang",
  "damage.ba.intro": "Pada {date} telah dimusnahkan barang rusak berikut:",
  "damage.ba.total": "Total",
  "damage.ba.approved": "Disetujui oleh",
  "damage.ba.print": "Berita acara",
  "report.damaged": "Barang rusak (dimusnahkan)",
  "cost.damaged": "Termasuk {n} unit rusak ({value}) yang menunggu keputusan.",
  "cost.damagedLink": "Barang rusak",
  "inventory.reason.disposed": "Dimusnahkan (rusak)",
  "serial.kind.disposed": "Dimusnahkan (rusak)",
  "activity.stock.disposed": "Memusnahkan barang rusak",
  "activity.stock.restored": "Mengembalikan barang rusak ke sellable",
  "damage.held": "{n} ditahan",
  "damage.request": "Ajukan",
  "damage.requestTitle": "Ajukan pemusnahan barang rusak",
  "damage.requestHelp": "Unit ditahan (tidak bisa diretur ke supplier atau dikembalikan ke sellable) sampai keuangan menyetujui atau menolak. Foto diambil saat barang dimusnahkan.",
  "damage.requested": "Sudah diajukan; menunggu persetujuan keuangan.",
  "damage.executeTitle": "Musnahkan barang sekarang",
  "damage.execute": "Musnahkan sekarang",
  "damage.takeFrom": "Ambil dari: {locations}",
  "damage.photosHave": "Sudah ada {n} foto",
  "damage.approve": "Setujui",
  "damage.approved": "Disetujui; gudang bisa memusnahkan barang.",
  "damage.reject": "Tolak",
  "damage.rejectTitle": "Tolak pemusnahan ini?",
  "damage.rejectReason": "Alasan (wajib); unit kembali bebas",
  "damage.rejectedBy": "Ditolak oleh",
  "damage.waitFinance": "Menunggu keuangan",
  "damage.people": "Pelaku",
  "damage.status.all": "Semua",
  "damage.status.requested": "Menunggu persetujuan",
  "damage.status.approved": "Siap dimusnahkan",
  "damage.status.done": "Selesai",
  "damage.status.rejected": "Ditolak",
  "damage.ba.asked": "Diajukan oleh",
  "damage.ba.done": "Dimusnahkan oleh",
  "activity.stock.disposal_requested": "Mengajukan pemusnahan barang rusak",
  "activity.stock.disposal_approved": "Menyetujui pemusnahan barang rusak",
  "activity.stock.disposal_rejected": "Menolak pemusnahan barang rusak",
  "nav.aftersalesClaims": "Klaim",
  "claim.title": "Klaim",
  "claim.pageTitle": "Klaim",
  "claim.add": "Ajukan klaim",
  "claim.submit": "Ajukan",
  "claim.none": "Belum ada klaim. Ajukan klaim ke marketplace atau kurir bila barang kembali rusak, tidak lengkap, atau hilang.",
  "claim.update": "Ubah",
  "claim.against": "Diklaim ke",
  "claim.against.marketplace": "Marketplace",
  "claim.against.courier": "Kurir",
  "claim.carrier": "Kurir",
  "claim.amount": "Nilai klaim",
  "claim.reference": "No. tiket / klaim",
  "claim.note": "Catatan",
  "claim.paidAmount": "Cair",
  "claim.paidOnLabel": "Tanggal cair",
  "claim.paidOn": "{amount} cair {date}",
  "claim.final": "Klaim yang ditolak atau sudah cair tidak bisa diubah lagi.",
  "claim.status.submitted": "Diajukan",
  "claim.status.approved": "Disetujui",
  "claim.status.rejected": "Ditolak",
  "claim.status.paid": "Cair",
  "claim.filter.open": "Menunggu",
  "claim.filter.all": "Semua",
  "claim.search": "Kasus, order, tiket, atau kurir",
  "claim.openSummary": "{n} menunggu · {amount}",
  "claim.empty": "Tidak ada klaim.",
  "claim.at": "Diajukan",
  "claim.case": "Kasus",
  "damage.claimOpen": "Klaim berjalan",
  "damage.claimOpenWarn": "Sebagian barang ini berasal dari retur yang klaimnya masih berjalan. Marketplace atau kurir bisa meminta barang atau foto: musnahkan setelah klaim selesai.",
  "report.recovered": "Klaim cair",
  "activity.aftersales.claim_created": "Mengajukan klaim",
  "activity.aftersales.claim_updated": "Mengubah klaim",
  "wms.task.source.vendor_return": "Retur supplier",
  "vr.pickingNote": "Picking {number}: {done} dari {total} baris sudah di KIRIM. Retur bisa dikirim setelah picking selesai.",
  "vr.pickedNote": "Picking selesai: semua barang sudah di KIRIM ({number}). Siap dikirim.",
  "vr.openPicking": "Buka picking",
  "damage.tab.sources": "Sumber kerusakan",
  "damage.age": "Rusak sejak",
  "damage.days": "{n} hari",
  "damage.sourcesHelp": "Unit yang menjadi rusak di gudang ini dalam periode (30 hari terakhir bila tanggal tidak dipilih), menurut asalnya: retur pembeli per toko, penerimaan per supplier, handling per staf. Memindah barang rusak antar lokasi tidak dihitung.",
  "damage.sourcesEmpty": "Tidak ada barang yang menjadi rusak dalam periode ini.",
  "damage.source": "Sumber",
  "damage.sourceWho": "Toko / supplier / staf",
  "damage.source.return": "Retur pembeli",
  "damage.source.supplier": "Dari supplier",
  "damage.source.handling": "Handling",
  "damage.source.transfer": "Transfer",
  "damage.source.other": "Lainnya",
  "report.basis": "Penjualan marketplace diakui saat order Selesai (pembeli konfirmasi, masa retur lewat); order manual saat barang keluar. Retur setelah Selesai mengurangi penjualan di bulan returnya.",
  "report.inTransit": "Saat ini {n} order sudah dikirim tapi belum Selesai: barangnya ({value} dengan HPP) masih dalam pengiriman, belum terjual.",
  "books.stockInTransit": "Persediaan dalam pengiriman",
  "cost.inTransit": "Belum termasuk nilai di atas: {units} unit dari {n} order yang dikirim tapi belum Selesai ({value}), dalam pengiriman.",
  "error.task_started": "Sudah ada pekerjaan di tugas ini (barang diambil atau tote dipakai): serahkan ke orang lain, tidak bisa dibebaskan.",
  "error.tote_twice": "Tote ini sudah dipakai untuk order lain di tugas ini.",
  "error.totes_full": "Semua order di tugas ini sudah punya tote.",
  "error.totes_incomplete": "Scan tote untuk semua order di tugas ini dulu.",
  "error.task_of_return": "Tugas ini picking retur supplier: ubah atau batalkan returnya.",
  "error.damaged_held": "Sebagian barang rusak ini sedang ditahan (pemusnahan atau retur supplier yang berjalan).",
  "error.disposal_state": "Pemusnahan ini sudah tidak di langkah itu. Muat ulang halaman.",
  "error.photo_required": "Tambahkan minimal satu foto dulu.",
  "error.photo_invalid": "Foto harus berformat JPEG atau PNG.",
  "error.photos_full": "Maksimal 10 foto.",
  "error.photo_too_large": "Foto terlalu besar (maksimal 5 MB).",
  "error.claim_state": "Klaim yang ditolak atau sudah cair tidak bisa diubah.",
  "error.return_not_picked": "Selesaikan dulu picking retur ini (barang ke KIRIM).",
  "nav.warehouse.cancelled": "Barang batal",
  "cx.title": "Barang batal",
  "cx.help": "Barang dari order batal yang masih di gudang. Paket yang sudah dikemas untuk order batal: cari di area outbound. Masih ada: barangnya dikembalikan ke rak. Sudah dibawa kurir: kembali lewat retur (Purna jual, lewat dok retur dengan rekaman). Barang yang sudah dipick untuk order batal menunggu di tote, slot cart, PACKING atau KIRIM sampai dikembalikan.",
  "cx.parcels": "Paket yang perlu dicek ({n})",
  "cx.scanParcel": "Scan resi atau nomor order paket",
  "cx.noParcels": "Tidak ada paket order batal yang perlu dicek.",
  "cx.order": "Order",
  "cx.tracking": "Resi",
  "cx.shop": "Toko · kurir",
  "cx.units": "Barang untuk dikembalikan ke rak",
  "cx.cancelledAt": "Batal",
  "cx.inHouse": "Masih ada: kembalikan",
  "cx.withCourier": "Sudah dibawa kurir",
  "cx.checkTitle": "Paket order {order}",
  "cx.checkHelp": "Apakah paketnya masih di area outbound? Masih ada: bongkar, tugas mengembalikan barangnya ke rak. Sudah dibawa kurir: kembali lewat retur.",
  "cx.notFound": "Tidak ada paket order batal dengan {code}.",
  "cx.noUnits": "Tidak ada barang yang menunggu dikembalikan ke rak.",
  "cx.location": "Lokasi",
  "cx.qty": "Jumlah",
  "cx.exOrders": "Ex order",
  "cx.putBack": "Kembalikan ke rak",
  "cx.taskMade": "Tugas dibuat: kembalikan barang ke rak.",
  "cx.toReturn": "Retur dibuka: barang kembali lewat dok retur.",
  "cx.checked": "Sudah dicek.",
  "as.resolution.lost": "Hilang di kurir",
  "as.dock.damagedPlace": "Barang rusak ke (kosong: RUSAK)",
  "report.lost": "Hilang di kurir",
  "books.lost": "Hilang di kurir",
  "error.parcel_checked": "Paket ini sudah dicek.",
  "error.not_lost": "Hanya kasus yang masih menunggu barang (belum ada yang diterima) yang bisa ditutup sebagai hilang.",
  "error.location_kind": "Jenis lokasi itu tidak sesuai.",
  "error.ai_unavailable": "Penulisan dengan AI belum diaktifkan di Zerpid.",
  "error.ai_quota": "Kuota draf AI workspace ini untuk hari ini sudah habis. Coba lagi besok.",
  "error.ai_failed": "AI belum berhasil menulis draf kali ini. Coba lagi.",
  "nav.listings": "Listing toko",
  "nav.prices": "Harga",
  "listings.title": "Listing toko",
  "listings.subtitle": "Semua yang dijual di toko terhubung. Diunduh otomatis saat toko terhubung, dan dipetakan otomatis bila seller SKU sama dengan kode SKU.",
  "listings.product": "Produk Zerpid",
  "listings.openProduct": "Buka produk",
  "listings.makeProduct": "Jadikan produk",
  "listings.makeProductN": "Jadikan produk ({n})",
  "listings.makeProductTip": "Listing ini menjadi master produk. Bila semua variannya sudah varian produk lain (barang yang sama di toko lain), listing ditautkan ke produk itu.",
  "listings.productUnsupported": "Produk dari listing belum didukung untuk marketplace ini.",
  "listings.madeProducts": "{n} listing menjadi produk.",
  "listings.madeProductsFailed": "{n} gagal: {error}",
  "listings.createAll": "Buat SKU untuk semua",
  "listings.createAll.tip": "Buat SKU internal untuk semua listing yang belum dipetakan sesuai filter, dengan pratinjau dulu.",
  "listings.createAll.title": "Buat SKU untuk semua yang belum dipetakan",
  "listings.createAll.help": "Kode SKU memakai seller SKU. Listing dengan seller SKU yang sama dipetakan ke satu SKU. Yang ditandai tidak dilacak tidak ikut.",
  "listings.createAll.summary": "{fresh} SKU baru dibuat, {reused} memakai SKU yang sudah ada, {skipped} dilewati.",
  "listings.createAll.truncated": "Hanya 2.000 listing pertama yang diproses. Jalankan lagi setelah selesai untuk sisanya.",
  "listings.createAll.empty": "Tidak ada listing yang belum dipetakan untuk filter ini.",
  "listings.createAll.listings": "Listing",
  "listings.createAll.action": "Tindakan",
  "listings.createAll.new": "Buat SKU baru",
  "listings.createAll.reuse": "Pakai SKU yang ada",
  "listings.createAll.skip.invalid": "Dilewati: kode tidak valid",
  "listings.createAll.skip.archived": "Dilewati: SKU diarsipkan",
  "listings.createAll.ok": "Buat & petakan ({n})",
  "listings.createAll.done": "{n} listing dipetakan.",
  "listings.createAll.failed": "{n} gagal dipetakan, misalnya karena batas jumlah SKU paket.",
  "pricing.title": "Harga",
  "pricing.subtitle": "Harga dasar dan harga minimum per SKU, selisih per toko, dan harga di setiap toko.",
  "pricing.margins": "Margin harga",
  "pricing.promos": "Promo marketplace",
  "pricing.markups": "Selisih harga per toko",
  "pricing.markupsHelp": "Aturan Harga dasar di Ubah harga massal memakai harga dasar SKU ditambah selisih toko. Contoh: harga dasar Rp100.000 dengan Shopee +8% menjadi Rp108.000.",
  "pricing.markupEdit": "Selisih harga {store}",
  "pricing.markupDialogHelp": "Persen dari harga dasar, -50% sampai +100%. Harga di toko baru berubah saat Anda menerapkan aturan Harga dasar.",
  "pricing.markupSaved": "Selisih harga disimpan.",
  "pricing.problem.all": "Semua SKU",
  "pricing.problem.below_min": "Di bawah harga minimum",
  "pricing.problem.failed": "Gagal sinkron",
  "pricing.problem.no_base": "Tanpa harga dasar",
  "pricing.setBaseN": "Atur harga dasar ({n})",
  "pricing.setBaseOne": "Harga dasar & minimum {code}",
  "pricing.setBaseMany": "Harga dasar & minimum {n} SKU",
  "pricing.base": "Harga dasar",
  "pricing.min": "Harga minimum",
  "pricing.baseHelp": "Harga acuan sebelum selisih toko. Menyimpannya tidak mengubah harga di toko.",
  "pricing.minHelp": "Perubahan harga, satu per satu maupun massal, tidak boleh di bawah angka ini.",
  "pricing.from.value": "Isi angka",
  "pricing.from.store": "Dari harga toko",
  "pricing.from.clear": "Kosongkan",
  "pricing.from.keep": "Tidak diubah",
  "pricing.baseSaved": "Harga dasar & minimum disimpan.",
  "pricing.onStores": "Harga di toko",
  "pricing.notSold": "Belum dijual di toko mana pun",
  "pricing.empty": "Belum ada SKU.",
  "pricing.storePrice": "Harga {code} di {store}",
  "price.mode.base": "Harga dasar + selisih toko",
  "price.baseHelp": "Harga tiap toko = harga dasar SKU ditambah selisih tokonya (menu Harga), lalu dibulatkan. SKU tanpa harga dasar dilewati.",
  "price.problem.no_base_price": "Belum ada harga dasar, dilewati",
  "price.problem.below_floor": "Di bawah harga minimum, dilewati",
  "price.problem.below_break_even": "Di bawah harga impas",
  "price.belowFloor": "Harga di bawah harga minimum SKU ini.",
  "price.belowFloorIs": "Di bawah harga minimum {min}.",
  "field.below_floor": "Di bawah harga minimum",
  "activity.product.base_price_set": "Mengubah harga dasar/minimum",
  "activity.channel.price_markup_set": "Mengubah selisih harga toko",
  "activity.listing.linked": "Menautkan listing toko ke produk",
  "error.import_store_taken": "Produk ini sudah punya listing lain di toko yang sama.",
} as const;

export type MessageKey = keyof typeof id;
